/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as PrivateRouteRouteImport } from "./routes/_private/route";
import { Route as ProtectedRouteRouteImport } from "./routes/_protected/route";
import { Route as PublicAuthRouteRouteImport } from "./routes/_public/_auth/route";
import { Route as PublicDomain_transitionRouteImport } from "./routes/_public/domain_transition";
import { Route as PrivateCall_off_contract_itemsIssue_purchase_orderRouteImport } from "./routes/_private/call_off_contract_items/issue_purchase_order";
import { Route as PrivateCreate_purchase_order_by_call_off_contractsIndexRouteImport } from "./routes/_private/create_purchase_order_by_call_off_contracts/index";
import { Route as PrivateCreate_purchase_order_by_spotsIndexRouteImport } from "./routes/_private/create_purchase_order_by_spots/index";
import { Route as PrivateDelivery_date_change_requestsIndexRouteImport } from "./routes/_private/delivery_date_change_requests/index";
import { Route as PrivateDelivery_date_change_requestsNewRouteImport } from "./routes/_private/delivery_date_change_requests/new";
import { Route as PrivateDelivery_schedulesIndexRouteImport } from "./routes/_private/delivery_schedules/index";
import { Route as PrivateDelivery_schedulesNewRouteImport } from "./routes/_private/delivery_schedules/new";
import { Route as PrivateDevelopersIndexRouteImport } from "./routes/_private/developers/index";
import { Route as PrivateMm_request_assignment_rulesIndexRouteImport } from "./routes/_private/mm_request_assignment_rules/index";
import { Route as PrivateMm_request_assignment_rulesNewRouteImport } from "./routes/_private/mm_request_assignment_rules/new";
import { Route as PrivateMm_request_weekly_goalsIndexRouteImport } from "./routes/_private/mm_request_weekly_goals/index";
import { Route as PrivateNotificationsIndexRouteImport } from "./routes/_private/notifications/index";
import { Route as PrivateRequest_anticipation_evaluation_quotationsIndexRouteImport } from "./routes/_private/request_anticipation_evaluation_quotations/index";
import { Route as PrivateUsersEditRouteImport } from "./routes/_private/users/edit";
import { Route as PrivateVsupplierregistrationVendorRouteRouteImport } from "./routes/_private/vsupplierregistration/vendor/route";
import { Route as PrivateVsupplierregistrationVendorsRouteRouteImport } from "./routes/_private/vsupplierregistration/vendors/route";
import { Route as PrivateErrorsErrorIndexRouteImport } from "./routes/_private/_errors/error/index";
import { Route as PrivateErrorsForbiddenIndexRouteImport } from "./routes/_private/_errors/forbidden/index";
import { Route as PrivateErrorsNot_foundIndexRouteImport } from "./routes/_private/_errors/not_found/index";
import { Route as PrivateCall_off_contract_itemsCallOffItemIdService_linesRouteImport } from "./routes/_private/call_off_contract_items/$callOffItemId/service_lines";
import { Route as PrivateCreate_purchase_order_by_call_off_contractsCreatePurchaseOrderByCallOffContractIdIndexRouteImport } from "./routes/_private/create_purchase_order_by_call_off_contracts/$createPurchaseOrderByCallOffContractId/index";
import { Route as PrivateCreate_purchase_order_by_spotsCreatePurchaseOrderBySpotIdIndexRouteImport } from "./routes/_private/create_purchase_order_by_spots/$createPurchaseOrderBySpotId/index";
import { Route as PrivateCreate_purchase_order_by_spotsExecutionsIndexRouteImport } from "./routes/_private/create_purchase_order_by_spots/executions/index";
import { Route as PrivateDelivery_date_change_requestsDeliveryDateChangeRequestIdIndexRouteImport } from "./routes/_private/delivery_date_change_requests/$deliveryDateChangeRequestId/index";
import { Route as PrivateDelivery_schedulesDeliveryScheduleIdIndexRouteImport } from "./routes/_private/delivery_schedules/$deliveryScheduleId/index";
import { Route as PrivateInvoice_approvalsInvoiceApprovalIdIndexRouteImport } from "./routes/_private/invoice_approvals/$invoiceApprovalId/index";
import { Route as PrivateMm_request_assignment_rulesAssignmentRuleIdIndexRouteImport } from "./routes/_private/mm_request_assignment_rules/$assignmentRuleId/index";
import { Route as PrivateMm_request_assignment_rulesAssignmentRuleIdEditRouteImport } from "./routes/_private/mm_request_assignment_rules/$assignmentRuleId/edit";
import { Route as PrivateMm_request_weekly_goalsUserIdIndexRouteImport } from "./routes/_private/mm_request_weekly_goals/$userId/index";
import { Route as PrivatePurchase_ordersMaterialsIndexRouteImport } from "./routes/_private/purchase_orders/materials/index";
import { Route as PrivatePurchase_ordersService_quotationsIndexRouteImport } from "./routes/_private/purchase_orders/service_quotations/index";
import { Route as PrivateRequest_anticipation_evaluation_quotationsRequestAnticipationEvaluationQuotationIdIndexRouteImport } from "./routes/_private/request_anticipation_evaluation_quotations/$requestAnticipationEvaluationQuotationId/index";
import { Route as PrivateRequest_anticipation_service_quotationsRequestAnticipationServiceQuotationIdIndexRouteImport } from "./routes/_private/request_anticipation_service_quotations/$requestAnticipationServiceQuotationId/index";
import { Route as PrivateVbuyerBill_of_materials_mgmt_requestsNewRouteImport } from "./routes/_private/vbuyer/bill_of_materials_mgmt_requests/new";
import { Route as PrivateVbuyerChange_material_requestsNewRouteImport } from "./routes/_private/vbuyer/change_material_requests/new";
import { Route as PrivateVbuyerCreate_purchase_order_by_quotationsIndexRouteImport } from "./routes/_private/vbuyer/create_purchase_order_by_quotations/index";
import { Route as PrivateVbuyerCreate_purchase_order_by_service_quotationsIndexRouteImport } from "./routes/_private/vbuyer/create_purchase_order_by_service_quotations/index";
import { Route as PrivateVbuyerDuimp_requestsNewRouteImport } from "./routes/_private/vbuyer/duimp_requests/new";
import { Route as PrivateVbuyerGr_general_issue_raisersIndexRouteImport } from "./routes/_private/vbuyer/gr_general_issue_raisers/index";
import { Route as PrivateVbuyerGuidesIndexRouteImport } from "./routes/_private/vbuyer/guides/index";
import { Route as PrivateVbuyerHelpsIndexRouteImport } from "./routes/_private/vbuyer/helps/index";
import { Route as PrivateVbuyerHelpsInvoice_and_payment_proceduresRouteImport } from "./routes/_private/vbuyer/helps/invoice_and_payment_procedures";
import { Route as PrivateVbuyerIssues_of_rfq_requestsNewRouteImport } from "./routes/_private/vbuyer/issues_of_rfq_requests/new";
import { Route as PrivateVbuyerMaterial_request_formsIndexRouteImport } from "./routes/_private/vbuyer/material_request_forms/index";
import { Route as PrivateVbuyerMm_requestsIndexRouteImport } from "./routes/_private/vbuyer/mm_requests/index";
import { Route as PrivateVbuyerMm_requestsCreate_new_requestsRouteImport } from "./routes/_private/vbuyer/mm_requests/create_new_requests";
import { Route as PrivateVbuyerOther_masterdata_services_requestsNewRouteImport } from "./routes/_private/vbuyer/other_masterdata_services_requests/new";
import { Route as PrivateVbuyerQuotation_batchesIndexRouteImport } from "./routes/_private/vbuyer/quotation_batches/index";
import { Route as PrivateVbuyerQuotation_batchesQuotationBatchIdRouteRouteImport } from "./routes/_private/vbuyer/quotation_batches/$quotationBatchId/route";
import { Route as PrivateVbuyerQuotation_batchesNewRouteImport } from "./routes/_private/vbuyer/quotation_batches/new";
import { Route as PrivateVbuyerQuotationsIndexRouteImport } from "./routes/_private/vbuyer/quotations/index";
import { Route as PrivateVbuyerQuotationsQuotationIdRouteRouteImport } from "./routes/_private/vbuyer/quotations/$quotationId/route";
import { Route as PrivateVbuyerQuotationsApproval_statsRouteImport } from "./routes/_private/vbuyer/quotations/approval_stats";
import { Route as PrivateVbuyerQuotationsIssue_purchase_orderRouteImport } from "./routes/_private/vbuyer/quotations/issue_purchase_order";
import { Route as PrivateVbuyerRnm_requestsNewRouteImport } from "./routes/_private/vbuyer/rnm_requests/new";
import { Route as PrivateVbuyerRnm_requestsNew_usRouteImport } from "./routes/_private/vbuyer/rnm_requests/new_us";
import { Route as PrivateVbuyerService_negotiationsIndexRouteImport } from "./routes/_private/vbuyer/service_negotiations/index";
import { Route as PrivateVbuyerService_quotationsIndexRouteImport } from "./routes/_private/vbuyer/service_quotations/index";
import { Route as PrivateVbuyerService_quotationsIssue_service_purchase_orderRouteImport } from "./routes/_private/vbuyer/service_quotations/issue_service_purchase_order";
import { Route as PrivateVbuyerValoration_requestsNewRouteImport } from "./routes/_private/vbuyer/valoration_requests/new";
import { Route as PrivateVsupplierregistrationExclusive_brandsIndexRouteImport } from "./routes/_private/vsupplierregistration/exclusive_brands/index";
import { Route as PrivateVsupplierregistrationTermsIndexRouteImport } from "./routes/_private/vsupplierregistration/terms/index";
import { Route as PrivateVsupplierregistrationTermsNewRouteImport } from "./routes/_private/vsupplierregistration/terms/new";
import { Route as PrivateVsupplierregistrationTerms_exceptionsIndexRouteImport } from "./routes/_private/vsupplierregistration/terms_exceptions/index";
import { Route as PrivateVsupplierregistrationTerms_exceptionsNewRouteImport } from "./routes/_private/vsupplierregistration/terms_exceptions/new";
import { Route as PrivateVsupplierregistrationVendorIndexRouteImport } from "./routes/_private/vsupplierregistration/vendor/index";
import { Route as PrivateVsupplierregistrationVendorCategoriesRouteImport } from "./routes/_private/vsupplierregistration/vendor/categories";
import { Route as PrivateVsupplierregistrationVendorDocumentsRouteImport } from "./routes/_private/vsupplierregistration/vendor/documents";
import { Route as PrivateVsupplierregistrationVendorEditRouteImport } from "./routes/_private/vsupplierregistration/vendor/edit";
import { Route as PrivateVsupplierregistrationVendorTermsRouteImport } from "./routes/_private/vsupplierregistration/vendor/terms";
import { Route as PrivateVsupplierregistrationVendorTerms_exceptionsRouteImport } from "./routes/_private/vsupplierregistration/vendor/terms_exceptions";
import { Route as PrivateVsupplierregistrationVendorUsersRouteImport } from "./routes/_private/vsupplierregistration/vendor/users";
import { Route as PrivateVsupplierregistrationVendorsIndexRouteImport } from "./routes/_private/vsupplierregistration/vendors/index";
import { Route as PrivateVsupplierregistrationVendorsVendorIdRouteRouteImport } from "./routes/_private/vsupplierregistration/vendors/$vendorId/route";
import { Route as PrivateVsupplierregistrationVendorsNew_by_equinorRouteImport } from "./routes/_private/vsupplierregistration/vendors/new_by_equinor";
import { Route as ProtectedOnboardingVendorTermsRouteImport } from "./routes/_protected/onboarding/vendor/terms";
import { Route as PublicAuthUsersSign_inRouteImport } from "./routes/_public/_auth/users/sign_in";
import { Route as PublicAuthUsersSign_upRouteImport } from "./routes/_public/_auth/users/sign_up";
import { Route as PrivatePurchase_ordersMaterialsPurchaseOrderIdIndexRouteImport } from "./routes/_private/purchase_orders/materials/$purchaseOrderId/index";
import { Route as PrivatePurchase_ordersService_quotationsPurchaseOrderIdIndexRouteImport } from "./routes/_private/purchase_orders/service_quotations/$purchaseOrderId/index";
import { Route as PrivateRedirectRailsHomeIndexRouteImport } from "./routes/_private/redirect/rails/home/index";
import { Route as PrivateVbuyerBill_of_materials_mgmt_requestsBillOfMaterialsMgmtRequestIdIndexRouteImport } from "./routes/_private/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId/index";
import { Route as PrivateVbuyerBill_of_materials_mgmt_requestsBillOfMaterialsMgmtRequestIdEditRouteImport } from "./routes/_private/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId/edit";
import { Route as PrivateVbuyerChange_material_requestsChangeMaterialRequestIdIndexRouteImport } from "./routes/_private/vbuyer/change_material_requests/$changeMaterialRequestId/index";
import { Route as PrivateVbuyerChange_material_requestsChangeMaterialRequestIdEditRouteImport } from "./routes/_private/vbuyer/change_material_requests/$changeMaterialRequestId/edit";
import { Route as PrivateVbuyerCreate_purchase_order_by_quotationsCreatePurchaseOrderByQuotationIdIndexRouteImport } from "./routes/_private/vbuyer/create_purchase_order_by_quotations/$createPurchaseOrderByQuotationId/index";
import { Route as PrivateVbuyerCreate_purchase_order_by_service_quotationsCreatePurchaseOrderByServiceQuotationIdIndexRouteImport } from "./routes/_private/vbuyer/create_purchase_order_by_service_quotations/$createPurchaseOrderByServiceQuotationId/index";
import { Route as PrivateVbuyerDuimp_requestsDuimpRequestIdIndexRouteImport } from "./routes/_private/vbuyer/duimp_requests/$duimpRequestId/index";
import { Route as PrivateVbuyerDuimp_requestsDuimpRequestIdEditRouteImport } from "./routes/_private/vbuyer/duimp_requests/$duimpRequestId/edit";
import { Route as PrivateVbuyerGr_general_issue_raisersGrGeneralIssueRaiserIdIndexRouteImport } from "./routes/_private/vbuyer/gr_general_issue_raisers/$grGeneralIssueRaiserId/index";
import { Route as PrivateVbuyerIssues_of_rfq_requestsIssuesOfRfqRequestIdIndexRouteImport } from "./routes/_private/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId/index";
import { Route as PrivateVbuyerIssues_of_rfq_requestsIssuesOfRfqRequestIdEditRouteImport } from "./routes/_private/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId/edit";
import { Route as PrivateVbuyerMaterial_request_formsMaterialRequestFormIdIndexRouteImport } from "./routes/_private/vbuyer/material_request_forms/$materialRequestFormId/index";
import { Route as PrivateVbuyerOther_masterdata_services_requestsOtherMasterdataServicesRequestIdIndexRouteImport } from "./routes/_private/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId/index";
import { Route as PrivateVbuyerOther_masterdata_services_requestsOtherMasterdataServicesRequestIdEditRouteImport } from "./routes/_private/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId/edit";
import { Route as PrivateVbuyerProposalsProposalIdIndexRouteImport } from "./routes/_private/vbuyer/proposals/$proposalId/index";
import { Route as PrivateVbuyerQuotation_batchesQuotationBatchIdIndexRouteImport } from "./routes/_private/vbuyer/quotation_batches/$quotationBatchId/index";
import { Route as PrivateVbuyerQuotation_batchesQuotationBatchIdEditRouteImport } from "./routes/_private/vbuyer/quotation_batches/$quotationBatchId/edit";
import { Route as PrivateVbuyerQuotationsQuotationIdIndexRouteImport } from "./routes/_private/vbuyer/quotations/$quotationId/index";
import { Route as PrivateVbuyerRnm_requestsRnmRequestIdIndexRouteImport } from "./routes/_private/vbuyer/rnm_requests/$rnmRequestId/index";
import { Route as PrivateVbuyerRsps3_requestsRsps3RequestIdIndexRouteImport } from "./routes/_private/vbuyer/rsps3_requests/$rsps3RequestId/index";
import { Route as PrivateVbuyerRsps3_requestsRsps3RequestIdEditRouteImport } from "./routes/_private/vbuyer/rsps3_requests/$rsps3RequestId/edit";
import { Route as PrivateVbuyerService_negotiationsServiceNegotiationIdIndexRouteImport } from "./routes/_private/vbuyer/service_negotiations/$serviceNegotiationId/index";
import { Route as PrivateVbuyerService_quotation_approvalsServiceQuotationApprovalIdIndexRouteImport } from "./routes/_private/vbuyer/service_quotation_approvals/$serviceQuotationApprovalId/index";
import { Route as PrivateVbuyerService_quotationsServiceQuotationIdIndexRouteImport } from "./routes/_private/vbuyer/service_quotations/$serviceQuotationId/index";
import { Route as PrivateVbuyerValoration_requestsValorationRequestIdIndexRouteImport } from "./routes/_private/vbuyer/valoration_requests/$valorationRequestId/index";
import { Route as PrivateVbuyerValoration_requestsValorationRequestIdEditRouteImport } from "./routes/_private/vbuyer/valoration_requests/$valorationRequestId/edit";
import { Route as PrivateVsupplierregistrationExclusive_brandsIdIndexRouteImport } from "./routes/_private/vsupplierregistration/exclusive_brands/$id/index";
import { Route as PrivateVsupplierregistrationTermsTermIdEditRouteImport } from "./routes/_private/vsupplierregistration/terms/$termId/edit";
import { Route as PrivateVsupplierregistrationTerms_exceptionsTermExceptionIdIndexRouteImport } from "./routes/_private/vsupplierregistration/terms_exceptions/$termExceptionId/index";
import { Route as PrivateVsupplierregistrationTerms_exceptionsTermExceptionIdEditRouteImport } from "./routes/_private/vsupplierregistration/terms_exceptions/$termExceptionId/edit";
import { Route as PrivateVsupplierregistrationVendorsVendorIdIndexRouteImport } from "./routes/_private/vsupplierregistration/vendors/$vendorId/index";
import { Route as PrivateVsupplierregistrationVendorsVendorIdCategoriesRouteImport } from "./routes/_private/vsupplierregistration/vendors/$vendorId/categories";
import { Route as PrivateVsupplierregistrationVendorsVendorIdDocumentsRouteImport } from "./routes/_private/vsupplierregistration/vendors/$vendorId/documents";
import { Route as PrivateVsupplierregistrationVendorsVendorIdEditRouteImport } from "./routes/_private/vsupplierregistration/vendors/$vendorId/edit";
import { Route as PrivateVsupplierregistrationVendorsVendorIdTermsRouteImport } from "./routes/_private/vsupplierregistration/vendors/$vendorId/terms";
import { Route as PrivateVsupplierregistrationVendorsVendorIdTerms_exceptionsRouteImport } from "./routes/_private/vsupplierregistration/vendors/$vendorId/terms_exceptions";
import { Route as PrivateVsupplierregistrationVendorsVendorIdUsersRouteImport } from "./routes/_private/vsupplierregistration/vendors/$vendorId/users";
import { Route as PublicAuthUsersConfirmationNewRouteImport } from "./routes/_public/_auth/users/confirmation/new";
import { Route as PublicAuthUsersPasswordNewRouteImport } from "./routes/_public/_auth/users/password/new";
import { Route as PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsNewRouteImport } from "./routes/_private/vbuyer/service_negotiations/$serviceNegotiationId/proposals/new";
import { Route as PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsProposalIdIndexRouteImport } from "./routes/_private/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId/index";
import { Route as PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsProposalIdEditRouteImport } from "./routes/_private/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId/edit";

const PrivateRouteRoute = PrivateRouteRouteImport.update({
  id: "/_private",
  getParentRoute: () => rootRouteImport,
} as any);
const ProtectedRouteRoute = ProtectedRouteRouteImport.update({
  id: "/_protected",
  getParentRoute: () => rootRouteImport,
} as any);
const PublicAuthRouteRoute = PublicAuthRouteRouteImport.update({
  id: "/_public/_auth",
  getParentRoute: () => rootRouteImport,
} as any);
const PublicDomain_transitionRoute = PublicDomain_transitionRouteImport.update({
  id: "/_public/domain_transition",
  path: "/domain_transition",
  getParentRoute: () => rootRouteImport,
} as any);
const PrivateCall_off_contract_itemsIssue_purchase_orderRoute =
  PrivateCall_off_contract_itemsIssue_purchase_orderRouteImport.update({
    id: "/call_off_contract_items/issue_purchase_order",
    path: "/call_off_contract_items/issue_purchase_order",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateCreate_purchase_order_by_call_off_contractsIndexRoute =
  PrivateCreate_purchase_order_by_call_off_contractsIndexRouteImport.update({
    id: "/create_purchase_order_by_call_off_contracts/",
    path: "/create_purchase_order_by_call_off_contracts/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateCreate_purchase_order_by_spotsIndexRoute =
  PrivateCreate_purchase_order_by_spotsIndexRouteImport.update({
    id: "/create_purchase_order_by_spots/",
    path: "/create_purchase_order_by_spots/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateDelivery_date_change_requestsIndexRoute =
  PrivateDelivery_date_change_requestsIndexRouteImport.update({
    id: "/delivery_date_change_requests/",
    path: "/delivery_date_change_requests/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateDelivery_date_change_requestsNewRoute =
  PrivateDelivery_date_change_requestsNewRouteImport.update({
    id: "/delivery_date_change_requests/new",
    path: "/delivery_date_change_requests/new",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateDelivery_schedulesIndexRoute =
  PrivateDelivery_schedulesIndexRouteImport.update({
    id: "/delivery_schedules/",
    path: "/delivery_schedules/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateDelivery_schedulesNewRoute =
  PrivateDelivery_schedulesNewRouteImport.update({
    id: "/delivery_schedules/new",
    path: "/delivery_schedules/new",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateDevelopersIndexRoute = PrivateDevelopersIndexRouteImport.update({
  id: "/developers/",
  path: "/developers/",
  getParentRoute: () => PrivateRouteRoute,
} as any);
const PrivateMm_request_assignment_rulesIndexRoute =
  PrivateMm_request_assignment_rulesIndexRouteImport.update({
    id: "/mm_request_assignment_rules/",
    path: "/mm_request_assignment_rules/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateMm_request_assignment_rulesNewRoute =
  PrivateMm_request_assignment_rulesNewRouteImport.update({
    id: "/mm_request_assignment_rules/new",
    path: "/mm_request_assignment_rules/new",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateMm_request_weekly_goalsIndexRoute =
  PrivateMm_request_weekly_goalsIndexRouteImport.update({
    id: "/mm_request_weekly_goals/",
    path: "/mm_request_weekly_goals/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateNotificationsIndexRoute =
  PrivateNotificationsIndexRouteImport.update({
    id: "/notifications/",
    path: "/notifications/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateRequest_anticipation_evaluation_quotationsIndexRoute =
  PrivateRequest_anticipation_evaluation_quotationsIndexRouteImport.update({
    id: "/request_anticipation_evaluation_quotations/",
    path: "/request_anticipation_evaluation_quotations/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateUsersEditRoute = PrivateUsersEditRouteImport.update({
  id: "/users/edit",
  path: "/users/edit",
  getParentRoute: () => PrivateRouteRoute,
} as any);
const PrivateVsupplierregistrationVendorRouteRoute =
  PrivateVsupplierregistrationVendorRouteRouteImport.update({
    id: "/vsupplierregistration/vendor",
    path: "/vsupplierregistration/vendor",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVsupplierregistrationVendorsRouteRoute =
  PrivateVsupplierregistrationVendorsRouteRouteImport.update({
    id: "/vsupplierregistration/vendors",
    path: "/vsupplierregistration/vendors",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateErrorsErrorIndexRoute = PrivateErrorsErrorIndexRouteImport.update({
  id: "/_errors/error/",
  path: "/error/",
  getParentRoute: () => PrivateRouteRoute,
} as any);
const PrivateErrorsForbiddenIndexRoute =
  PrivateErrorsForbiddenIndexRouteImport.update({
    id: "/_errors/forbidden/",
    path: "/forbidden/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateErrorsNot_foundIndexRoute =
  PrivateErrorsNot_foundIndexRouteImport.update({
    id: "/_errors/not_found/",
    path: "/not_found/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateCall_off_contract_itemsCallOffItemIdService_linesRoute =
  PrivateCall_off_contract_itemsCallOffItemIdService_linesRouteImport.update({
    id: "/call_off_contract_items/$callOffItemId/service_lines",
    path: "/call_off_contract_items/$callOffItemId/service_lines",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateCreate_purchase_order_by_call_off_contractsCreatePurchaseOrderByCallOffContractIdIndexRoute =
  PrivateCreate_purchase_order_by_call_off_contractsCreatePurchaseOrderByCallOffContractIdIndexRouteImport.update(
    {
      id: "/create_purchase_order_by_call_off_contracts/$createPurchaseOrderByCallOffContractId/",
      path: "/create_purchase_order_by_call_off_contracts/$createPurchaseOrderByCallOffContractId/",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateCreate_purchase_order_by_spotsCreatePurchaseOrderBySpotIdIndexRoute =
  PrivateCreate_purchase_order_by_spotsCreatePurchaseOrderBySpotIdIndexRouteImport.update(
    {
      id: "/create_purchase_order_by_spots/$createPurchaseOrderBySpotId/",
      path: "/create_purchase_order_by_spots/$createPurchaseOrderBySpotId/",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateCreate_purchase_order_by_spotsExecutionsIndexRoute =
  PrivateCreate_purchase_order_by_spotsExecutionsIndexRouteImport.update({
    id: "/create_purchase_order_by_spots/executions/",
    path: "/create_purchase_order_by_spots/executions/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateDelivery_date_change_requestsDeliveryDateChangeRequestIdIndexRoute =
  PrivateDelivery_date_change_requestsDeliveryDateChangeRequestIdIndexRouteImport.update(
    {
      id: "/delivery_date_change_requests/$deliveryDateChangeRequestId/",
      path: "/delivery_date_change_requests/$deliveryDateChangeRequestId/",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateDelivery_schedulesDeliveryScheduleIdIndexRoute =
  PrivateDelivery_schedulesDeliveryScheduleIdIndexRouteImport.update({
    id: "/delivery_schedules/$deliveryScheduleId/",
    path: "/delivery_schedules/$deliveryScheduleId/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateInvoice_approvalsInvoiceApprovalIdIndexRoute =
  PrivateInvoice_approvalsInvoiceApprovalIdIndexRouteImport.update({
    id: "/invoice_approvals/$invoiceApprovalId/",
    path: "/invoice_approvals/$invoiceApprovalId/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateMm_request_assignment_rulesAssignmentRuleIdIndexRoute =
  PrivateMm_request_assignment_rulesAssignmentRuleIdIndexRouteImport.update({
    id: "/mm_request_assignment_rules/$assignmentRuleId/",
    path: "/mm_request_assignment_rules/$assignmentRuleId/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateMm_request_assignment_rulesAssignmentRuleIdEditRoute =
  PrivateMm_request_assignment_rulesAssignmentRuleIdEditRouteImport.update({
    id: "/mm_request_assignment_rules/$assignmentRuleId/edit",
    path: "/mm_request_assignment_rules/$assignmentRuleId/edit",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateMm_request_weekly_goalsUserIdIndexRoute =
  PrivateMm_request_weekly_goalsUserIdIndexRouteImport.update({
    id: "/mm_request_weekly_goals/$userId/",
    path: "/mm_request_weekly_goals/$userId/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivatePurchase_ordersMaterialsIndexRoute =
  PrivatePurchase_ordersMaterialsIndexRouteImport.update({
    id: "/purchase_orders/materials/",
    path: "/purchase_orders/materials/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivatePurchase_ordersService_quotationsIndexRoute =
  PrivatePurchase_ordersService_quotationsIndexRouteImport.update({
    id: "/purchase_orders/service_quotations/",
    path: "/purchase_orders/service_quotations/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateRequest_anticipation_evaluation_quotationsRequestAnticipationEvaluationQuotationIdIndexRoute =
  PrivateRequest_anticipation_evaluation_quotationsRequestAnticipationEvaluationQuotationIdIndexRouteImport.update(
    {
      id: "/request_anticipation_evaluation_quotations/$requestAnticipationEvaluationQuotationId/",
      path: "/request_anticipation_evaluation_quotations/$requestAnticipationEvaluationQuotationId/",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateRequest_anticipation_service_quotationsRequestAnticipationServiceQuotationIdIndexRoute =
  PrivateRequest_anticipation_service_quotationsRequestAnticipationServiceQuotationIdIndexRouteImport.update(
    {
      id: "/request_anticipation_service_quotations/$requestAnticipationServiceQuotationId/",
      path: "/request_anticipation_service_quotations/$requestAnticipationServiceQuotationId/",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateVbuyerBill_of_materials_mgmt_requestsNewRoute =
  PrivateVbuyerBill_of_materials_mgmt_requestsNewRouteImport.update({
    id: "/vbuyer/bill_of_materials_mgmt_requests/new",
    path: "/vbuyer/bill_of_materials_mgmt_requests/new",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerChange_material_requestsNewRoute =
  PrivateVbuyerChange_material_requestsNewRouteImport.update({
    id: "/vbuyer/change_material_requests/new",
    path: "/vbuyer/change_material_requests/new",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerCreate_purchase_order_by_quotationsIndexRoute =
  PrivateVbuyerCreate_purchase_order_by_quotationsIndexRouteImport.update({
    id: "/vbuyer/create_purchase_order_by_quotations/",
    path: "/vbuyer/create_purchase_order_by_quotations/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerCreate_purchase_order_by_service_quotationsIndexRoute =
  PrivateVbuyerCreate_purchase_order_by_service_quotationsIndexRouteImport.update(
    {
      id: "/vbuyer/create_purchase_order_by_service_quotations/",
      path: "/vbuyer/create_purchase_order_by_service_quotations/",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateVbuyerDuimp_requestsNewRoute =
  PrivateVbuyerDuimp_requestsNewRouteImport.update({
    id: "/vbuyer/duimp_requests/new",
    path: "/vbuyer/duimp_requests/new",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerGr_general_issue_raisersIndexRoute =
  PrivateVbuyerGr_general_issue_raisersIndexRouteImport.update({
    id: "/vbuyer/gr_general_issue_raisers/",
    path: "/vbuyer/gr_general_issue_raisers/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerGuidesIndexRoute =
  PrivateVbuyerGuidesIndexRouteImport.update({
    id: "/vbuyer/guides/",
    path: "/vbuyer/guides/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerHelpsIndexRoute = PrivateVbuyerHelpsIndexRouteImport.update({
  id: "/vbuyer/helps/",
  path: "/vbuyer/helps/",
  getParentRoute: () => PrivateRouteRoute,
} as any);
const PrivateVbuyerHelpsInvoice_and_payment_proceduresRoute =
  PrivateVbuyerHelpsInvoice_and_payment_proceduresRouteImport.update({
    id: "/vbuyer/helps/invoice_and_payment_procedures",
    path: "/vbuyer/helps/invoice_and_payment_procedures",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerIssues_of_rfq_requestsNewRoute =
  PrivateVbuyerIssues_of_rfq_requestsNewRouteImport.update({
    id: "/vbuyer/issues_of_rfq_requests/new",
    path: "/vbuyer/issues_of_rfq_requests/new",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerMaterial_request_formsIndexRoute =
  PrivateVbuyerMaterial_request_formsIndexRouteImport.update({
    id: "/vbuyer/material_request_forms/",
    path: "/vbuyer/material_request_forms/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerMm_requestsIndexRoute =
  PrivateVbuyerMm_requestsIndexRouteImport.update({
    id: "/vbuyer/mm_requests/",
    path: "/vbuyer/mm_requests/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerMm_requestsCreate_new_requestsRoute =
  PrivateVbuyerMm_requestsCreate_new_requestsRouteImport.update({
    id: "/vbuyer/mm_requests/create_new_requests",
    path: "/vbuyer/mm_requests/create_new_requests",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerOther_masterdata_services_requestsNewRoute =
  PrivateVbuyerOther_masterdata_services_requestsNewRouteImport.update({
    id: "/vbuyer/other_masterdata_services_requests/new",
    path: "/vbuyer/other_masterdata_services_requests/new",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerQuotation_batchesIndexRoute =
  PrivateVbuyerQuotation_batchesIndexRouteImport.update({
    id: "/vbuyer/quotation_batches/",
    path: "/vbuyer/quotation_batches/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerQuotation_batchesQuotationBatchIdRouteRoute =
  PrivateVbuyerQuotation_batchesQuotationBatchIdRouteRouteImport.update({
    id: "/vbuyer/quotation_batches/$quotationBatchId",
    path: "/vbuyer/quotation_batches/$quotationBatchId",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerQuotation_batchesNewRoute =
  PrivateVbuyerQuotation_batchesNewRouteImport.update({
    id: "/vbuyer/quotation_batches/new",
    path: "/vbuyer/quotation_batches/new",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerQuotationsIndexRoute =
  PrivateVbuyerQuotationsIndexRouteImport.update({
    id: "/vbuyer/quotations/",
    path: "/vbuyer/quotations/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerQuotationsQuotationIdRouteRoute =
  PrivateVbuyerQuotationsQuotationIdRouteRouteImport.update({
    id: "/vbuyer/quotations/$quotationId",
    path: "/vbuyer/quotations/$quotationId",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerQuotationsApproval_statsRoute =
  PrivateVbuyerQuotationsApproval_statsRouteImport.update({
    id: "/vbuyer/quotations/approval_stats",
    path: "/vbuyer/quotations/approval_stats",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerQuotationsIssue_purchase_orderRoute =
  PrivateVbuyerQuotationsIssue_purchase_orderRouteImport.update({
    id: "/vbuyer/quotations/issue_purchase_order",
    path: "/vbuyer/quotations/issue_purchase_order",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerRnm_requestsNewRoute =
  PrivateVbuyerRnm_requestsNewRouteImport.update({
    id: "/vbuyer/rnm_requests/new",
    path: "/vbuyer/rnm_requests/new",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerRnm_requestsNew_usRoute =
  PrivateVbuyerRnm_requestsNew_usRouteImport.update({
    id: "/vbuyer/rnm_requests/new_us",
    path: "/vbuyer/rnm_requests/new_us",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerService_negotiationsIndexRoute =
  PrivateVbuyerService_negotiationsIndexRouteImport.update({
    id: "/vbuyer/service_negotiations/",
    path: "/vbuyer/service_negotiations/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerService_quotationsIndexRoute =
  PrivateVbuyerService_quotationsIndexRouteImport.update({
    id: "/vbuyer/service_quotations/",
    path: "/vbuyer/service_quotations/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerService_quotationsIssue_service_purchase_orderRoute =
  PrivateVbuyerService_quotationsIssue_service_purchase_orderRouteImport.update(
    {
      id: "/vbuyer/service_quotations/issue_service_purchase_order",
      path: "/vbuyer/service_quotations/issue_service_purchase_order",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateVbuyerValoration_requestsNewRoute =
  PrivateVbuyerValoration_requestsNewRouteImport.update({
    id: "/vbuyer/valoration_requests/new",
    path: "/vbuyer/valoration_requests/new",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVsupplierregistrationExclusive_brandsIndexRoute =
  PrivateVsupplierregistrationExclusive_brandsIndexRouteImport.update({
    id: "/vsupplierregistration/exclusive_brands/",
    path: "/vsupplierregistration/exclusive_brands/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVsupplierregistrationTermsIndexRoute =
  PrivateVsupplierregistrationTermsIndexRouteImport.update({
    id: "/vsupplierregistration/terms/",
    path: "/vsupplierregistration/terms/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVsupplierregistrationTermsNewRoute =
  PrivateVsupplierregistrationTermsNewRouteImport.update({
    id: "/vsupplierregistration/terms/new",
    path: "/vsupplierregistration/terms/new",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVsupplierregistrationTerms_exceptionsIndexRoute =
  PrivateVsupplierregistrationTerms_exceptionsIndexRouteImport.update({
    id: "/vsupplierregistration/terms_exceptions/",
    path: "/vsupplierregistration/terms_exceptions/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVsupplierregistrationTerms_exceptionsNewRoute =
  PrivateVsupplierregistrationTerms_exceptionsNewRouteImport.update({
    id: "/vsupplierregistration/terms_exceptions/new",
    path: "/vsupplierregistration/terms_exceptions/new",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVsupplierregistrationVendorIndexRoute =
  PrivateVsupplierregistrationVendorIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => PrivateVsupplierregistrationVendorRouteRoute,
  } as any);
const PrivateVsupplierregistrationVendorCategoriesRoute =
  PrivateVsupplierregistrationVendorCategoriesRouteImport.update({
    id: "/categories",
    path: "/categories",
    getParentRoute: () => PrivateVsupplierregistrationVendorRouteRoute,
  } as any);
const PrivateVsupplierregistrationVendorDocumentsRoute =
  PrivateVsupplierregistrationVendorDocumentsRouteImport.update({
    id: "/documents",
    path: "/documents",
    getParentRoute: () => PrivateVsupplierregistrationVendorRouteRoute,
  } as any);
const PrivateVsupplierregistrationVendorEditRoute =
  PrivateVsupplierregistrationVendorEditRouteImport.update({
    id: "/edit",
    path: "/edit",
    getParentRoute: () => PrivateVsupplierregistrationVendorRouteRoute,
  } as any);
const PrivateVsupplierregistrationVendorTermsRoute =
  PrivateVsupplierregistrationVendorTermsRouteImport.update({
    id: "/terms",
    path: "/terms",
    getParentRoute: () => PrivateVsupplierregistrationVendorRouteRoute,
  } as any);
const PrivateVsupplierregistrationVendorTerms_exceptionsRoute =
  PrivateVsupplierregistrationVendorTerms_exceptionsRouteImport.update({
    id: "/terms_exceptions",
    path: "/terms_exceptions",
    getParentRoute: () => PrivateVsupplierregistrationVendorRouteRoute,
  } as any);
const PrivateVsupplierregistrationVendorUsersRoute =
  PrivateVsupplierregistrationVendorUsersRouteImport.update({
    id: "/users",
    path: "/users",
    getParentRoute: () => PrivateVsupplierregistrationVendorRouteRoute,
  } as any);
const PrivateVsupplierregistrationVendorsIndexRoute =
  PrivateVsupplierregistrationVendorsIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => PrivateVsupplierregistrationVendorsRouteRoute,
  } as any);
const PrivateVsupplierregistrationVendorsVendorIdRouteRoute =
  PrivateVsupplierregistrationVendorsVendorIdRouteRouteImport.update({
    id: "/$vendorId",
    path: "/$vendorId",
    getParentRoute: () => PrivateVsupplierregistrationVendorsRouteRoute,
  } as any);
const PrivateVsupplierregistrationVendorsNew_by_equinorRoute =
  PrivateVsupplierregistrationVendorsNew_by_equinorRouteImport.update({
    id: "/new_by_equinor",
    path: "/new_by_equinor",
    getParentRoute: () => PrivateVsupplierregistrationVendorsRouteRoute,
  } as any);
const ProtectedOnboardingVendorTermsRoute =
  ProtectedOnboardingVendorTermsRouteImport.update({
    id: "/onboarding/vendor/terms",
    path: "/onboarding/vendor/terms",
    getParentRoute: () => ProtectedRouteRoute,
  } as any);
const PublicAuthUsersSign_inRoute = PublicAuthUsersSign_inRouteImport.update({
  id: "/users/sign_in",
  path: "/users/sign_in",
  getParentRoute: () => PublicAuthRouteRoute,
} as any);
const PublicAuthUsersSign_upRoute = PublicAuthUsersSign_upRouteImport.update({
  id: "/users/sign_up",
  path: "/users/sign_up",
  getParentRoute: () => PublicAuthRouteRoute,
} as any);
const PrivatePurchase_ordersMaterialsPurchaseOrderIdIndexRoute =
  PrivatePurchase_ordersMaterialsPurchaseOrderIdIndexRouteImport.update({
    id: "/purchase_orders/materials/$purchaseOrderId/",
    path: "/purchase_orders/materials/$purchaseOrderId/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivatePurchase_ordersService_quotationsPurchaseOrderIdIndexRoute =
  PrivatePurchase_ordersService_quotationsPurchaseOrderIdIndexRouteImport.update(
    {
      id: "/purchase_orders/service_quotations/$purchaseOrderId/",
      path: "/purchase_orders/service_quotations/$purchaseOrderId/",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateRedirectRailsHomeIndexRoute =
  PrivateRedirectRailsHomeIndexRouteImport.update({
    id: "/redirect/rails/home/",
    path: "/redirect/rails/home/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerBill_of_materials_mgmt_requestsBillOfMaterialsMgmtRequestIdIndexRoute =
  PrivateVbuyerBill_of_materials_mgmt_requestsBillOfMaterialsMgmtRequestIdIndexRouteImport.update(
    {
      id: "/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId/",
      path: "/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId/",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateVbuyerBill_of_materials_mgmt_requestsBillOfMaterialsMgmtRequestIdEditRoute =
  PrivateVbuyerBill_of_materials_mgmt_requestsBillOfMaterialsMgmtRequestIdEditRouteImport.update(
    {
      id: "/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId/edit",
      path: "/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId/edit",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateVbuyerChange_material_requestsChangeMaterialRequestIdIndexRoute =
  PrivateVbuyerChange_material_requestsChangeMaterialRequestIdIndexRouteImport.update(
    {
      id: "/vbuyer/change_material_requests/$changeMaterialRequestId/",
      path: "/vbuyer/change_material_requests/$changeMaterialRequestId/",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateVbuyerChange_material_requestsChangeMaterialRequestIdEditRoute =
  PrivateVbuyerChange_material_requestsChangeMaterialRequestIdEditRouteImport.update(
    {
      id: "/vbuyer/change_material_requests/$changeMaterialRequestId/edit",
      path: "/vbuyer/change_material_requests/$changeMaterialRequestId/edit",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateVbuyerCreate_purchase_order_by_quotationsCreatePurchaseOrderByQuotationIdIndexRoute =
  PrivateVbuyerCreate_purchase_order_by_quotationsCreatePurchaseOrderByQuotationIdIndexRouteImport.update(
    {
      id: "/vbuyer/create_purchase_order_by_quotations/$createPurchaseOrderByQuotationId/",
      path: "/vbuyer/create_purchase_order_by_quotations/$createPurchaseOrderByQuotationId/",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateVbuyerCreate_purchase_order_by_service_quotationsCreatePurchaseOrderByServiceQuotationIdIndexRoute =
  PrivateVbuyerCreate_purchase_order_by_service_quotationsCreatePurchaseOrderByServiceQuotationIdIndexRouteImport.update(
    {
      id: "/vbuyer/create_purchase_order_by_service_quotations/$createPurchaseOrderByServiceQuotationId/",
      path: "/vbuyer/create_purchase_order_by_service_quotations/$createPurchaseOrderByServiceQuotationId/",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateVbuyerDuimp_requestsDuimpRequestIdIndexRoute =
  PrivateVbuyerDuimp_requestsDuimpRequestIdIndexRouteImport.update({
    id: "/vbuyer/duimp_requests/$duimpRequestId/",
    path: "/vbuyer/duimp_requests/$duimpRequestId/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerDuimp_requestsDuimpRequestIdEditRoute =
  PrivateVbuyerDuimp_requestsDuimpRequestIdEditRouteImport.update({
    id: "/vbuyer/duimp_requests/$duimpRequestId/edit",
    path: "/vbuyer/duimp_requests/$duimpRequestId/edit",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerGr_general_issue_raisersGrGeneralIssueRaiserIdIndexRoute =
  PrivateVbuyerGr_general_issue_raisersGrGeneralIssueRaiserIdIndexRouteImport.update(
    {
      id: "/vbuyer/gr_general_issue_raisers/$grGeneralIssueRaiserId/",
      path: "/vbuyer/gr_general_issue_raisers/$grGeneralIssueRaiserId/",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateVbuyerIssues_of_rfq_requestsIssuesOfRfqRequestIdIndexRoute =
  PrivateVbuyerIssues_of_rfq_requestsIssuesOfRfqRequestIdIndexRouteImport.update(
    {
      id: "/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId/",
      path: "/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId/",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateVbuyerIssues_of_rfq_requestsIssuesOfRfqRequestIdEditRoute =
  PrivateVbuyerIssues_of_rfq_requestsIssuesOfRfqRequestIdEditRouteImport.update(
    {
      id: "/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId/edit",
      path: "/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId/edit",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateVbuyerMaterial_request_formsMaterialRequestFormIdIndexRoute =
  PrivateVbuyerMaterial_request_formsMaterialRequestFormIdIndexRouteImport.update(
    {
      id: "/vbuyer/material_request_forms/$materialRequestFormId/",
      path: "/vbuyer/material_request_forms/$materialRequestFormId/",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateVbuyerOther_masterdata_services_requestsOtherMasterdataServicesRequestIdIndexRoute =
  PrivateVbuyerOther_masterdata_services_requestsOtherMasterdataServicesRequestIdIndexRouteImport.update(
    {
      id: "/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId/",
      path: "/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId/",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateVbuyerOther_masterdata_services_requestsOtherMasterdataServicesRequestIdEditRoute =
  PrivateVbuyerOther_masterdata_services_requestsOtherMasterdataServicesRequestIdEditRouteImport.update(
    {
      id: "/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId/edit",
      path: "/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId/edit",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateVbuyerProposalsProposalIdIndexRoute =
  PrivateVbuyerProposalsProposalIdIndexRouteImport.update({
    id: "/vbuyer/proposals/$proposalId/",
    path: "/vbuyer/proposals/$proposalId/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerQuotation_batchesQuotationBatchIdIndexRoute =
  PrivateVbuyerQuotation_batchesQuotationBatchIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () =>
      PrivateVbuyerQuotation_batchesQuotationBatchIdRouteRoute,
  } as any);
const PrivateVbuyerQuotation_batchesQuotationBatchIdEditRoute =
  PrivateVbuyerQuotation_batchesQuotationBatchIdEditRouteImport.update({
    id: "/edit",
    path: "/edit",
    getParentRoute: () =>
      PrivateVbuyerQuotation_batchesQuotationBatchIdRouteRoute,
  } as any);
const PrivateVbuyerQuotationsQuotationIdIndexRoute =
  PrivateVbuyerQuotationsQuotationIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => PrivateVbuyerQuotationsQuotationIdRouteRoute,
  } as any);
const PrivateVbuyerRnm_requestsRnmRequestIdIndexRoute =
  PrivateVbuyerRnm_requestsRnmRequestIdIndexRouteImport.update({
    id: "/vbuyer/rnm_requests/$rnmRequestId/",
    path: "/vbuyer/rnm_requests/$rnmRequestId/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerRsps3_requestsRsps3RequestIdIndexRoute =
  PrivateVbuyerRsps3_requestsRsps3RequestIdIndexRouteImport.update({
    id: "/vbuyer/rsps3_requests/$rsps3RequestId/",
    path: "/vbuyer/rsps3_requests/$rsps3RequestId/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerRsps3_requestsRsps3RequestIdEditRoute =
  PrivateVbuyerRsps3_requestsRsps3RequestIdEditRouteImport.update({
    id: "/vbuyer/rsps3_requests/$rsps3RequestId/edit",
    path: "/vbuyer/rsps3_requests/$rsps3RequestId/edit",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerService_negotiationsServiceNegotiationIdIndexRoute =
  PrivateVbuyerService_negotiationsServiceNegotiationIdIndexRouteImport.update({
    id: "/vbuyer/service_negotiations/$serviceNegotiationId/",
    path: "/vbuyer/service_negotiations/$serviceNegotiationId/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerService_quotation_approvalsServiceQuotationApprovalIdIndexRoute =
  PrivateVbuyerService_quotation_approvalsServiceQuotationApprovalIdIndexRouteImport.update(
    {
      id: "/vbuyer/service_quotation_approvals/$serviceQuotationApprovalId/",
      path: "/vbuyer/service_quotation_approvals/$serviceQuotationApprovalId/",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateVbuyerService_quotationsServiceQuotationIdIndexRoute =
  PrivateVbuyerService_quotationsServiceQuotationIdIndexRouteImport.update({
    id: "/vbuyer/service_quotations/$serviceQuotationId/",
    path: "/vbuyer/service_quotations/$serviceQuotationId/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerValoration_requestsValorationRequestIdIndexRoute =
  PrivateVbuyerValoration_requestsValorationRequestIdIndexRouteImport.update({
    id: "/vbuyer/valoration_requests/$valorationRequestId/",
    path: "/vbuyer/valoration_requests/$valorationRequestId/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVbuyerValoration_requestsValorationRequestIdEditRoute =
  PrivateVbuyerValoration_requestsValorationRequestIdEditRouteImport.update({
    id: "/vbuyer/valoration_requests/$valorationRequestId/edit",
    path: "/vbuyer/valoration_requests/$valorationRequestId/edit",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVsupplierregistrationExclusive_brandsIdIndexRoute =
  PrivateVsupplierregistrationExclusive_brandsIdIndexRouteImport.update({
    id: "/vsupplierregistration/exclusive_brands/$id/",
    path: "/vsupplierregistration/exclusive_brands/$id/",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVsupplierregistrationTermsTermIdEditRoute =
  PrivateVsupplierregistrationTermsTermIdEditRouteImport.update({
    id: "/vsupplierregistration/terms/$termId/edit",
    path: "/vsupplierregistration/terms/$termId/edit",
    getParentRoute: () => PrivateRouteRoute,
  } as any);
const PrivateVsupplierregistrationTerms_exceptionsTermExceptionIdIndexRoute =
  PrivateVsupplierregistrationTerms_exceptionsTermExceptionIdIndexRouteImport.update(
    {
      id: "/vsupplierregistration/terms_exceptions/$termExceptionId/",
      path: "/vsupplierregistration/terms_exceptions/$termExceptionId/",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateVsupplierregistrationTerms_exceptionsTermExceptionIdEditRoute =
  PrivateVsupplierregistrationTerms_exceptionsTermExceptionIdEditRouteImport.update(
    {
      id: "/vsupplierregistration/terms_exceptions/$termExceptionId/edit",
      path: "/vsupplierregistration/terms_exceptions/$termExceptionId/edit",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateVsupplierregistrationVendorsVendorIdIndexRoute =
  PrivateVsupplierregistrationVendorsVendorIdIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => PrivateVsupplierregistrationVendorsVendorIdRouteRoute,
  } as any);
const PrivateVsupplierregistrationVendorsVendorIdCategoriesRoute =
  PrivateVsupplierregistrationVendorsVendorIdCategoriesRouteImport.update({
    id: "/categories",
    path: "/categories",
    getParentRoute: () => PrivateVsupplierregistrationVendorsVendorIdRouteRoute,
  } as any);
const PrivateVsupplierregistrationVendorsVendorIdDocumentsRoute =
  PrivateVsupplierregistrationVendorsVendorIdDocumentsRouteImport.update({
    id: "/documents",
    path: "/documents",
    getParentRoute: () => PrivateVsupplierregistrationVendorsVendorIdRouteRoute,
  } as any);
const PrivateVsupplierregistrationVendorsVendorIdEditRoute =
  PrivateVsupplierregistrationVendorsVendorIdEditRouteImport.update({
    id: "/edit",
    path: "/edit",
    getParentRoute: () => PrivateVsupplierregistrationVendorsVendorIdRouteRoute,
  } as any);
const PrivateVsupplierregistrationVendorsVendorIdTermsRoute =
  PrivateVsupplierregistrationVendorsVendorIdTermsRouteImport.update({
    id: "/terms",
    path: "/terms",
    getParentRoute: () => PrivateVsupplierregistrationVendorsVendorIdRouteRoute,
  } as any);
const PrivateVsupplierregistrationVendorsVendorIdTerms_exceptionsRoute =
  PrivateVsupplierregistrationVendorsVendorIdTerms_exceptionsRouteImport.update(
    {
      id: "/terms_exceptions",
      path: "/terms_exceptions",
      getParentRoute: () =>
        PrivateVsupplierregistrationVendorsVendorIdRouteRoute,
    } as any,
  );
const PrivateVsupplierregistrationVendorsVendorIdUsersRoute =
  PrivateVsupplierregistrationVendorsVendorIdUsersRouteImport.update({
    id: "/users",
    path: "/users",
    getParentRoute: () => PrivateVsupplierregistrationVendorsVendorIdRouteRoute,
  } as any);
const PublicAuthUsersConfirmationNewRoute =
  PublicAuthUsersConfirmationNewRouteImport.update({
    id: "/users/confirmation/new",
    path: "/users/confirmation/new",
    getParentRoute: () => PublicAuthRouteRoute,
  } as any);
const PublicAuthUsersPasswordNewRoute =
  PublicAuthUsersPasswordNewRouteImport.update({
    id: "/users/password/new",
    path: "/users/password/new",
    getParentRoute: () => PublicAuthRouteRoute,
  } as any);
const PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsNewRoute =
  PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsNewRouteImport.update(
    {
      id: "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/new",
      path: "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/new",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsProposalIdIndexRoute =
  PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsProposalIdIndexRouteImport.update(
    {
      id: "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId/",
      path: "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId/",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );
const PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsProposalIdEditRoute =
  PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsProposalIdEditRouteImport.update(
    {
      id: "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId/edit",
      path: "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId/edit",
      getParentRoute: () => PrivateRouteRoute,
    } as any,
  );

export interface FileRoutesByFullPath {
  "/": typeof PublicAuthRouteRouteWithChildren;
  "/domain_transition": typeof PublicDomain_transitionRoute;
  "/vsupplierregistration/vendor": typeof PrivateVsupplierregistrationVendorRouteRouteWithChildren;
  "/vsupplierregistration/vendors": typeof PrivateVsupplierregistrationVendorsRouteRouteWithChildren;
  "/call_off_contract_items/issue_purchase_order": typeof PrivateCall_off_contract_itemsIssue_purchase_orderRoute;
  "/delivery_date_change_requests/new": typeof PrivateDelivery_date_change_requestsNewRoute;
  "/delivery_schedules/new": typeof PrivateDelivery_schedulesNewRoute;
  "/mm_request_assignment_rules/new": typeof PrivateMm_request_assignment_rulesNewRoute;
  "/users/edit": typeof PrivateUsersEditRoute;
  "/create_purchase_order_by_call_off_contracts/": typeof PrivateCreate_purchase_order_by_call_off_contractsIndexRoute;
  "/create_purchase_order_by_spots/": typeof PrivateCreate_purchase_order_by_spotsIndexRoute;
  "/delivery_date_change_requests/": typeof PrivateDelivery_date_change_requestsIndexRoute;
  "/delivery_schedules/": typeof PrivateDelivery_schedulesIndexRoute;
  "/developers/": typeof PrivateDevelopersIndexRoute;
  "/mm_request_assignment_rules/": typeof PrivateMm_request_assignment_rulesIndexRoute;
  "/mm_request_weekly_goals/": typeof PrivateMm_request_weekly_goalsIndexRoute;
  "/notifications/": typeof PrivateNotificationsIndexRoute;
  "/request_anticipation_evaluation_quotations/": typeof PrivateRequest_anticipation_evaluation_quotationsIndexRoute;
  "/vbuyer/quotation_batches/$quotationBatchId": typeof PrivateVbuyerQuotation_batchesQuotationBatchIdRouteRouteWithChildren;
  "/vbuyer/quotations/$quotationId": typeof PrivateVbuyerQuotationsQuotationIdRouteRouteWithChildren;
  "/vsupplierregistration/vendors/$vendorId": typeof PrivateVsupplierregistrationVendorsVendorIdRouteRouteWithChildren;
  "/call_off_contract_items/$callOffItemId/service_lines": typeof PrivateCall_off_contract_itemsCallOffItemIdService_linesRoute;
  "/mm_request_assignment_rules/$assignmentRuleId/edit": typeof PrivateMm_request_assignment_rulesAssignmentRuleIdEditRoute;
  "/vbuyer/bill_of_materials_mgmt_requests/new": typeof PrivateVbuyerBill_of_materials_mgmt_requestsNewRoute;
  "/vbuyer/change_material_requests/new": typeof PrivateVbuyerChange_material_requestsNewRoute;
  "/vbuyer/duimp_requests/new": typeof PrivateVbuyerDuimp_requestsNewRoute;
  "/vbuyer/helps/invoice_and_payment_procedures": typeof PrivateVbuyerHelpsInvoice_and_payment_proceduresRoute;
  "/vbuyer/issues_of_rfq_requests/new": typeof PrivateVbuyerIssues_of_rfq_requestsNewRoute;
  "/vbuyer/mm_requests/create_new_requests": typeof PrivateVbuyerMm_requestsCreate_new_requestsRoute;
  "/vbuyer/other_masterdata_services_requests/new": typeof PrivateVbuyerOther_masterdata_services_requestsNewRoute;
  "/vbuyer/quotation_batches/new": typeof PrivateVbuyerQuotation_batchesNewRoute;
  "/vbuyer/quotations/approval_stats": typeof PrivateVbuyerQuotationsApproval_statsRoute;
  "/vbuyer/quotations/issue_purchase_order": typeof PrivateVbuyerQuotationsIssue_purchase_orderRoute;
  "/vbuyer/rnm_requests/new": typeof PrivateVbuyerRnm_requestsNewRoute;
  "/vbuyer/rnm_requests/new_us": typeof PrivateVbuyerRnm_requestsNew_usRoute;
  "/vbuyer/service_quotations/issue_service_purchase_order": typeof PrivateVbuyerService_quotationsIssue_service_purchase_orderRoute;
  "/vbuyer/valoration_requests/new": typeof PrivateVbuyerValoration_requestsNewRoute;
  "/vsupplierregistration/terms/new": typeof PrivateVsupplierregistrationTermsNewRoute;
  "/vsupplierregistration/terms_exceptions/new": typeof PrivateVsupplierregistrationTerms_exceptionsNewRoute;
  "/vsupplierregistration/vendor/categories": typeof PrivateVsupplierregistrationVendorCategoriesRoute;
  "/vsupplierregistration/vendor/documents": typeof PrivateVsupplierregistrationVendorDocumentsRoute;
  "/vsupplierregistration/vendor/edit": typeof PrivateVsupplierregistrationVendorEditRoute;
  "/vsupplierregistration/vendor/terms": typeof PrivateVsupplierregistrationVendorTermsRoute;
  "/vsupplierregistration/vendor/terms_exceptions": typeof PrivateVsupplierregistrationVendorTerms_exceptionsRoute;
  "/vsupplierregistration/vendor/users": typeof PrivateVsupplierregistrationVendorUsersRoute;
  "/vsupplierregistration/vendors/new_by_equinor": typeof PrivateVsupplierregistrationVendorsNew_by_equinorRoute;
  "/onboarding/vendor/terms": typeof ProtectedOnboardingVendorTermsRoute;
  "/users/sign_in": typeof PublicAuthUsersSign_inRoute;
  "/users/sign_up": typeof PublicAuthUsersSign_upRoute;
  "/error/": typeof PrivateErrorsErrorIndexRoute;
  "/forbidden/": typeof PrivateErrorsForbiddenIndexRoute;
  "/not_found/": typeof PrivateErrorsNot_foundIndexRoute;
  "/create_purchase_order_by_call_off_contracts/$createPurchaseOrderByCallOffContractId/": typeof PrivateCreate_purchase_order_by_call_off_contractsCreatePurchaseOrderByCallOffContractIdIndexRoute;
  "/create_purchase_order_by_spots/$createPurchaseOrderBySpotId/": typeof PrivateCreate_purchase_order_by_spotsCreatePurchaseOrderBySpotIdIndexRoute;
  "/create_purchase_order_by_spots/executions/": typeof PrivateCreate_purchase_order_by_spotsExecutionsIndexRoute;
  "/delivery_date_change_requests/$deliveryDateChangeRequestId/": typeof PrivateDelivery_date_change_requestsDeliveryDateChangeRequestIdIndexRoute;
  "/delivery_schedules/$deliveryScheduleId/": typeof PrivateDelivery_schedulesDeliveryScheduleIdIndexRoute;
  "/invoice_approvals/$invoiceApprovalId/": typeof PrivateInvoice_approvalsInvoiceApprovalIdIndexRoute;
  "/mm_request_assignment_rules/$assignmentRuleId/": typeof PrivateMm_request_assignment_rulesAssignmentRuleIdIndexRoute;
  "/mm_request_weekly_goals/$userId/": typeof PrivateMm_request_weekly_goalsUserIdIndexRoute;
  "/purchase_orders/materials/": typeof PrivatePurchase_ordersMaterialsIndexRoute;
  "/purchase_orders/service_quotations/": typeof PrivatePurchase_ordersService_quotationsIndexRoute;
  "/request_anticipation_evaluation_quotations/$requestAnticipationEvaluationQuotationId/": typeof PrivateRequest_anticipation_evaluation_quotationsRequestAnticipationEvaluationQuotationIdIndexRoute;
  "/request_anticipation_service_quotations/$requestAnticipationServiceQuotationId/": typeof PrivateRequest_anticipation_service_quotationsRequestAnticipationServiceQuotationIdIndexRoute;
  "/vbuyer/create_purchase_order_by_quotations/": typeof PrivateVbuyerCreate_purchase_order_by_quotationsIndexRoute;
  "/vbuyer/create_purchase_order_by_service_quotations/": typeof PrivateVbuyerCreate_purchase_order_by_service_quotationsIndexRoute;
  "/vbuyer/gr_general_issue_raisers/": typeof PrivateVbuyerGr_general_issue_raisersIndexRoute;
  "/vbuyer/guides/": typeof PrivateVbuyerGuidesIndexRoute;
  "/vbuyer/helps/": typeof PrivateVbuyerHelpsIndexRoute;
  "/vbuyer/material_request_forms/": typeof PrivateVbuyerMaterial_request_formsIndexRoute;
  "/vbuyer/mm_requests/": typeof PrivateVbuyerMm_requestsIndexRoute;
  "/vbuyer/quotation_batches/": typeof PrivateVbuyerQuotation_batchesIndexRoute;
  "/vbuyer/quotations/": typeof PrivateVbuyerQuotationsIndexRoute;
  "/vbuyer/service_negotiations/": typeof PrivateVbuyerService_negotiationsIndexRoute;
  "/vbuyer/service_quotations/": typeof PrivateVbuyerService_quotationsIndexRoute;
  "/vsupplierregistration/exclusive_brands/": typeof PrivateVsupplierregistrationExclusive_brandsIndexRoute;
  "/vsupplierregistration/terms/": typeof PrivateVsupplierregistrationTermsIndexRoute;
  "/vsupplierregistration/terms_exceptions/": typeof PrivateVsupplierregistrationTerms_exceptionsIndexRoute;
  "/vsupplierregistration/vendor/": typeof PrivateVsupplierregistrationVendorIndexRoute;
  "/vsupplierregistration/vendors/": typeof PrivateVsupplierregistrationVendorsIndexRoute;
  "/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId/edit": typeof PrivateVbuyerBill_of_materials_mgmt_requestsBillOfMaterialsMgmtRequestIdEditRoute;
  "/vbuyer/change_material_requests/$changeMaterialRequestId/edit": typeof PrivateVbuyerChange_material_requestsChangeMaterialRequestIdEditRoute;
  "/vbuyer/duimp_requests/$duimpRequestId/edit": typeof PrivateVbuyerDuimp_requestsDuimpRequestIdEditRoute;
  "/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId/edit": typeof PrivateVbuyerIssues_of_rfq_requestsIssuesOfRfqRequestIdEditRoute;
  "/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId/edit": typeof PrivateVbuyerOther_masterdata_services_requestsOtherMasterdataServicesRequestIdEditRoute;
  "/vbuyer/quotation_batches/$quotationBatchId/edit": typeof PrivateVbuyerQuotation_batchesQuotationBatchIdEditRoute;
  "/vbuyer/rsps3_requests/$rsps3RequestId/edit": typeof PrivateVbuyerRsps3_requestsRsps3RequestIdEditRoute;
  "/vbuyer/valoration_requests/$valorationRequestId/edit": typeof PrivateVbuyerValoration_requestsValorationRequestIdEditRoute;
  "/vsupplierregistration/terms/$termId/edit": typeof PrivateVsupplierregistrationTermsTermIdEditRoute;
  "/vsupplierregistration/terms_exceptions/$termExceptionId/edit": typeof PrivateVsupplierregistrationTerms_exceptionsTermExceptionIdEditRoute;
  "/vsupplierregistration/vendors/$vendorId/categories": typeof PrivateVsupplierregistrationVendorsVendorIdCategoriesRoute;
  "/vsupplierregistration/vendors/$vendorId/documents": typeof PrivateVsupplierregistrationVendorsVendorIdDocumentsRoute;
  "/vsupplierregistration/vendors/$vendorId/edit": typeof PrivateVsupplierregistrationVendorsVendorIdEditRoute;
  "/vsupplierregistration/vendors/$vendorId/terms": typeof PrivateVsupplierregistrationVendorsVendorIdTermsRoute;
  "/vsupplierregistration/vendors/$vendorId/terms_exceptions": typeof PrivateVsupplierregistrationVendorsVendorIdTerms_exceptionsRoute;
  "/vsupplierregistration/vendors/$vendorId/users": typeof PrivateVsupplierregistrationVendorsVendorIdUsersRoute;
  "/users/confirmation/new": typeof PublicAuthUsersConfirmationNewRoute;
  "/users/password/new": typeof PublicAuthUsersPasswordNewRoute;
  "/purchase_orders/materials/$purchaseOrderId/": typeof PrivatePurchase_ordersMaterialsPurchaseOrderIdIndexRoute;
  "/purchase_orders/service_quotations/$purchaseOrderId/": typeof PrivatePurchase_ordersService_quotationsPurchaseOrderIdIndexRoute;
  "/redirect/rails/home/": typeof PrivateRedirectRailsHomeIndexRoute;
  "/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId/": typeof PrivateVbuyerBill_of_materials_mgmt_requestsBillOfMaterialsMgmtRequestIdIndexRoute;
  "/vbuyer/change_material_requests/$changeMaterialRequestId/": typeof PrivateVbuyerChange_material_requestsChangeMaterialRequestIdIndexRoute;
  "/vbuyer/create_purchase_order_by_quotations/$createPurchaseOrderByQuotationId/": typeof PrivateVbuyerCreate_purchase_order_by_quotationsCreatePurchaseOrderByQuotationIdIndexRoute;
  "/vbuyer/create_purchase_order_by_service_quotations/$createPurchaseOrderByServiceQuotationId/": typeof PrivateVbuyerCreate_purchase_order_by_service_quotationsCreatePurchaseOrderByServiceQuotationIdIndexRoute;
  "/vbuyer/duimp_requests/$duimpRequestId/": typeof PrivateVbuyerDuimp_requestsDuimpRequestIdIndexRoute;
  "/vbuyer/gr_general_issue_raisers/$grGeneralIssueRaiserId/": typeof PrivateVbuyerGr_general_issue_raisersGrGeneralIssueRaiserIdIndexRoute;
  "/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId/": typeof PrivateVbuyerIssues_of_rfq_requestsIssuesOfRfqRequestIdIndexRoute;
  "/vbuyer/material_request_forms/$materialRequestFormId/": typeof PrivateVbuyerMaterial_request_formsMaterialRequestFormIdIndexRoute;
  "/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId/": typeof PrivateVbuyerOther_masterdata_services_requestsOtherMasterdataServicesRequestIdIndexRoute;
  "/vbuyer/proposals/$proposalId/": typeof PrivateVbuyerProposalsProposalIdIndexRoute;
  "/vbuyer/quotation_batches/$quotationBatchId/": typeof PrivateVbuyerQuotation_batchesQuotationBatchIdIndexRoute;
  "/vbuyer/quotations/$quotationId/": typeof PrivateVbuyerQuotationsQuotationIdIndexRoute;
  "/vbuyer/rnm_requests/$rnmRequestId/": typeof PrivateVbuyerRnm_requestsRnmRequestIdIndexRoute;
  "/vbuyer/rsps3_requests/$rsps3RequestId/": typeof PrivateVbuyerRsps3_requestsRsps3RequestIdIndexRoute;
  "/vbuyer/service_negotiations/$serviceNegotiationId/": typeof PrivateVbuyerService_negotiationsServiceNegotiationIdIndexRoute;
  "/vbuyer/service_quotation_approvals/$serviceQuotationApprovalId/": typeof PrivateVbuyerService_quotation_approvalsServiceQuotationApprovalIdIndexRoute;
  "/vbuyer/service_quotations/$serviceQuotationId/": typeof PrivateVbuyerService_quotationsServiceQuotationIdIndexRoute;
  "/vbuyer/valoration_requests/$valorationRequestId/": typeof PrivateVbuyerValoration_requestsValorationRequestIdIndexRoute;
  "/vsupplierregistration/exclusive_brands/$id/": typeof PrivateVsupplierregistrationExclusive_brandsIdIndexRoute;
  "/vsupplierregistration/terms_exceptions/$termExceptionId/": typeof PrivateVsupplierregistrationTerms_exceptionsTermExceptionIdIndexRoute;
  "/vsupplierregistration/vendors/$vendorId/": typeof PrivateVsupplierregistrationVendorsVendorIdIndexRoute;
  "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/new": typeof PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsNewRoute;
  "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId/edit": typeof PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsProposalIdEditRoute;
  "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId/": typeof PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsProposalIdIndexRoute;
}
export interface FileRoutesByTo {
  "/": typeof PublicAuthRouteRouteWithChildren;
  "/domain_transition": typeof PublicDomain_transitionRoute;
  "/call_off_contract_items/issue_purchase_order": typeof PrivateCall_off_contract_itemsIssue_purchase_orderRoute;
  "/delivery_date_change_requests/new": typeof PrivateDelivery_date_change_requestsNewRoute;
  "/delivery_schedules/new": typeof PrivateDelivery_schedulesNewRoute;
  "/mm_request_assignment_rules/new": typeof PrivateMm_request_assignment_rulesNewRoute;
  "/users/edit": typeof PrivateUsersEditRoute;
  "/create_purchase_order_by_call_off_contracts": typeof PrivateCreate_purchase_order_by_call_off_contractsIndexRoute;
  "/create_purchase_order_by_spots": typeof PrivateCreate_purchase_order_by_spotsIndexRoute;
  "/delivery_date_change_requests": typeof PrivateDelivery_date_change_requestsIndexRoute;
  "/delivery_schedules": typeof PrivateDelivery_schedulesIndexRoute;
  "/developers": typeof PrivateDevelopersIndexRoute;
  "/mm_request_assignment_rules": typeof PrivateMm_request_assignment_rulesIndexRoute;
  "/mm_request_weekly_goals": typeof PrivateMm_request_weekly_goalsIndexRoute;
  "/notifications": typeof PrivateNotificationsIndexRoute;
  "/request_anticipation_evaluation_quotations": typeof PrivateRequest_anticipation_evaluation_quotationsIndexRoute;
  "/call_off_contract_items/$callOffItemId/service_lines": typeof PrivateCall_off_contract_itemsCallOffItemIdService_linesRoute;
  "/mm_request_assignment_rules/$assignmentRuleId/edit": typeof PrivateMm_request_assignment_rulesAssignmentRuleIdEditRoute;
  "/vbuyer/bill_of_materials_mgmt_requests/new": typeof PrivateVbuyerBill_of_materials_mgmt_requestsNewRoute;
  "/vbuyer/change_material_requests/new": typeof PrivateVbuyerChange_material_requestsNewRoute;
  "/vbuyer/duimp_requests/new": typeof PrivateVbuyerDuimp_requestsNewRoute;
  "/vbuyer/helps/invoice_and_payment_procedures": typeof PrivateVbuyerHelpsInvoice_and_payment_proceduresRoute;
  "/vbuyer/issues_of_rfq_requests/new": typeof PrivateVbuyerIssues_of_rfq_requestsNewRoute;
  "/vbuyer/mm_requests/create_new_requests": typeof PrivateVbuyerMm_requestsCreate_new_requestsRoute;
  "/vbuyer/other_masterdata_services_requests/new": typeof PrivateVbuyerOther_masterdata_services_requestsNewRoute;
  "/vbuyer/quotation_batches/new": typeof PrivateVbuyerQuotation_batchesNewRoute;
  "/vbuyer/quotations/approval_stats": typeof PrivateVbuyerQuotationsApproval_statsRoute;
  "/vbuyer/quotations/issue_purchase_order": typeof PrivateVbuyerQuotationsIssue_purchase_orderRoute;
  "/vbuyer/rnm_requests/new": typeof PrivateVbuyerRnm_requestsNewRoute;
  "/vbuyer/rnm_requests/new_us": typeof PrivateVbuyerRnm_requestsNew_usRoute;
  "/vbuyer/service_quotations/issue_service_purchase_order": typeof PrivateVbuyerService_quotationsIssue_service_purchase_orderRoute;
  "/vbuyer/valoration_requests/new": typeof PrivateVbuyerValoration_requestsNewRoute;
  "/vsupplierregistration/terms/new": typeof PrivateVsupplierregistrationTermsNewRoute;
  "/vsupplierregistration/terms_exceptions/new": typeof PrivateVsupplierregistrationTerms_exceptionsNewRoute;
  "/vsupplierregistration/vendor/categories": typeof PrivateVsupplierregistrationVendorCategoriesRoute;
  "/vsupplierregistration/vendor/documents": typeof PrivateVsupplierregistrationVendorDocumentsRoute;
  "/vsupplierregistration/vendor/edit": typeof PrivateVsupplierregistrationVendorEditRoute;
  "/vsupplierregistration/vendor/terms": typeof PrivateVsupplierregistrationVendorTermsRoute;
  "/vsupplierregistration/vendor/terms_exceptions": typeof PrivateVsupplierregistrationVendorTerms_exceptionsRoute;
  "/vsupplierregistration/vendor/users": typeof PrivateVsupplierregistrationVendorUsersRoute;
  "/vsupplierregistration/vendors/new_by_equinor": typeof PrivateVsupplierregistrationVendorsNew_by_equinorRoute;
  "/onboarding/vendor/terms": typeof ProtectedOnboardingVendorTermsRoute;
  "/users/sign_in": typeof PublicAuthUsersSign_inRoute;
  "/users/sign_up": typeof PublicAuthUsersSign_upRoute;
  "/error": typeof PrivateErrorsErrorIndexRoute;
  "/forbidden": typeof PrivateErrorsForbiddenIndexRoute;
  "/not_found": typeof PrivateErrorsNot_foundIndexRoute;
  "/create_purchase_order_by_call_off_contracts/$createPurchaseOrderByCallOffContractId": typeof PrivateCreate_purchase_order_by_call_off_contractsCreatePurchaseOrderByCallOffContractIdIndexRoute;
  "/create_purchase_order_by_spots/$createPurchaseOrderBySpotId": typeof PrivateCreate_purchase_order_by_spotsCreatePurchaseOrderBySpotIdIndexRoute;
  "/create_purchase_order_by_spots/executions": typeof PrivateCreate_purchase_order_by_spotsExecutionsIndexRoute;
  "/delivery_date_change_requests/$deliveryDateChangeRequestId": typeof PrivateDelivery_date_change_requestsDeliveryDateChangeRequestIdIndexRoute;
  "/delivery_schedules/$deliveryScheduleId": typeof PrivateDelivery_schedulesDeliveryScheduleIdIndexRoute;
  "/invoice_approvals/$invoiceApprovalId": typeof PrivateInvoice_approvalsInvoiceApprovalIdIndexRoute;
  "/mm_request_assignment_rules/$assignmentRuleId": typeof PrivateMm_request_assignment_rulesAssignmentRuleIdIndexRoute;
  "/mm_request_weekly_goals/$userId": typeof PrivateMm_request_weekly_goalsUserIdIndexRoute;
  "/purchase_orders/materials": typeof PrivatePurchase_ordersMaterialsIndexRoute;
  "/purchase_orders/service_quotations": typeof PrivatePurchase_ordersService_quotationsIndexRoute;
  "/request_anticipation_evaluation_quotations/$requestAnticipationEvaluationQuotationId": typeof PrivateRequest_anticipation_evaluation_quotationsRequestAnticipationEvaluationQuotationIdIndexRoute;
  "/request_anticipation_service_quotations/$requestAnticipationServiceQuotationId": typeof PrivateRequest_anticipation_service_quotationsRequestAnticipationServiceQuotationIdIndexRoute;
  "/vbuyer/create_purchase_order_by_quotations": typeof PrivateVbuyerCreate_purchase_order_by_quotationsIndexRoute;
  "/vbuyer/create_purchase_order_by_service_quotations": typeof PrivateVbuyerCreate_purchase_order_by_service_quotationsIndexRoute;
  "/vbuyer/gr_general_issue_raisers": typeof PrivateVbuyerGr_general_issue_raisersIndexRoute;
  "/vbuyer/guides": typeof PrivateVbuyerGuidesIndexRoute;
  "/vbuyer/helps": typeof PrivateVbuyerHelpsIndexRoute;
  "/vbuyer/material_request_forms": typeof PrivateVbuyerMaterial_request_formsIndexRoute;
  "/vbuyer/mm_requests": typeof PrivateVbuyerMm_requestsIndexRoute;
  "/vbuyer/quotation_batches": typeof PrivateVbuyerQuotation_batchesIndexRoute;
  "/vbuyer/quotations": typeof PrivateVbuyerQuotationsIndexRoute;
  "/vbuyer/service_negotiations": typeof PrivateVbuyerService_negotiationsIndexRoute;
  "/vbuyer/service_quotations": typeof PrivateVbuyerService_quotationsIndexRoute;
  "/vsupplierregistration/exclusive_brands": typeof PrivateVsupplierregistrationExclusive_brandsIndexRoute;
  "/vsupplierregistration/terms": typeof PrivateVsupplierregistrationTermsIndexRoute;
  "/vsupplierregistration/terms_exceptions": typeof PrivateVsupplierregistrationTerms_exceptionsIndexRoute;
  "/vsupplierregistration/vendor": typeof PrivateVsupplierregistrationVendorIndexRoute;
  "/vsupplierregistration/vendors": typeof PrivateVsupplierregistrationVendorsIndexRoute;
  "/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId/edit": typeof PrivateVbuyerBill_of_materials_mgmt_requestsBillOfMaterialsMgmtRequestIdEditRoute;
  "/vbuyer/change_material_requests/$changeMaterialRequestId/edit": typeof PrivateVbuyerChange_material_requestsChangeMaterialRequestIdEditRoute;
  "/vbuyer/duimp_requests/$duimpRequestId/edit": typeof PrivateVbuyerDuimp_requestsDuimpRequestIdEditRoute;
  "/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId/edit": typeof PrivateVbuyerIssues_of_rfq_requestsIssuesOfRfqRequestIdEditRoute;
  "/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId/edit": typeof PrivateVbuyerOther_masterdata_services_requestsOtherMasterdataServicesRequestIdEditRoute;
  "/vbuyer/quotation_batches/$quotationBatchId/edit": typeof PrivateVbuyerQuotation_batchesQuotationBatchIdEditRoute;
  "/vbuyer/rsps3_requests/$rsps3RequestId/edit": typeof PrivateVbuyerRsps3_requestsRsps3RequestIdEditRoute;
  "/vbuyer/valoration_requests/$valorationRequestId/edit": typeof PrivateVbuyerValoration_requestsValorationRequestIdEditRoute;
  "/vsupplierregistration/terms/$termId/edit": typeof PrivateVsupplierregistrationTermsTermIdEditRoute;
  "/vsupplierregistration/terms_exceptions/$termExceptionId/edit": typeof PrivateVsupplierregistrationTerms_exceptionsTermExceptionIdEditRoute;
  "/vsupplierregistration/vendors/$vendorId/categories": typeof PrivateVsupplierregistrationVendorsVendorIdCategoriesRoute;
  "/vsupplierregistration/vendors/$vendorId/documents": typeof PrivateVsupplierregistrationVendorsVendorIdDocumentsRoute;
  "/vsupplierregistration/vendors/$vendorId/edit": typeof PrivateVsupplierregistrationVendorsVendorIdEditRoute;
  "/vsupplierregistration/vendors/$vendorId/terms": typeof PrivateVsupplierregistrationVendorsVendorIdTermsRoute;
  "/vsupplierregistration/vendors/$vendorId/terms_exceptions": typeof PrivateVsupplierregistrationVendorsVendorIdTerms_exceptionsRoute;
  "/vsupplierregistration/vendors/$vendorId/users": typeof PrivateVsupplierregistrationVendorsVendorIdUsersRoute;
  "/users/confirmation/new": typeof PublicAuthUsersConfirmationNewRoute;
  "/users/password/new": typeof PublicAuthUsersPasswordNewRoute;
  "/purchase_orders/materials/$purchaseOrderId": typeof PrivatePurchase_ordersMaterialsPurchaseOrderIdIndexRoute;
  "/purchase_orders/service_quotations/$purchaseOrderId": typeof PrivatePurchase_ordersService_quotationsPurchaseOrderIdIndexRoute;
  "/redirect/rails/home": typeof PrivateRedirectRailsHomeIndexRoute;
  "/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId": typeof PrivateVbuyerBill_of_materials_mgmt_requestsBillOfMaterialsMgmtRequestIdIndexRoute;
  "/vbuyer/change_material_requests/$changeMaterialRequestId": typeof PrivateVbuyerChange_material_requestsChangeMaterialRequestIdIndexRoute;
  "/vbuyer/create_purchase_order_by_quotations/$createPurchaseOrderByQuotationId": typeof PrivateVbuyerCreate_purchase_order_by_quotationsCreatePurchaseOrderByQuotationIdIndexRoute;
  "/vbuyer/create_purchase_order_by_service_quotations/$createPurchaseOrderByServiceQuotationId": typeof PrivateVbuyerCreate_purchase_order_by_service_quotationsCreatePurchaseOrderByServiceQuotationIdIndexRoute;
  "/vbuyer/duimp_requests/$duimpRequestId": typeof PrivateVbuyerDuimp_requestsDuimpRequestIdIndexRoute;
  "/vbuyer/gr_general_issue_raisers/$grGeneralIssueRaiserId": typeof PrivateVbuyerGr_general_issue_raisersGrGeneralIssueRaiserIdIndexRoute;
  "/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId": typeof PrivateVbuyerIssues_of_rfq_requestsIssuesOfRfqRequestIdIndexRoute;
  "/vbuyer/material_request_forms/$materialRequestFormId": typeof PrivateVbuyerMaterial_request_formsMaterialRequestFormIdIndexRoute;
  "/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId": typeof PrivateVbuyerOther_masterdata_services_requestsOtherMasterdataServicesRequestIdIndexRoute;
  "/vbuyer/proposals/$proposalId": typeof PrivateVbuyerProposalsProposalIdIndexRoute;
  "/vbuyer/quotation_batches/$quotationBatchId": typeof PrivateVbuyerQuotation_batchesQuotationBatchIdIndexRoute;
  "/vbuyer/quotations/$quotationId": typeof PrivateVbuyerQuotationsQuotationIdIndexRoute;
  "/vbuyer/rnm_requests/$rnmRequestId": typeof PrivateVbuyerRnm_requestsRnmRequestIdIndexRoute;
  "/vbuyer/rsps3_requests/$rsps3RequestId": typeof PrivateVbuyerRsps3_requestsRsps3RequestIdIndexRoute;
  "/vbuyer/service_negotiations/$serviceNegotiationId": typeof PrivateVbuyerService_negotiationsServiceNegotiationIdIndexRoute;
  "/vbuyer/service_quotation_approvals/$serviceQuotationApprovalId": typeof PrivateVbuyerService_quotation_approvalsServiceQuotationApprovalIdIndexRoute;
  "/vbuyer/service_quotations/$serviceQuotationId": typeof PrivateVbuyerService_quotationsServiceQuotationIdIndexRoute;
  "/vbuyer/valoration_requests/$valorationRequestId": typeof PrivateVbuyerValoration_requestsValorationRequestIdIndexRoute;
  "/vsupplierregistration/exclusive_brands/$id": typeof PrivateVsupplierregistrationExclusive_brandsIdIndexRoute;
  "/vsupplierregistration/terms_exceptions/$termExceptionId": typeof PrivateVsupplierregistrationTerms_exceptionsTermExceptionIdIndexRoute;
  "/vsupplierregistration/vendors/$vendorId": typeof PrivateVsupplierregistrationVendorsVendorIdIndexRoute;
  "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/new": typeof PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsNewRoute;
  "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId/edit": typeof PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsProposalIdEditRoute;
  "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId": typeof PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsProposalIdIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/_private": typeof PrivateRouteRouteWithChildren;
  "/_protected": typeof ProtectedRouteRouteWithChildren;
  "/_public/_auth": typeof PublicAuthRouteRouteWithChildren;
  "/_public/domain_transition": typeof PublicDomain_transitionRoute;
  "/_private/vsupplierregistration/vendor": typeof PrivateVsupplierregistrationVendorRouteRouteWithChildren;
  "/_private/vsupplierregistration/vendors": typeof PrivateVsupplierregistrationVendorsRouteRouteWithChildren;
  "/_private/call_off_contract_items/issue_purchase_order": typeof PrivateCall_off_contract_itemsIssue_purchase_orderRoute;
  "/_private/delivery_date_change_requests/new": typeof PrivateDelivery_date_change_requestsNewRoute;
  "/_private/delivery_schedules/new": typeof PrivateDelivery_schedulesNewRoute;
  "/_private/mm_request_assignment_rules/new": typeof PrivateMm_request_assignment_rulesNewRoute;
  "/_private/users/edit": typeof PrivateUsersEditRoute;
  "/_private/create_purchase_order_by_call_off_contracts/": typeof PrivateCreate_purchase_order_by_call_off_contractsIndexRoute;
  "/_private/create_purchase_order_by_spots/": typeof PrivateCreate_purchase_order_by_spotsIndexRoute;
  "/_private/delivery_date_change_requests/": typeof PrivateDelivery_date_change_requestsIndexRoute;
  "/_private/delivery_schedules/": typeof PrivateDelivery_schedulesIndexRoute;
  "/_private/developers/": typeof PrivateDevelopersIndexRoute;
  "/_private/mm_request_assignment_rules/": typeof PrivateMm_request_assignment_rulesIndexRoute;
  "/_private/mm_request_weekly_goals/": typeof PrivateMm_request_weekly_goalsIndexRoute;
  "/_private/notifications/": typeof PrivateNotificationsIndexRoute;
  "/_private/request_anticipation_evaluation_quotations/": typeof PrivateRequest_anticipation_evaluation_quotationsIndexRoute;
  "/_private/vbuyer/quotation_batches/$quotationBatchId": typeof PrivateVbuyerQuotation_batchesQuotationBatchIdRouteRouteWithChildren;
  "/_private/vbuyer/quotations/$quotationId": typeof PrivateVbuyerQuotationsQuotationIdRouteRouteWithChildren;
  "/_private/vsupplierregistration/vendors/$vendorId": typeof PrivateVsupplierregistrationVendorsVendorIdRouteRouteWithChildren;
  "/_private/call_off_contract_items/$callOffItemId/service_lines": typeof PrivateCall_off_contract_itemsCallOffItemIdService_linesRoute;
  "/_private/mm_request_assignment_rules/$assignmentRuleId/edit": typeof PrivateMm_request_assignment_rulesAssignmentRuleIdEditRoute;
  "/_private/vbuyer/bill_of_materials_mgmt_requests/new": typeof PrivateVbuyerBill_of_materials_mgmt_requestsNewRoute;
  "/_private/vbuyer/change_material_requests/new": typeof PrivateVbuyerChange_material_requestsNewRoute;
  "/_private/vbuyer/duimp_requests/new": typeof PrivateVbuyerDuimp_requestsNewRoute;
  "/_private/vbuyer/helps/invoice_and_payment_procedures": typeof PrivateVbuyerHelpsInvoice_and_payment_proceduresRoute;
  "/_private/vbuyer/issues_of_rfq_requests/new": typeof PrivateVbuyerIssues_of_rfq_requestsNewRoute;
  "/_private/vbuyer/mm_requests/create_new_requests": typeof PrivateVbuyerMm_requestsCreate_new_requestsRoute;
  "/_private/vbuyer/other_masterdata_services_requests/new": typeof PrivateVbuyerOther_masterdata_services_requestsNewRoute;
  "/_private/vbuyer/quotation_batches/new": typeof PrivateVbuyerQuotation_batchesNewRoute;
  "/_private/vbuyer/quotations/approval_stats": typeof PrivateVbuyerQuotationsApproval_statsRoute;
  "/_private/vbuyer/quotations/issue_purchase_order": typeof PrivateVbuyerQuotationsIssue_purchase_orderRoute;
  "/_private/vbuyer/rnm_requests/new": typeof PrivateVbuyerRnm_requestsNewRoute;
  "/_private/vbuyer/rnm_requests/new_us": typeof PrivateVbuyerRnm_requestsNew_usRoute;
  "/_private/vbuyer/service_quotations/issue_service_purchase_order": typeof PrivateVbuyerService_quotationsIssue_service_purchase_orderRoute;
  "/_private/vbuyer/valoration_requests/new": typeof PrivateVbuyerValoration_requestsNewRoute;
  "/_private/vsupplierregistration/terms/new": typeof PrivateVsupplierregistrationTermsNewRoute;
  "/_private/vsupplierregistration/terms_exceptions/new": typeof PrivateVsupplierregistrationTerms_exceptionsNewRoute;
  "/_private/vsupplierregistration/vendor/categories": typeof PrivateVsupplierregistrationVendorCategoriesRoute;
  "/_private/vsupplierregistration/vendor/documents": typeof PrivateVsupplierregistrationVendorDocumentsRoute;
  "/_private/vsupplierregistration/vendor/edit": typeof PrivateVsupplierregistrationVendorEditRoute;
  "/_private/vsupplierregistration/vendor/terms": typeof PrivateVsupplierregistrationVendorTermsRoute;
  "/_private/vsupplierregistration/vendor/terms_exceptions": typeof PrivateVsupplierregistrationVendorTerms_exceptionsRoute;
  "/_private/vsupplierregistration/vendor/users": typeof PrivateVsupplierregistrationVendorUsersRoute;
  "/_private/vsupplierregistration/vendors/new_by_equinor": typeof PrivateVsupplierregistrationVendorsNew_by_equinorRoute;
  "/_protected/onboarding/vendor/terms": typeof ProtectedOnboardingVendorTermsRoute;
  "/_public/_auth/users/sign_in": typeof PublicAuthUsersSign_inRoute;
  "/_public/_auth/users/sign_up": typeof PublicAuthUsersSign_upRoute;
  "/_private/_errors/error/": typeof PrivateErrorsErrorIndexRoute;
  "/_private/_errors/forbidden/": typeof PrivateErrorsForbiddenIndexRoute;
  "/_private/_errors/not_found/": typeof PrivateErrorsNot_foundIndexRoute;
  "/_private/create_purchase_order_by_call_off_contracts/$createPurchaseOrderByCallOffContractId/": typeof PrivateCreate_purchase_order_by_call_off_contractsCreatePurchaseOrderByCallOffContractIdIndexRoute;
  "/_private/create_purchase_order_by_spots/$createPurchaseOrderBySpotId/": typeof PrivateCreate_purchase_order_by_spotsCreatePurchaseOrderBySpotIdIndexRoute;
  "/_private/create_purchase_order_by_spots/executions/": typeof PrivateCreate_purchase_order_by_spotsExecutionsIndexRoute;
  "/_private/delivery_date_change_requests/$deliveryDateChangeRequestId/": typeof PrivateDelivery_date_change_requestsDeliveryDateChangeRequestIdIndexRoute;
  "/_private/delivery_schedules/$deliveryScheduleId/": typeof PrivateDelivery_schedulesDeliveryScheduleIdIndexRoute;
  "/_private/invoice_approvals/$invoiceApprovalId/": typeof PrivateInvoice_approvalsInvoiceApprovalIdIndexRoute;
  "/_private/mm_request_assignment_rules/$assignmentRuleId/": typeof PrivateMm_request_assignment_rulesAssignmentRuleIdIndexRoute;
  "/_private/mm_request_weekly_goals/$userId/": typeof PrivateMm_request_weekly_goalsUserIdIndexRoute;
  "/_private/purchase_orders/materials/": typeof PrivatePurchase_ordersMaterialsIndexRoute;
  "/_private/purchase_orders/service_quotations/": typeof PrivatePurchase_ordersService_quotationsIndexRoute;
  "/_private/request_anticipation_evaluation_quotations/$requestAnticipationEvaluationQuotationId/": typeof PrivateRequest_anticipation_evaluation_quotationsRequestAnticipationEvaluationQuotationIdIndexRoute;
  "/_private/request_anticipation_service_quotations/$requestAnticipationServiceQuotationId/": typeof PrivateRequest_anticipation_service_quotationsRequestAnticipationServiceQuotationIdIndexRoute;
  "/_private/vbuyer/create_purchase_order_by_quotations/": typeof PrivateVbuyerCreate_purchase_order_by_quotationsIndexRoute;
  "/_private/vbuyer/create_purchase_order_by_service_quotations/": typeof PrivateVbuyerCreate_purchase_order_by_service_quotationsIndexRoute;
  "/_private/vbuyer/gr_general_issue_raisers/": typeof PrivateVbuyerGr_general_issue_raisersIndexRoute;
  "/_private/vbuyer/guides/": typeof PrivateVbuyerGuidesIndexRoute;
  "/_private/vbuyer/helps/": typeof PrivateVbuyerHelpsIndexRoute;
  "/_private/vbuyer/material_request_forms/": typeof PrivateVbuyerMaterial_request_formsIndexRoute;
  "/_private/vbuyer/mm_requests/": typeof PrivateVbuyerMm_requestsIndexRoute;
  "/_private/vbuyer/quotation_batches/": typeof PrivateVbuyerQuotation_batchesIndexRoute;
  "/_private/vbuyer/quotations/": typeof PrivateVbuyerQuotationsIndexRoute;
  "/_private/vbuyer/service_negotiations/": typeof PrivateVbuyerService_negotiationsIndexRoute;
  "/_private/vbuyer/service_quotations/": typeof PrivateVbuyerService_quotationsIndexRoute;
  "/_private/vsupplierregistration/exclusive_brands/": typeof PrivateVsupplierregistrationExclusive_brandsIndexRoute;
  "/_private/vsupplierregistration/terms/": typeof PrivateVsupplierregistrationTermsIndexRoute;
  "/_private/vsupplierregistration/terms_exceptions/": typeof PrivateVsupplierregistrationTerms_exceptionsIndexRoute;
  "/_private/vsupplierregistration/vendor/": typeof PrivateVsupplierregistrationVendorIndexRoute;
  "/_private/vsupplierregistration/vendors/": typeof PrivateVsupplierregistrationVendorsIndexRoute;
  "/_private/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId/edit": typeof PrivateVbuyerBill_of_materials_mgmt_requestsBillOfMaterialsMgmtRequestIdEditRoute;
  "/_private/vbuyer/change_material_requests/$changeMaterialRequestId/edit": typeof PrivateVbuyerChange_material_requestsChangeMaterialRequestIdEditRoute;
  "/_private/vbuyer/duimp_requests/$duimpRequestId/edit": typeof PrivateVbuyerDuimp_requestsDuimpRequestIdEditRoute;
  "/_private/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId/edit": typeof PrivateVbuyerIssues_of_rfq_requestsIssuesOfRfqRequestIdEditRoute;
  "/_private/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId/edit": typeof PrivateVbuyerOther_masterdata_services_requestsOtherMasterdataServicesRequestIdEditRoute;
  "/_private/vbuyer/quotation_batches/$quotationBatchId/edit": typeof PrivateVbuyerQuotation_batchesQuotationBatchIdEditRoute;
  "/_private/vbuyer/rsps3_requests/$rsps3RequestId/edit": typeof PrivateVbuyerRsps3_requestsRsps3RequestIdEditRoute;
  "/_private/vbuyer/valoration_requests/$valorationRequestId/edit": typeof PrivateVbuyerValoration_requestsValorationRequestIdEditRoute;
  "/_private/vsupplierregistration/terms/$termId/edit": typeof PrivateVsupplierregistrationTermsTermIdEditRoute;
  "/_private/vsupplierregistration/terms_exceptions/$termExceptionId/edit": typeof PrivateVsupplierregistrationTerms_exceptionsTermExceptionIdEditRoute;
  "/_private/vsupplierregistration/vendors/$vendorId/categories": typeof PrivateVsupplierregistrationVendorsVendorIdCategoriesRoute;
  "/_private/vsupplierregistration/vendors/$vendorId/documents": typeof PrivateVsupplierregistrationVendorsVendorIdDocumentsRoute;
  "/_private/vsupplierregistration/vendors/$vendorId/edit": typeof PrivateVsupplierregistrationVendorsVendorIdEditRoute;
  "/_private/vsupplierregistration/vendors/$vendorId/terms": typeof PrivateVsupplierregistrationVendorsVendorIdTermsRoute;
  "/_private/vsupplierregistration/vendors/$vendorId/terms_exceptions": typeof PrivateVsupplierregistrationVendorsVendorIdTerms_exceptionsRoute;
  "/_private/vsupplierregistration/vendors/$vendorId/users": typeof PrivateVsupplierregistrationVendorsVendorIdUsersRoute;
  "/_public/_auth/users/confirmation/new": typeof PublicAuthUsersConfirmationNewRoute;
  "/_public/_auth/users/password/new": typeof PublicAuthUsersPasswordNewRoute;
  "/_private/purchase_orders/materials/$purchaseOrderId/": typeof PrivatePurchase_ordersMaterialsPurchaseOrderIdIndexRoute;
  "/_private/purchase_orders/service_quotations/$purchaseOrderId/": typeof PrivatePurchase_ordersService_quotationsPurchaseOrderIdIndexRoute;
  "/_private/redirect/rails/home/": typeof PrivateRedirectRailsHomeIndexRoute;
  "/_private/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId/": typeof PrivateVbuyerBill_of_materials_mgmt_requestsBillOfMaterialsMgmtRequestIdIndexRoute;
  "/_private/vbuyer/change_material_requests/$changeMaterialRequestId/": typeof PrivateVbuyerChange_material_requestsChangeMaterialRequestIdIndexRoute;
  "/_private/vbuyer/create_purchase_order_by_quotations/$createPurchaseOrderByQuotationId/": typeof PrivateVbuyerCreate_purchase_order_by_quotationsCreatePurchaseOrderByQuotationIdIndexRoute;
  "/_private/vbuyer/create_purchase_order_by_service_quotations/$createPurchaseOrderByServiceQuotationId/": typeof PrivateVbuyerCreate_purchase_order_by_service_quotationsCreatePurchaseOrderByServiceQuotationIdIndexRoute;
  "/_private/vbuyer/duimp_requests/$duimpRequestId/": typeof PrivateVbuyerDuimp_requestsDuimpRequestIdIndexRoute;
  "/_private/vbuyer/gr_general_issue_raisers/$grGeneralIssueRaiserId/": typeof PrivateVbuyerGr_general_issue_raisersGrGeneralIssueRaiserIdIndexRoute;
  "/_private/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId/": typeof PrivateVbuyerIssues_of_rfq_requestsIssuesOfRfqRequestIdIndexRoute;
  "/_private/vbuyer/material_request_forms/$materialRequestFormId/": typeof PrivateVbuyerMaterial_request_formsMaterialRequestFormIdIndexRoute;
  "/_private/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId/": typeof PrivateVbuyerOther_masterdata_services_requestsOtherMasterdataServicesRequestIdIndexRoute;
  "/_private/vbuyer/proposals/$proposalId/": typeof PrivateVbuyerProposalsProposalIdIndexRoute;
  "/_private/vbuyer/quotation_batches/$quotationBatchId/": typeof PrivateVbuyerQuotation_batchesQuotationBatchIdIndexRoute;
  "/_private/vbuyer/quotations/$quotationId/": typeof PrivateVbuyerQuotationsQuotationIdIndexRoute;
  "/_private/vbuyer/rnm_requests/$rnmRequestId/": typeof PrivateVbuyerRnm_requestsRnmRequestIdIndexRoute;
  "/_private/vbuyer/rsps3_requests/$rsps3RequestId/": typeof PrivateVbuyerRsps3_requestsRsps3RequestIdIndexRoute;
  "/_private/vbuyer/service_negotiations/$serviceNegotiationId/": typeof PrivateVbuyerService_negotiationsServiceNegotiationIdIndexRoute;
  "/_private/vbuyer/service_quotation_approvals/$serviceQuotationApprovalId/": typeof PrivateVbuyerService_quotation_approvalsServiceQuotationApprovalIdIndexRoute;
  "/_private/vbuyer/service_quotations/$serviceQuotationId/": typeof PrivateVbuyerService_quotationsServiceQuotationIdIndexRoute;
  "/_private/vbuyer/valoration_requests/$valorationRequestId/": typeof PrivateVbuyerValoration_requestsValorationRequestIdIndexRoute;
  "/_private/vsupplierregistration/exclusive_brands/$id/": typeof PrivateVsupplierregistrationExclusive_brandsIdIndexRoute;
  "/_private/vsupplierregistration/terms_exceptions/$termExceptionId/": typeof PrivateVsupplierregistrationTerms_exceptionsTermExceptionIdIndexRoute;
  "/_private/vsupplierregistration/vendors/$vendorId/": typeof PrivateVsupplierregistrationVendorsVendorIdIndexRoute;
  "/_private/vbuyer/service_negotiations/$serviceNegotiationId/proposals/new": typeof PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsNewRoute;
  "/_private/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId/edit": typeof PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsProposalIdEditRoute;
  "/_private/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId/": typeof PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsProposalIdIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/domain_transition"
    | "/vsupplierregistration/vendor"
    | "/vsupplierregistration/vendors"
    | "/call_off_contract_items/issue_purchase_order"
    | "/delivery_date_change_requests/new"
    | "/delivery_schedules/new"
    | "/mm_request_assignment_rules/new"
    | "/users/edit"
    | "/create_purchase_order_by_call_off_contracts/"
    | "/create_purchase_order_by_spots/"
    | "/delivery_date_change_requests/"
    | "/delivery_schedules/"
    | "/developers/"
    | "/mm_request_assignment_rules/"
    | "/mm_request_weekly_goals/"
    | "/notifications/"
    | "/request_anticipation_evaluation_quotations/"
    | "/vbuyer/quotation_batches/$quotationBatchId"
    | "/vbuyer/quotations/$quotationId"
    | "/vsupplierregistration/vendors/$vendorId"
    | "/call_off_contract_items/$callOffItemId/service_lines"
    | "/mm_request_assignment_rules/$assignmentRuleId/edit"
    | "/vbuyer/bill_of_materials_mgmt_requests/new"
    | "/vbuyer/change_material_requests/new"
    | "/vbuyer/duimp_requests/new"
    | "/vbuyer/helps/invoice_and_payment_procedures"
    | "/vbuyer/issues_of_rfq_requests/new"
    | "/vbuyer/mm_requests/create_new_requests"
    | "/vbuyer/other_masterdata_services_requests/new"
    | "/vbuyer/quotation_batches/new"
    | "/vbuyer/quotations/approval_stats"
    | "/vbuyer/quotations/issue_purchase_order"
    | "/vbuyer/rnm_requests/new"
    | "/vbuyer/rnm_requests/new_us"
    | "/vbuyer/service_quotations/issue_service_purchase_order"
    | "/vbuyer/valoration_requests/new"
    | "/vsupplierregistration/terms/new"
    | "/vsupplierregistration/terms_exceptions/new"
    | "/vsupplierregistration/vendor/categories"
    | "/vsupplierregistration/vendor/documents"
    | "/vsupplierregistration/vendor/edit"
    | "/vsupplierregistration/vendor/terms"
    | "/vsupplierregistration/vendor/terms_exceptions"
    | "/vsupplierregistration/vendor/users"
    | "/vsupplierregistration/vendors/new_by_equinor"
    | "/onboarding/vendor/terms"
    | "/users/sign_in"
    | "/users/sign_up"
    | "/error/"
    | "/forbidden/"
    | "/not_found/"
    | "/create_purchase_order_by_call_off_contracts/$createPurchaseOrderByCallOffContractId/"
    | "/create_purchase_order_by_spots/$createPurchaseOrderBySpotId/"
    | "/create_purchase_order_by_spots/executions/"
    | "/delivery_date_change_requests/$deliveryDateChangeRequestId/"
    | "/delivery_schedules/$deliveryScheduleId/"
    | "/invoice_approvals/$invoiceApprovalId/"
    | "/mm_request_assignment_rules/$assignmentRuleId/"
    | "/mm_request_weekly_goals/$userId/"
    | "/purchase_orders/materials/"
    | "/purchase_orders/service_quotations/"
    | "/request_anticipation_evaluation_quotations/$requestAnticipationEvaluationQuotationId/"
    | "/request_anticipation_service_quotations/$requestAnticipationServiceQuotationId/"
    | "/vbuyer/create_purchase_order_by_quotations/"
    | "/vbuyer/create_purchase_order_by_service_quotations/"
    | "/vbuyer/gr_general_issue_raisers/"
    | "/vbuyer/guides/"
    | "/vbuyer/helps/"
    | "/vbuyer/material_request_forms/"
    | "/vbuyer/mm_requests/"
    | "/vbuyer/quotation_batches/"
    | "/vbuyer/quotations/"
    | "/vbuyer/service_negotiations/"
    | "/vbuyer/service_quotations/"
    | "/vsupplierregistration/exclusive_brands/"
    | "/vsupplierregistration/terms/"
    | "/vsupplierregistration/terms_exceptions/"
    | "/vsupplierregistration/vendor/"
    | "/vsupplierregistration/vendors/"
    | "/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId/edit"
    | "/vbuyer/change_material_requests/$changeMaterialRequestId/edit"
    | "/vbuyer/duimp_requests/$duimpRequestId/edit"
    | "/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId/edit"
    | "/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId/edit"
    | "/vbuyer/quotation_batches/$quotationBatchId/edit"
    | "/vbuyer/rsps3_requests/$rsps3RequestId/edit"
    | "/vbuyer/valoration_requests/$valorationRequestId/edit"
    | "/vsupplierregistration/terms/$termId/edit"
    | "/vsupplierregistration/terms_exceptions/$termExceptionId/edit"
    | "/vsupplierregistration/vendors/$vendorId/categories"
    | "/vsupplierregistration/vendors/$vendorId/documents"
    | "/vsupplierregistration/vendors/$vendorId/edit"
    | "/vsupplierregistration/vendors/$vendorId/terms"
    | "/vsupplierregistration/vendors/$vendorId/terms_exceptions"
    | "/vsupplierregistration/vendors/$vendorId/users"
    | "/users/confirmation/new"
    | "/users/password/new"
    | "/purchase_orders/materials/$purchaseOrderId/"
    | "/purchase_orders/service_quotations/$purchaseOrderId/"
    | "/redirect/rails/home/"
    | "/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId/"
    | "/vbuyer/change_material_requests/$changeMaterialRequestId/"
    | "/vbuyer/create_purchase_order_by_quotations/$createPurchaseOrderByQuotationId/"
    | "/vbuyer/create_purchase_order_by_service_quotations/$createPurchaseOrderByServiceQuotationId/"
    | "/vbuyer/duimp_requests/$duimpRequestId/"
    | "/vbuyer/gr_general_issue_raisers/$grGeneralIssueRaiserId/"
    | "/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId/"
    | "/vbuyer/material_request_forms/$materialRequestFormId/"
    | "/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId/"
    | "/vbuyer/proposals/$proposalId/"
    | "/vbuyer/quotation_batches/$quotationBatchId/"
    | "/vbuyer/quotations/$quotationId/"
    | "/vbuyer/rnm_requests/$rnmRequestId/"
    | "/vbuyer/rsps3_requests/$rsps3RequestId/"
    | "/vbuyer/service_negotiations/$serviceNegotiationId/"
    | "/vbuyer/service_quotation_approvals/$serviceQuotationApprovalId/"
    | "/vbuyer/service_quotations/$serviceQuotationId/"
    | "/vbuyer/valoration_requests/$valorationRequestId/"
    | "/vsupplierregistration/exclusive_brands/$id/"
    | "/vsupplierregistration/terms_exceptions/$termExceptionId/"
    | "/vsupplierregistration/vendors/$vendorId/"
    | "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/new"
    | "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId/edit"
    | "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId/";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/domain_transition"
    | "/call_off_contract_items/issue_purchase_order"
    | "/delivery_date_change_requests/new"
    | "/delivery_schedules/new"
    | "/mm_request_assignment_rules/new"
    | "/users/edit"
    | "/create_purchase_order_by_call_off_contracts"
    | "/create_purchase_order_by_spots"
    | "/delivery_date_change_requests"
    | "/delivery_schedules"
    | "/developers"
    | "/mm_request_assignment_rules"
    | "/mm_request_weekly_goals"
    | "/notifications"
    | "/request_anticipation_evaluation_quotations"
    | "/call_off_contract_items/$callOffItemId/service_lines"
    | "/mm_request_assignment_rules/$assignmentRuleId/edit"
    | "/vbuyer/bill_of_materials_mgmt_requests/new"
    | "/vbuyer/change_material_requests/new"
    | "/vbuyer/duimp_requests/new"
    | "/vbuyer/helps/invoice_and_payment_procedures"
    | "/vbuyer/issues_of_rfq_requests/new"
    | "/vbuyer/mm_requests/create_new_requests"
    | "/vbuyer/other_masterdata_services_requests/new"
    | "/vbuyer/quotation_batches/new"
    | "/vbuyer/quotations/approval_stats"
    | "/vbuyer/quotations/issue_purchase_order"
    | "/vbuyer/rnm_requests/new"
    | "/vbuyer/rnm_requests/new_us"
    | "/vbuyer/service_quotations/issue_service_purchase_order"
    | "/vbuyer/valoration_requests/new"
    | "/vsupplierregistration/terms/new"
    | "/vsupplierregistration/terms_exceptions/new"
    | "/vsupplierregistration/vendor/categories"
    | "/vsupplierregistration/vendor/documents"
    | "/vsupplierregistration/vendor/edit"
    | "/vsupplierregistration/vendor/terms"
    | "/vsupplierregistration/vendor/terms_exceptions"
    | "/vsupplierregistration/vendor/users"
    | "/vsupplierregistration/vendors/new_by_equinor"
    | "/onboarding/vendor/terms"
    | "/users/sign_in"
    | "/users/sign_up"
    | "/error"
    | "/forbidden"
    | "/not_found"
    | "/create_purchase_order_by_call_off_contracts/$createPurchaseOrderByCallOffContractId"
    | "/create_purchase_order_by_spots/$createPurchaseOrderBySpotId"
    | "/create_purchase_order_by_spots/executions"
    | "/delivery_date_change_requests/$deliveryDateChangeRequestId"
    | "/delivery_schedules/$deliveryScheduleId"
    | "/invoice_approvals/$invoiceApprovalId"
    | "/mm_request_assignment_rules/$assignmentRuleId"
    | "/mm_request_weekly_goals/$userId"
    | "/purchase_orders/materials"
    | "/purchase_orders/service_quotations"
    | "/request_anticipation_evaluation_quotations/$requestAnticipationEvaluationQuotationId"
    | "/request_anticipation_service_quotations/$requestAnticipationServiceQuotationId"
    | "/vbuyer/create_purchase_order_by_quotations"
    | "/vbuyer/create_purchase_order_by_service_quotations"
    | "/vbuyer/gr_general_issue_raisers"
    | "/vbuyer/guides"
    | "/vbuyer/helps"
    | "/vbuyer/material_request_forms"
    | "/vbuyer/mm_requests"
    | "/vbuyer/quotation_batches"
    | "/vbuyer/quotations"
    | "/vbuyer/service_negotiations"
    | "/vbuyer/service_quotations"
    | "/vsupplierregistration/exclusive_brands"
    | "/vsupplierregistration/terms"
    | "/vsupplierregistration/terms_exceptions"
    | "/vsupplierregistration/vendor"
    | "/vsupplierregistration/vendors"
    | "/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId/edit"
    | "/vbuyer/change_material_requests/$changeMaterialRequestId/edit"
    | "/vbuyer/duimp_requests/$duimpRequestId/edit"
    | "/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId/edit"
    | "/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId/edit"
    | "/vbuyer/quotation_batches/$quotationBatchId/edit"
    | "/vbuyer/rsps3_requests/$rsps3RequestId/edit"
    | "/vbuyer/valoration_requests/$valorationRequestId/edit"
    | "/vsupplierregistration/terms/$termId/edit"
    | "/vsupplierregistration/terms_exceptions/$termExceptionId/edit"
    | "/vsupplierregistration/vendors/$vendorId/categories"
    | "/vsupplierregistration/vendors/$vendorId/documents"
    | "/vsupplierregistration/vendors/$vendorId/edit"
    | "/vsupplierregistration/vendors/$vendorId/terms"
    | "/vsupplierregistration/vendors/$vendorId/terms_exceptions"
    | "/vsupplierregistration/vendors/$vendorId/users"
    | "/users/confirmation/new"
    | "/users/password/new"
    | "/purchase_orders/materials/$purchaseOrderId"
    | "/purchase_orders/service_quotations/$purchaseOrderId"
    | "/redirect/rails/home"
    | "/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId"
    | "/vbuyer/change_material_requests/$changeMaterialRequestId"
    | "/vbuyer/create_purchase_order_by_quotations/$createPurchaseOrderByQuotationId"
    | "/vbuyer/create_purchase_order_by_service_quotations/$createPurchaseOrderByServiceQuotationId"
    | "/vbuyer/duimp_requests/$duimpRequestId"
    | "/vbuyer/gr_general_issue_raisers/$grGeneralIssueRaiserId"
    | "/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId"
    | "/vbuyer/material_request_forms/$materialRequestFormId"
    | "/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId"
    | "/vbuyer/proposals/$proposalId"
    | "/vbuyer/quotation_batches/$quotationBatchId"
    | "/vbuyer/quotations/$quotationId"
    | "/vbuyer/rnm_requests/$rnmRequestId"
    | "/vbuyer/rsps3_requests/$rsps3RequestId"
    | "/vbuyer/service_negotiations/$serviceNegotiationId"
    | "/vbuyer/service_quotation_approvals/$serviceQuotationApprovalId"
    | "/vbuyer/service_quotations/$serviceQuotationId"
    | "/vbuyer/valoration_requests/$valorationRequestId"
    | "/vsupplierregistration/exclusive_brands/$id"
    | "/vsupplierregistration/terms_exceptions/$termExceptionId"
    | "/vsupplierregistration/vendors/$vendorId"
    | "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/new"
    | "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId/edit"
    | "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId";
  id:
    | "__root__"
    | "/_private"
    | "/_protected"
    | "/_public/_auth"
    | "/_public/domain_transition"
    | "/_private/vsupplierregistration/vendor"
    | "/_private/vsupplierregistration/vendors"
    | "/_private/call_off_contract_items/issue_purchase_order"
    | "/_private/delivery_date_change_requests/new"
    | "/_private/delivery_schedules/new"
    | "/_private/mm_request_assignment_rules/new"
    | "/_private/users/edit"
    | "/_private/create_purchase_order_by_call_off_contracts/"
    | "/_private/create_purchase_order_by_spots/"
    | "/_private/delivery_date_change_requests/"
    | "/_private/delivery_schedules/"
    | "/_private/developers/"
    | "/_private/mm_request_assignment_rules/"
    | "/_private/mm_request_weekly_goals/"
    | "/_private/notifications/"
    | "/_private/request_anticipation_evaluation_quotations/"
    | "/_private/vbuyer/quotation_batches/$quotationBatchId"
    | "/_private/vbuyer/quotations/$quotationId"
    | "/_private/vsupplierregistration/vendors/$vendorId"
    | "/_private/call_off_contract_items/$callOffItemId/service_lines"
    | "/_private/mm_request_assignment_rules/$assignmentRuleId/edit"
    | "/_private/vbuyer/bill_of_materials_mgmt_requests/new"
    | "/_private/vbuyer/change_material_requests/new"
    | "/_private/vbuyer/duimp_requests/new"
    | "/_private/vbuyer/helps/invoice_and_payment_procedures"
    | "/_private/vbuyer/issues_of_rfq_requests/new"
    | "/_private/vbuyer/mm_requests/create_new_requests"
    | "/_private/vbuyer/other_masterdata_services_requests/new"
    | "/_private/vbuyer/quotation_batches/new"
    | "/_private/vbuyer/quotations/approval_stats"
    | "/_private/vbuyer/quotations/issue_purchase_order"
    | "/_private/vbuyer/rnm_requests/new"
    | "/_private/vbuyer/rnm_requests/new_us"
    | "/_private/vbuyer/service_quotations/issue_service_purchase_order"
    | "/_private/vbuyer/valoration_requests/new"
    | "/_private/vsupplierregistration/terms/new"
    | "/_private/vsupplierregistration/terms_exceptions/new"
    | "/_private/vsupplierregistration/vendor/categories"
    | "/_private/vsupplierregistration/vendor/documents"
    | "/_private/vsupplierregistration/vendor/edit"
    | "/_private/vsupplierregistration/vendor/terms"
    | "/_private/vsupplierregistration/vendor/terms_exceptions"
    | "/_private/vsupplierregistration/vendor/users"
    | "/_private/vsupplierregistration/vendors/new_by_equinor"
    | "/_protected/onboarding/vendor/terms"
    | "/_public/_auth/users/sign_in"
    | "/_public/_auth/users/sign_up"
    | "/_private/_errors/error/"
    | "/_private/_errors/forbidden/"
    | "/_private/_errors/not_found/"
    | "/_private/create_purchase_order_by_call_off_contracts/$createPurchaseOrderByCallOffContractId/"
    | "/_private/create_purchase_order_by_spots/$createPurchaseOrderBySpotId/"
    | "/_private/create_purchase_order_by_spots/executions/"
    | "/_private/delivery_date_change_requests/$deliveryDateChangeRequestId/"
    | "/_private/delivery_schedules/$deliveryScheduleId/"
    | "/_private/invoice_approvals/$invoiceApprovalId/"
    | "/_private/mm_request_assignment_rules/$assignmentRuleId/"
    | "/_private/mm_request_weekly_goals/$userId/"
    | "/_private/purchase_orders/materials/"
    | "/_private/purchase_orders/service_quotations/"
    | "/_private/request_anticipation_evaluation_quotations/$requestAnticipationEvaluationQuotationId/"
    | "/_private/request_anticipation_service_quotations/$requestAnticipationServiceQuotationId/"
    | "/_private/vbuyer/create_purchase_order_by_quotations/"
    | "/_private/vbuyer/create_purchase_order_by_service_quotations/"
    | "/_private/vbuyer/gr_general_issue_raisers/"
    | "/_private/vbuyer/guides/"
    | "/_private/vbuyer/helps/"
    | "/_private/vbuyer/material_request_forms/"
    | "/_private/vbuyer/mm_requests/"
    | "/_private/vbuyer/quotation_batches/"
    | "/_private/vbuyer/quotations/"
    | "/_private/vbuyer/service_negotiations/"
    | "/_private/vbuyer/service_quotations/"
    | "/_private/vsupplierregistration/exclusive_brands/"
    | "/_private/vsupplierregistration/terms/"
    | "/_private/vsupplierregistration/terms_exceptions/"
    | "/_private/vsupplierregistration/vendor/"
    | "/_private/vsupplierregistration/vendors/"
    | "/_private/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId/edit"
    | "/_private/vbuyer/change_material_requests/$changeMaterialRequestId/edit"
    | "/_private/vbuyer/duimp_requests/$duimpRequestId/edit"
    | "/_private/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId/edit"
    | "/_private/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId/edit"
    | "/_private/vbuyer/quotation_batches/$quotationBatchId/edit"
    | "/_private/vbuyer/rsps3_requests/$rsps3RequestId/edit"
    | "/_private/vbuyer/valoration_requests/$valorationRequestId/edit"
    | "/_private/vsupplierregistration/terms/$termId/edit"
    | "/_private/vsupplierregistration/terms_exceptions/$termExceptionId/edit"
    | "/_private/vsupplierregistration/vendors/$vendorId/categories"
    | "/_private/vsupplierregistration/vendors/$vendorId/documents"
    | "/_private/vsupplierregistration/vendors/$vendorId/edit"
    | "/_private/vsupplierregistration/vendors/$vendorId/terms"
    | "/_private/vsupplierregistration/vendors/$vendorId/terms_exceptions"
    | "/_private/vsupplierregistration/vendors/$vendorId/users"
    | "/_public/_auth/users/confirmation/new"
    | "/_public/_auth/users/password/new"
    | "/_private/purchase_orders/materials/$purchaseOrderId/"
    | "/_private/purchase_orders/service_quotations/$purchaseOrderId/"
    | "/_private/redirect/rails/home/"
    | "/_private/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId/"
    | "/_private/vbuyer/change_material_requests/$changeMaterialRequestId/"
    | "/_private/vbuyer/create_purchase_order_by_quotations/$createPurchaseOrderByQuotationId/"
    | "/_private/vbuyer/create_purchase_order_by_service_quotations/$createPurchaseOrderByServiceQuotationId/"
    | "/_private/vbuyer/duimp_requests/$duimpRequestId/"
    | "/_private/vbuyer/gr_general_issue_raisers/$grGeneralIssueRaiserId/"
    | "/_private/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId/"
    | "/_private/vbuyer/material_request_forms/$materialRequestFormId/"
    | "/_private/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId/"
    | "/_private/vbuyer/proposals/$proposalId/"
    | "/_private/vbuyer/quotation_batches/$quotationBatchId/"
    | "/_private/vbuyer/quotations/$quotationId/"
    | "/_private/vbuyer/rnm_requests/$rnmRequestId/"
    | "/_private/vbuyer/rsps3_requests/$rsps3RequestId/"
    | "/_private/vbuyer/service_negotiations/$serviceNegotiationId/"
    | "/_private/vbuyer/service_quotation_approvals/$serviceQuotationApprovalId/"
    | "/_private/vbuyer/service_quotations/$serviceQuotationId/"
    | "/_private/vbuyer/valoration_requests/$valorationRequestId/"
    | "/_private/vsupplierregistration/exclusive_brands/$id/"
    | "/_private/vsupplierregistration/terms_exceptions/$termExceptionId/"
    | "/_private/vsupplierregistration/vendors/$vendorId/"
    | "/_private/vbuyer/service_negotiations/$serviceNegotiationId/proposals/new"
    | "/_private/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId/edit"
    | "/_private/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  PrivateRouteRoute: typeof PrivateRouteRouteWithChildren;
  ProtectedRouteRoute: typeof ProtectedRouteRouteWithChildren;
  PublicAuthRouteRoute: typeof PublicAuthRouteRouteWithChildren;
  PublicDomain_transitionRoute: typeof PublicDomain_transitionRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_private": {
      id: "/_private";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof PrivateRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_protected": {
      id: "/_protected";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof ProtectedRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_public/_auth": {
      id: "/_public/_auth";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof PublicAuthRouteRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_public/domain_transition": {
      id: "/_public/domain_transition";
      path: "/domain_transition";
      fullPath: "/domain_transition";
      preLoaderRoute: typeof PublicDomain_transitionRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_private/call_off_contract_items/issue_purchase_order": {
      id: "/_private/call_off_contract_items/issue_purchase_order";
      path: "/call_off_contract_items/issue_purchase_order";
      fullPath: "/call_off_contract_items/issue_purchase_order";
      preLoaderRoute: typeof PrivateCall_off_contract_itemsIssue_purchase_orderRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/create_purchase_order_by_call_off_contracts/": {
      id: "/_private/create_purchase_order_by_call_off_contracts/";
      path: "/create_purchase_order_by_call_off_contracts";
      fullPath: "/create_purchase_order_by_call_off_contracts/";
      preLoaderRoute: typeof PrivateCreate_purchase_order_by_call_off_contractsIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/create_purchase_order_by_spots/": {
      id: "/_private/create_purchase_order_by_spots/";
      path: "/create_purchase_order_by_spots";
      fullPath: "/create_purchase_order_by_spots/";
      preLoaderRoute: typeof PrivateCreate_purchase_order_by_spotsIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/delivery_date_change_requests/": {
      id: "/_private/delivery_date_change_requests/";
      path: "/delivery_date_change_requests";
      fullPath: "/delivery_date_change_requests/";
      preLoaderRoute: typeof PrivateDelivery_date_change_requestsIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/delivery_date_change_requests/new": {
      id: "/_private/delivery_date_change_requests/new";
      path: "/delivery_date_change_requests/new";
      fullPath: "/delivery_date_change_requests/new";
      preLoaderRoute: typeof PrivateDelivery_date_change_requestsNewRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/delivery_schedules/": {
      id: "/_private/delivery_schedules/";
      path: "/delivery_schedules";
      fullPath: "/delivery_schedules/";
      preLoaderRoute: typeof PrivateDelivery_schedulesIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/delivery_schedules/new": {
      id: "/_private/delivery_schedules/new";
      path: "/delivery_schedules/new";
      fullPath: "/delivery_schedules/new";
      preLoaderRoute: typeof PrivateDelivery_schedulesNewRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/developers/": {
      id: "/_private/developers/";
      path: "/developers";
      fullPath: "/developers/";
      preLoaderRoute: typeof PrivateDevelopersIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/mm_request_assignment_rules/": {
      id: "/_private/mm_request_assignment_rules/";
      path: "/mm_request_assignment_rules";
      fullPath: "/mm_request_assignment_rules/";
      preLoaderRoute: typeof PrivateMm_request_assignment_rulesIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/mm_request_assignment_rules/new": {
      id: "/_private/mm_request_assignment_rules/new";
      path: "/mm_request_assignment_rules/new";
      fullPath: "/mm_request_assignment_rules/new";
      preLoaderRoute: typeof PrivateMm_request_assignment_rulesNewRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/mm_request_weekly_goals/": {
      id: "/_private/mm_request_weekly_goals/";
      path: "/mm_request_weekly_goals";
      fullPath: "/mm_request_weekly_goals/";
      preLoaderRoute: typeof PrivateMm_request_weekly_goalsIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/notifications/": {
      id: "/_private/notifications/";
      path: "/notifications";
      fullPath: "/notifications/";
      preLoaderRoute: typeof PrivateNotificationsIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/request_anticipation_evaluation_quotations/": {
      id: "/_private/request_anticipation_evaluation_quotations/";
      path: "/request_anticipation_evaluation_quotations";
      fullPath: "/request_anticipation_evaluation_quotations/";
      preLoaderRoute: typeof PrivateRequest_anticipation_evaluation_quotationsIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/users/edit": {
      id: "/_private/users/edit";
      path: "/users/edit";
      fullPath: "/users/edit";
      preLoaderRoute: typeof PrivateUsersEditRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vsupplierregistration/vendor": {
      id: "/_private/vsupplierregistration/vendor";
      path: "/vsupplierregistration/vendor";
      fullPath: "/vsupplierregistration/vendor";
      preLoaderRoute: typeof PrivateVsupplierregistrationVendorRouteRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vsupplierregistration/vendors": {
      id: "/_private/vsupplierregistration/vendors";
      path: "/vsupplierregistration/vendors";
      fullPath: "/vsupplierregistration/vendors";
      preLoaderRoute: typeof PrivateVsupplierregistrationVendorsRouteRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/_errors/error/": {
      id: "/_private/_errors/error/";
      path: "/error";
      fullPath: "/error/";
      preLoaderRoute: typeof PrivateErrorsErrorIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/_errors/forbidden/": {
      id: "/_private/_errors/forbidden/";
      path: "/forbidden";
      fullPath: "/forbidden/";
      preLoaderRoute: typeof PrivateErrorsForbiddenIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/_errors/not_found/": {
      id: "/_private/_errors/not_found/";
      path: "/not_found";
      fullPath: "/not_found/";
      preLoaderRoute: typeof PrivateErrorsNot_foundIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/call_off_contract_items/$callOffItemId/service_lines": {
      id: "/_private/call_off_contract_items/$callOffItemId/service_lines";
      path: "/call_off_contract_items/$callOffItemId/service_lines";
      fullPath: "/call_off_contract_items/$callOffItemId/service_lines";
      preLoaderRoute: typeof PrivateCall_off_contract_itemsCallOffItemIdService_linesRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/create_purchase_order_by_call_off_contracts/$createPurchaseOrderByCallOffContractId/": {
      id: "/_private/create_purchase_order_by_call_off_contracts/$createPurchaseOrderByCallOffContractId/";
      path: "/create_purchase_order_by_call_off_contracts/$createPurchaseOrderByCallOffContractId";
      fullPath: "/create_purchase_order_by_call_off_contracts/$createPurchaseOrderByCallOffContractId/";
      preLoaderRoute: typeof PrivateCreate_purchase_order_by_call_off_contractsCreatePurchaseOrderByCallOffContractIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/create_purchase_order_by_spots/$createPurchaseOrderBySpotId/": {
      id: "/_private/create_purchase_order_by_spots/$createPurchaseOrderBySpotId/";
      path: "/create_purchase_order_by_spots/$createPurchaseOrderBySpotId";
      fullPath: "/create_purchase_order_by_spots/$createPurchaseOrderBySpotId/";
      preLoaderRoute: typeof PrivateCreate_purchase_order_by_spotsCreatePurchaseOrderBySpotIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/create_purchase_order_by_spots/executions/": {
      id: "/_private/create_purchase_order_by_spots/executions/";
      path: "/create_purchase_order_by_spots/executions";
      fullPath: "/create_purchase_order_by_spots/executions/";
      preLoaderRoute: typeof PrivateCreate_purchase_order_by_spotsExecutionsIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/delivery_date_change_requests/$deliveryDateChangeRequestId/": {
      id: "/_private/delivery_date_change_requests/$deliveryDateChangeRequestId/";
      path: "/delivery_date_change_requests/$deliveryDateChangeRequestId";
      fullPath: "/delivery_date_change_requests/$deliveryDateChangeRequestId/";
      preLoaderRoute: typeof PrivateDelivery_date_change_requestsDeliveryDateChangeRequestIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/delivery_schedules/$deliveryScheduleId/": {
      id: "/_private/delivery_schedules/$deliveryScheduleId/";
      path: "/delivery_schedules/$deliveryScheduleId";
      fullPath: "/delivery_schedules/$deliveryScheduleId/";
      preLoaderRoute: typeof PrivateDelivery_schedulesDeliveryScheduleIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/invoice_approvals/$invoiceApprovalId/": {
      id: "/_private/invoice_approvals/$invoiceApprovalId/";
      path: "/invoice_approvals/$invoiceApprovalId";
      fullPath: "/invoice_approvals/$invoiceApprovalId/";
      preLoaderRoute: typeof PrivateInvoice_approvalsInvoiceApprovalIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/mm_request_assignment_rules/$assignmentRuleId/": {
      id: "/_private/mm_request_assignment_rules/$assignmentRuleId/";
      path: "/mm_request_assignment_rules/$assignmentRuleId";
      fullPath: "/mm_request_assignment_rules/$assignmentRuleId/";
      preLoaderRoute: typeof PrivateMm_request_assignment_rulesAssignmentRuleIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/mm_request_assignment_rules/$assignmentRuleId/edit": {
      id: "/_private/mm_request_assignment_rules/$assignmentRuleId/edit";
      path: "/mm_request_assignment_rules/$assignmentRuleId/edit";
      fullPath: "/mm_request_assignment_rules/$assignmentRuleId/edit";
      preLoaderRoute: typeof PrivateMm_request_assignment_rulesAssignmentRuleIdEditRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/mm_request_weekly_goals/$userId/": {
      id: "/_private/mm_request_weekly_goals/$userId/";
      path: "/mm_request_weekly_goals/$userId";
      fullPath: "/mm_request_weekly_goals/$userId/";
      preLoaderRoute: typeof PrivateMm_request_weekly_goalsUserIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/purchase_orders/materials/": {
      id: "/_private/purchase_orders/materials/";
      path: "/purchase_orders/materials";
      fullPath: "/purchase_orders/materials/";
      preLoaderRoute: typeof PrivatePurchase_ordersMaterialsIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/purchase_orders/service_quotations/": {
      id: "/_private/purchase_orders/service_quotations/";
      path: "/purchase_orders/service_quotations";
      fullPath: "/purchase_orders/service_quotations/";
      preLoaderRoute: typeof PrivatePurchase_ordersService_quotationsIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/request_anticipation_evaluation_quotations/$requestAnticipationEvaluationQuotationId/": {
      id: "/_private/request_anticipation_evaluation_quotations/$requestAnticipationEvaluationQuotationId/";
      path: "/request_anticipation_evaluation_quotations/$requestAnticipationEvaluationQuotationId";
      fullPath: "/request_anticipation_evaluation_quotations/$requestAnticipationEvaluationQuotationId/";
      preLoaderRoute: typeof PrivateRequest_anticipation_evaluation_quotationsRequestAnticipationEvaluationQuotationIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/request_anticipation_service_quotations/$requestAnticipationServiceQuotationId/": {
      id: "/_private/request_anticipation_service_quotations/$requestAnticipationServiceQuotationId/";
      path: "/request_anticipation_service_quotations/$requestAnticipationServiceQuotationId";
      fullPath: "/request_anticipation_service_quotations/$requestAnticipationServiceQuotationId/";
      preLoaderRoute: typeof PrivateRequest_anticipation_service_quotationsRequestAnticipationServiceQuotationIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/bill_of_materials_mgmt_requests/new": {
      id: "/_private/vbuyer/bill_of_materials_mgmt_requests/new";
      path: "/vbuyer/bill_of_materials_mgmt_requests/new";
      fullPath: "/vbuyer/bill_of_materials_mgmt_requests/new";
      preLoaderRoute: typeof PrivateVbuyerBill_of_materials_mgmt_requestsNewRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/change_material_requests/new": {
      id: "/_private/vbuyer/change_material_requests/new";
      path: "/vbuyer/change_material_requests/new";
      fullPath: "/vbuyer/change_material_requests/new";
      preLoaderRoute: typeof PrivateVbuyerChange_material_requestsNewRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/create_purchase_order_by_quotations/": {
      id: "/_private/vbuyer/create_purchase_order_by_quotations/";
      path: "/vbuyer/create_purchase_order_by_quotations";
      fullPath: "/vbuyer/create_purchase_order_by_quotations/";
      preLoaderRoute: typeof PrivateVbuyerCreate_purchase_order_by_quotationsIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/create_purchase_order_by_service_quotations/": {
      id: "/_private/vbuyer/create_purchase_order_by_service_quotations/";
      path: "/vbuyer/create_purchase_order_by_service_quotations";
      fullPath: "/vbuyer/create_purchase_order_by_service_quotations/";
      preLoaderRoute: typeof PrivateVbuyerCreate_purchase_order_by_service_quotationsIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/duimp_requests/new": {
      id: "/_private/vbuyer/duimp_requests/new";
      path: "/vbuyer/duimp_requests/new";
      fullPath: "/vbuyer/duimp_requests/new";
      preLoaderRoute: typeof PrivateVbuyerDuimp_requestsNewRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/gr_general_issue_raisers/": {
      id: "/_private/vbuyer/gr_general_issue_raisers/";
      path: "/vbuyer/gr_general_issue_raisers";
      fullPath: "/vbuyer/gr_general_issue_raisers/";
      preLoaderRoute: typeof PrivateVbuyerGr_general_issue_raisersIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/guides/": {
      id: "/_private/vbuyer/guides/";
      path: "/vbuyer/guides";
      fullPath: "/vbuyer/guides/";
      preLoaderRoute: typeof PrivateVbuyerGuidesIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/helps/": {
      id: "/_private/vbuyer/helps/";
      path: "/vbuyer/helps";
      fullPath: "/vbuyer/helps/";
      preLoaderRoute: typeof PrivateVbuyerHelpsIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/helps/invoice_and_payment_procedures": {
      id: "/_private/vbuyer/helps/invoice_and_payment_procedures";
      path: "/vbuyer/helps/invoice_and_payment_procedures";
      fullPath: "/vbuyer/helps/invoice_and_payment_procedures";
      preLoaderRoute: typeof PrivateVbuyerHelpsInvoice_and_payment_proceduresRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/issues_of_rfq_requests/new": {
      id: "/_private/vbuyer/issues_of_rfq_requests/new";
      path: "/vbuyer/issues_of_rfq_requests/new";
      fullPath: "/vbuyer/issues_of_rfq_requests/new";
      preLoaderRoute: typeof PrivateVbuyerIssues_of_rfq_requestsNewRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/material_request_forms/": {
      id: "/_private/vbuyer/material_request_forms/";
      path: "/vbuyer/material_request_forms";
      fullPath: "/vbuyer/material_request_forms/";
      preLoaderRoute: typeof PrivateVbuyerMaterial_request_formsIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/mm_requests/": {
      id: "/_private/vbuyer/mm_requests/";
      path: "/vbuyer/mm_requests";
      fullPath: "/vbuyer/mm_requests/";
      preLoaderRoute: typeof PrivateVbuyerMm_requestsIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/mm_requests/create_new_requests": {
      id: "/_private/vbuyer/mm_requests/create_new_requests";
      path: "/vbuyer/mm_requests/create_new_requests";
      fullPath: "/vbuyer/mm_requests/create_new_requests";
      preLoaderRoute: typeof PrivateVbuyerMm_requestsCreate_new_requestsRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/other_masterdata_services_requests/new": {
      id: "/_private/vbuyer/other_masterdata_services_requests/new";
      path: "/vbuyer/other_masterdata_services_requests/new";
      fullPath: "/vbuyer/other_masterdata_services_requests/new";
      preLoaderRoute: typeof PrivateVbuyerOther_masterdata_services_requestsNewRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/quotation_batches/": {
      id: "/_private/vbuyer/quotation_batches/";
      path: "/vbuyer/quotation_batches";
      fullPath: "/vbuyer/quotation_batches/";
      preLoaderRoute: typeof PrivateVbuyerQuotation_batchesIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/quotation_batches/$quotationBatchId": {
      id: "/_private/vbuyer/quotation_batches/$quotationBatchId";
      path: "/vbuyer/quotation_batches/$quotationBatchId";
      fullPath: "/vbuyer/quotation_batches/$quotationBatchId";
      preLoaderRoute: typeof PrivateVbuyerQuotation_batchesQuotationBatchIdRouteRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/quotation_batches/new": {
      id: "/_private/vbuyer/quotation_batches/new";
      path: "/vbuyer/quotation_batches/new";
      fullPath: "/vbuyer/quotation_batches/new";
      preLoaderRoute: typeof PrivateVbuyerQuotation_batchesNewRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/quotations/": {
      id: "/_private/vbuyer/quotations/";
      path: "/vbuyer/quotations";
      fullPath: "/vbuyer/quotations/";
      preLoaderRoute: typeof PrivateVbuyerQuotationsIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/quotations/$quotationId": {
      id: "/_private/vbuyer/quotations/$quotationId";
      path: "/vbuyer/quotations/$quotationId";
      fullPath: "/vbuyer/quotations/$quotationId";
      preLoaderRoute: typeof PrivateVbuyerQuotationsQuotationIdRouteRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/quotations/approval_stats": {
      id: "/_private/vbuyer/quotations/approval_stats";
      path: "/vbuyer/quotations/approval_stats";
      fullPath: "/vbuyer/quotations/approval_stats";
      preLoaderRoute: typeof PrivateVbuyerQuotationsApproval_statsRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/quotations/issue_purchase_order": {
      id: "/_private/vbuyer/quotations/issue_purchase_order";
      path: "/vbuyer/quotations/issue_purchase_order";
      fullPath: "/vbuyer/quotations/issue_purchase_order";
      preLoaderRoute: typeof PrivateVbuyerQuotationsIssue_purchase_orderRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/rnm_requests/new": {
      id: "/_private/vbuyer/rnm_requests/new";
      path: "/vbuyer/rnm_requests/new";
      fullPath: "/vbuyer/rnm_requests/new";
      preLoaderRoute: typeof PrivateVbuyerRnm_requestsNewRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/rnm_requests/new_us": {
      id: "/_private/vbuyer/rnm_requests/new_us";
      path: "/vbuyer/rnm_requests/new_us";
      fullPath: "/vbuyer/rnm_requests/new_us";
      preLoaderRoute: typeof PrivateVbuyerRnm_requestsNew_usRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/service_negotiations/": {
      id: "/_private/vbuyer/service_negotiations/";
      path: "/vbuyer/service_negotiations";
      fullPath: "/vbuyer/service_negotiations/";
      preLoaderRoute: typeof PrivateVbuyerService_negotiationsIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/service_quotations/": {
      id: "/_private/vbuyer/service_quotations/";
      path: "/vbuyer/service_quotations";
      fullPath: "/vbuyer/service_quotations/";
      preLoaderRoute: typeof PrivateVbuyerService_quotationsIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/service_quotations/issue_service_purchase_order": {
      id: "/_private/vbuyer/service_quotations/issue_service_purchase_order";
      path: "/vbuyer/service_quotations/issue_service_purchase_order";
      fullPath: "/vbuyer/service_quotations/issue_service_purchase_order";
      preLoaderRoute: typeof PrivateVbuyerService_quotationsIssue_service_purchase_orderRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/valoration_requests/new": {
      id: "/_private/vbuyer/valoration_requests/new";
      path: "/vbuyer/valoration_requests/new";
      fullPath: "/vbuyer/valoration_requests/new";
      preLoaderRoute: typeof PrivateVbuyerValoration_requestsNewRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vsupplierregistration/exclusive_brands/": {
      id: "/_private/vsupplierregistration/exclusive_brands/";
      path: "/vsupplierregistration/exclusive_brands";
      fullPath: "/vsupplierregistration/exclusive_brands/";
      preLoaderRoute: typeof PrivateVsupplierregistrationExclusive_brandsIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vsupplierregistration/terms/": {
      id: "/_private/vsupplierregistration/terms/";
      path: "/vsupplierregistration/terms";
      fullPath: "/vsupplierregistration/terms/";
      preLoaderRoute: typeof PrivateVsupplierregistrationTermsIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vsupplierregistration/terms/new": {
      id: "/_private/vsupplierregistration/terms/new";
      path: "/vsupplierregistration/terms/new";
      fullPath: "/vsupplierregistration/terms/new";
      preLoaderRoute: typeof PrivateVsupplierregistrationTermsNewRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vsupplierregistration/terms_exceptions/": {
      id: "/_private/vsupplierregistration/terms_exceptions/";
      path: "/vsupplierregistration/terms_exceptions";
      fullPath: "/vsupplierregistration/terms_exceptions/";
      preLoaderRoute: typeof PrivateVsupplierregistrationTerms_exceptionsIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vsupplierregistration/terms_exceptions/new": {
      id: "/_private/vsupplierregistration/terms_exceptions/new";
      path: "/vsupplierregistration/terms_exceptions/new";
      fullPath: "/vsupplierregistration/terms_exceptions/new";
      preLoaderRoute: typeof PrivateVsupplierregistrationTerms_exceptionsNewRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vsupplierregistration/vendor/": {
      id: "/_private/vsupplierregistration/vendor/";
      path: "/";
      fullPath: "/vsupplierregistration/vendor/";
      preLoaderRoute: typeof PrivateVsupplierregistrationVendorIndexRouteImport;
      parentRoute: typeof PrivateVsupplierregistrationVendorRouteRoute;
    };
    "/_private/vsupplierregistration/vendor/categories": {
      id: "/_private/vsupplierregistration/vendor/categories";
      path: "/categories";
      fullPath: "/vsupplierregistration/vendor/categories";
      preLoaderRoute: typeof PrivateVsupplierregistrationVendorCategoriesRouteImport;
      parentRoute: typeof PrivateVsupplierregistrationVendorRouteRoute;
    };
    "/_private/vsupplierregistration/vendor/documents": {
      id: "/_private/vsupplierregistration/vendor/documents";
      path: "/documents";
      fullPath: "/vsupplierregistration/vendor/documents";
      preLoaderRoute: typeof PrivateVsupplierregistrationVendorDocumentsRouteImport;
      parentRoute: typeof PrivateVsupplierregistrationVendorRouteRoute;
    };
    "/_private/vsupplierregistration/vendor/edit": {
      id: "/_private/vsupplierregistration/vendor/edit";
      path: "/edit";
      fullPath: "/vsupplierregistration/vendor/edit";
      preLoaderRoute: typeof PrivateVsupplierregistrationVendorEditRouteImport;
      parentRoute: typeof PrivateVsupplierregistrationVendorRouteRoute;
    };
    "/_private/vsupplierregistration/vendor/terms": {
      id: "/_private/vsupplierregistration/vendor/terms";
      path: "/terms";
      fullPath: "/vsupplierregistration/vendor/terms";
      preLoaderRoute: typeof PrivateVsupplierregistrationVendorTermsRouteImport;
      parentRoute: typeof PrivateVsupplierregistrationVendorRouteRoute;
    };
    "/_private/vsupplierregistration/vendor/terms_exceptions": {
      id: "/_private/vsupplierregistration/vendor/terms_exceptions";
      path: "/terms_exceptions";
      fullPath: "/vsupplierregistration/vendor/terms_exceptions";
      preLoaderRoute: typeof PrivateVsupplierregistrationVendorTerms_exceptionsRouteImport;
      parentRoute: typeof PrivateVsupplierregistrationVendorRouteRoute;
    };
    "/_private/vsupplierregistration/vendor/users": {
      id: "/_private/vsupplierregistration/vendor/users";
      path: "/users";
      fullPath: "/vsupplierregistration/vendor/users";
      preLoaderRoute: typeof PrivateVsupplierregistrationVendorUsersRouteImport;
      parentRoute: typeof PrivateVsupplierregistrationVendorRouteRoute;
    };
    "/_private/vsupplierregistration/vendors/": {
      id: "/_private/vsupplierregistration/vendors/";
      path: "/";
      fullPath: "/vsupplierregistration/vendors/";
      preLoaderRoute: typeof PrivateVsupplierregistrationVendorsIndexRouteImport;
      parentRoute: typeof PrivateVsupplierregistrationVendorsRouteRoute;
    };
    "/_private/vsupplierregistration/vendors/$vendorId": {
      id: "/_private/vsupplierregistration/vendors/$vendorId";
      path: "/$vendorId";
      fullPath: "/vsupplierregistration/vendors/$vendorId";
      preLoaderRoute: typeof PrivateVsupplierregistrationVendorsVendorIdRouteRouteImport;
      parentRoute: typeof PrivateVsupplierregistrationVendorsRouteRoute;
    };
    "/_private/vsupplierregistration/vendors/new_by_equinor": {
      id: "/_private/vsupplierregistration/vendors/new_by_equinor";
      path: "/new_by_equinor";
      fullPath: "/vsupplierregistration/vendors/new_by_equinor";
      preLoaderRoute: typeof PrivateVsupplierregistrationVendorsNew_by_equinorRouteImport;
      parentRoute: typeof PrivateVsupplierregistrationVendorsRouteRoute;
    };
    "/_protected/onboarding/vendor/terms": {
      id: "/_protected/onboarding/vendor/terms";
      path: "/onboarding/vendor/terms";
      fullPath: "/onboarding/vendor/terms";
      preLoaderRoute: typeof ProtectedOnboardingVendorTermsRouteImport;
      parentRoute: typeof ProtectedRouteRoute;
    };
    "/_public/_auth/users/sign_in": {
      id: "/_public/_auth/users/sign_in";
      path: "/users/sign_in";
      fullPath: "/users/sign_in";
      preLoaderRoute: typeof PublicAuthUsersSign_inRouteImport;
      parentRoute: typeof PublicAuthRouteRoute;
    };
    "/_public/_auth/users/sign_up": {
      id: "/_public/_auth/users/sign_up";
      path: "/users/sign_up";
      fullPath: "/users/sign_up";
      preLoaderRoute: typeof PublicAuthUsersSign_upRouteImport;
      parentRoute: typeof PublicAuthRouteRoute;
    };
    "/_private/purchase_orders/materials/$purchaseOrderId/": {
      id: "/_private/purchase_orders/materials/$purchaseOrderId/";
      path: "/purchase_orders/materials/$purchaseOrderId";
      fullPath: "/purchase_orders/materials/$purchaseOrderId/";
      preLoaderRoute: typeof PrivatePurchase_ordersMaterialsPurchaseOrderIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/purchase_orders/service_quotations/$purchaseOrderId/": {
      id: "/_private/purchase_orders/service_quotations/$purchaseOrderId/";
      path: "/purchase_orders/service_quotations/$purchaseOrderId";
      fullPath: "/purchase_orders/service_quotations/$purchaseOrderId/";
      preLoaderRoute: typeof PrivatePurchase_ordersService_quotationsPurchaseOrderIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/redirect/rails/home/": {
      id: "/_private/redirect/rails/home/";
      path: "/redirect/rails/home";
      fullPath: "/redirect/rails/home/";
      preLoaderRoute: typeof PrivateRedirectRailsHomeIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId/": {
      id: "/_private/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId/";
      path: "/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId";
      fullPath: "/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId/";
      preLoaderRoute: typeof PrivateVbuyerBill_of_materials_mgmt_requestsBillOfMaterialsMgmtRequestIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId/edit": {
      id: "/_private/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId/edit";
      path: "/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId/edit";
      fullPath: "/vbuyer/bill_of_materials_mgmt_requests/$billOfMaterialsMgmtRequestId/edit";
      preLoaderRoute: typeof PrivateVbuyerBill_of_materials_mgmt_requestsBillOfMaterialsMgmtRequestIdEditRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/change_material_requests/$changeMaterialRequestId/": {
      id: "/_private/vbuyer/change_material_requests/$changeMaterialRequestId/";
      path: "/vbuyer/change_material_requests/$changeMaterialRequestId";
      fullPath: "/vbuyer/change_material_requests/$changeMaterialRequestId/";
      preLoaderRoute: typeof PrivateVbuyerChange_material_requestsChangeMaterialRequestIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/change_material_requests/$changeMaterialRequestId/edit": {
      id: "/_private/vbuyer/change_material_requests/$changeMaterialRequestId/edit";
      path: "/vbuyer/change_material_requests/$changeMaterialRequestId/edit";
      fullPath: "/vbuyer/change_material_requests/$changeMaterialRequestId/edit";
      preLoaderRoute: typeof PrivateVbuyerChange_material_requestsChangeMaterialRequestIdEditRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/create_purchase_order_by_quotations/$createPurchaseOrderByQuotationId/": {
      id: "/_private/vbuyer/create_purchase_order_by_quotations/$createPurchaseOrderByQuotationId/";
      path: "/vbuyer/create_purchase_order_by_quotations/$createPurchaseOrderByQuotationId";
      fullPath: "/vbuyer/create_purchase_order_by_quotations/$createPurchaseOrderByQuotationId/";
      preLoaderRoute: typeof PrivateVbuyerCreate_purchase_order_by_quotationsCreatePurchaseOrderByQuotationIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/create_purchase_order_by_service_quotations/$createPurchaseOrderByServiceQuotationId/": {
      id: "/_private/vbuyer/create_purchase_order_by_service_quotations/$createPurchaseOrderByServiceQuotationId/";
      path: "/vbuyer/create_purchase_order_by_service_quotations/$createPurchaseOrderByServiceQuotationId";
      fullPath: "/vbuyer/create_purchase_order_by_service_quotations/$createPurchaseOrderByServiceQuotationId/";
      preLoaderRoute: typeof PrivateVbuyerCreate_purchase_order_by_service_quotationsCreatePurchaseOrderByServiceQuotationIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/duimp_requests/$duimpRequestId/": {
      id: "/_private/vbuyer/duimp_requests/$duimpRequestId/";
      path: "/vbuyer/duimp_requests/$duimpRequestId";
      fullPath: "/vbuyer/duimp_requests/$duimpRequestId/";
      preLoaderRoute: typeof PrivateVbuyerDuimp_requestsDuimpRequestIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/duimp_requests/$duimpRequestId/edit": {
      id: "/_private/vbuyer/duimp_requests/$duimpRequestId/edit";
      path: "/vbuyer/duimp_requests/$duimpRequestId/edit";
      fullPath: "/vbuyer/duimp_requests/$duimpRequestId/edit";
      preLoaderRoute: typeof PrivateVbuyerDuimp_requestsDuimpRequestIdEditRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/gr_general_issue_raisers/$grGeneralIssueRaiserId/": {
      id: "/_private/vbuyer/gr_general_issue_raisers/$grGeneralIssueRaiserId/";
      path: "/vbuyer/gr_general_issue_raisers/$grGeneralIssueRaiserId";
      fullPath: "/vbuyer/gr_general_issue_raisers/$grGeneralIssueRaiserId/";
      preLoaderRoute: typeof PrivateVbuyerGr_general_issue_raisersGrGeneralIssueRaiserIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId/": {
      id: "/_private/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId/";
      path: "/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId";
      fullPath: "/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId/";
      preLoaderRoute: typeof PrivateVbuyerIssues_of_rfq_requestsIssuesOfRfqRequestIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId/edit": {
      id: "/_private/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId/edit";
      path: "/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId/edit";
      fullPath: "/vbuyer/issues_of_rfq_requests/$issuesOfRfqRequestId/edit";
      preLoaderRoute: typeof PrivateVbuyerIssues_of_rfq_requestsIssuesOfRfqRequestIdEditRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/material_request_forms/$materialRequestFormId/": {
      id: "/_private/vbuyer/material_request_forms/$materialRequestFormId/";
      path: "/vbuyer/material_request_forms/$materialRequestFormId";
      fullPath: "/vbuyer/material_request_forms/$materialRequestFormId/";
      preLoaderRoute: typeof PrivateVbuyerMaterial_request_formsMaterialRequestFormIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId/": {
      id: "/_private/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId/";
      path: "/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId";
      fullPath: "/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId/";
      preLoaderRoute: typeof PrivateVbuyerOther_masterdata_services_requestsOtherMasterdataServicesRequestIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId/edit": {
      id: "/_private/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId/edit";
      path: "/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId/edit";
      fullPath: "/vbuyer/other_masterdata_services_requests/$otherMasterdataServicesRequestId/edit";
      preLoaderRoute: typeof PrivateVbuyerOther_masterdata_services_requestsOtherMasterdataServicesRequestIdEditRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/proposals/$proposalId/": {
      id: "/_private/vbuyer/proposals/$proposalId/";
      path: "/vbuyer/proposals/$proposalId";
      fullPath: "/vbuyer/proposals/$proposalId/";
      preLoaderRoute: typeof PrivateVbuyerProposalsProposalIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/quotation_batches/$quotationBatchId/": {
      id: "/_private/vbuyer/quotation_batches/$quotationBatchId/";
      path: "/";
      fullPath: "/vbuyer/quotation_batches/$quotationBatchId/";
      preLoaderRoute: typeof PrivateVbuyerQuotation_batchesQuotationBatchIdIndexRouteImport;
      parentRoute: typeof PrivateVbuyerQuotation_batchesQuotationBatchIdRouteRoute;
    };
    "/_private/vbuyer/quotation_batches/$quotationBatchId/edit": {
      id: "/_private/vbuyer/quotation_batches/$quotationBatchId/edit";
      path: "/edit";
      fullPath: "/vbuyer/quotation_batches/$quotationBatchId/edit";
      preLoaderRoute: typeof PrivateVbuyerQuotation_batchesQuotationBatchIdEditRouteImport;
      parentRoute: typeof PrivateVbuyerQuotation_batchesQuotationBatchIdRouteRoute;
    };
    "/_private/vbuyer/quotations/$quotationId/": {
      id: "/_private/vbuyer/quotations/$quotationId/";
      path: "/";
      fullPath: "/vbuyer/quotations/$quotationId/";
      preLoaderRoute: typeof PrivateVbuyerQuotationsQuotationIdIndexRouteImport;
      parentRoute: typeof PrivateVbuyerQuotationsQuotationIdRouteRoute;
    };
    "/_private/vbuyer/rnm_requests/$rnmRequestId/": {
      id: "/_private/vbuyer/rnm_requests/$rnmRequestId/";
      path: "/vbuyer/rnm_requests/$rnmRequestId";
      fullPath: "/vbuyer/rnm_requests/$rnmRequestId/";
      preLoaderRoute: typeof PrivateVbuyerRnm_requestsRnmRequestIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/rsps3_requests/$rsps3RequestId/": {
      id: "/_private/vbuyer/rsps3_requests/$rsps3RequestId/";
      path: "/vbuyer/rsps3_requests/$rsps3RequestId";
      fullPath: "/vbuyer/rsps3_requests/$rsps3RequestId/";
      preLoaderRoute: typeof PrivateVbuyerRsps3_requestsRsps3RequestIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/rsps3_requests/$rsps3RequestId/edit": {
      id: "/_private/vbuyer/rsps3_requests/$rsps3RequestId/edit";
      path: "/vbuyer/rsps3_requests/$rsps3RequestId/edit";
      fullPath: "/vbuyer/rsps3_requests/$rsps3RequestId/edit";
      preLoaderRoute: typeof PrivateVbuyerRsps3_requestsRsps3RequestIdEditRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/service_negotiations/$serviceNegotiationId/": {
      id: "/_private/vbuyer/service_negotiations/$serviceNegotiationId/";
      path: "/vbuyer/service_negotiations/$serviceNegotiationId";
      fullPath: "/vbuyer/service_negotiations/$serviceNegotiationId/";
      preLoaderRoute: typeof PrivateVbuyerService_negotiationsServiceNegotiationIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/service_quotation_approvals/$serviceQuotationApprovalId/": {
      id: "/_private/vbuyer/service_quotation_approvals/$serviceQuotationApprovalId/";
      path: "/vbuyer/service_quotation_approvals/$serviceQuotationApprovalId";
      fullPath: "/vbuyer/service_quotation_approvals/$serviceQuotationApprovalId/";
      preLoaderRoute: typeof PrivateVbuyerService_quotation_approvalsServiceQuotationApprovalIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/service_quotations/$serviceQuotationId/": {
      id: "/_private/vbuyer/service_quotations/$serviceQuotationId/";
      path: "/vbuyer/service_quotations/$serviceQuotationId";
      fullPath: "/vbuyer/service_quotations/$serviceQuotationId/";
      preLoaderRoute: typeof PrivateVbuyerService_quotationsServiceQuotationIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/valoration_requests/$valorationRequestId/": {
      id: "/_private/vbuyer/valoration_requests/$valorationRequestId/";
      path: "/vbuyer/valoration_requests/$valorationRequestId";
      fullPath: "/vbuyer/valoration_requests/$valorationRequestId/";
      preLoaderRoute: typeof PrivateVbuyerValoration_requestsValorationRequestIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/valoration_requests/$valorationRequestId/edit": {
      id: "/_private/vbuyer/valoration_requests/$valorationRequestId/edit";
      path: "/vbuyer/valoration_requests/$valorationRequestId/edit";
      fullPath: "/vbuyer/valoration_requests/$valorationRequestId/edit";
      preLoaderRoute: typeof PrivateVbuyerValoration_requestsValorationRequestIdEditRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vsupplierregistration/exclusive_brands/$id/": {
      id: "/_private/vsupplierregistration/exclusive_brands/$id/";
      path: "/vsupplierregistration/exclusive_brands/$id";
      fullPath: "/vsupplierregistration/exclusive_brands/$id/";
      preLoaderRoute: typeof PrivateVsupplierregistrationExclusive_brandsIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vsupplierregistration/terms/$termId/edit": {
      id: "/_private/vsupplierregistration/terms/$termId/edit";
      path: "/vsupplierregistration/terms/$termId/edit";
      fullPath: "/vsupplierregistration/terms/$termId/edit";
      preLoaderRoute: typeof PrivateVsupplierregistrationTermsTermIdEditRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vsupplierregistration/terms_exceptions/$termExceptionId/": {
      id: "/_private/vsupplierregistration/terms_exceptions/$termExceptionId/";
      path: "/vsupplierregistration/terms_exceptions/$termExceptionId";
      fullPath: "/vsupplierregistration/terms_exceptions/$termExceptionId/";
      preLoaderRoute: typeof PrivateVsupplierregistrationTerms_exceptionsTermExceptionIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vsupplierregistration/terms_exceptions/$termExceptionId/edit": {
      id: "/_private/vsupplierregistration/terms_exceptions/$termExceptionId/edit";
      path: "/vsupplierregistration/terms_exceptions/$termExceptionId/edit";
      fullPath: "/vsupplierregistration/terms_exceptions/$termExceptionId/edit";
      preLoaderRoute: typeof PrivateVsupplierregistrationTerms_exceptionsTermExceptionIdEditRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vsupplierregistration/vendors/$vendorId/": {
      id: "/_private/vsupplierregistration/vendors/$vendorId/";
      path: "/";
      fullPath: "/vsupplierregistration/vendors/$vendorId/";
      preLoaderRoute: typeof PrivateVsupplierregistrationVendorsVendorIdIndexRouteImport;
      parentRoute: typeof PrivateVsupplierregistrationVendorsVendorIdRouteRoute;
    };
    "/_private/vsupplierregistration/vendors/$vendorId/categories": {
      id: "/_private/vsupplierregistration/vendors/$vendorId/categories";
      path: "/categories";
      fullPath: "/vsupplierregistration/vendors/$vendorId/categories";
      preLoaderRoute: typeof PrivateVsupplierregistrationVendorsVendorIdCategoriesRouteImport;
      parentRoute: typeof PrivateVsupplierregistrationVendorsVendorIdRouteRoute;
    };
    "/_private/vsupplierregistration/vendors/$vendorId/documents": {
      id: "/_private/vsupplierregistration/vendors/$vendorId/documents";
      path: "/documents";
      fullPath: "/vsupplierregistration/vendors/$vendorId/documents";
      preLoaderRoute: typeof PrivateVsupplierregistrationVendorsVendorIdDocumentsRouteImport;
      parentRoute: typeof PrivateVsupplierregistrationVendorsVendorIdRouteRoute;
    };
    "/_private/vsupplierregistration/vendors/$vendorId/edit": {
      id: "/_private/vsupplierregistration/vendors/$vendorId/edit";
      path: "/edit";
      fullPath: "/vsupplierregistration/vendors/$vendorId/edit";
      preLoaderRoute: typeof PrivateVsupplierregistrationVendorsVendorIdEditRouteImport;
      parentRoute: typeof PrivateVsupplierregistrationVendorsVendorIdRouteRoute;
    };
    "/_private/vsupplierregistration/vendors/$vendorId/terms": {
      id: "/_private/vsupplierregistration/vendors/$vendorId/terms";
      path: "/terms";
      fullPath: "/vsupplierregistration/vendors/$vendorId/terms";
      preLoaderRoute: typeof PrivateVsupplierregistrationVendorsVendorIdTermsRouteImport;
      parentRoute: typeof PrivateVsupplierregistrationVendorsVendorIdRouteRoute;
    };
    "/_private/vsupplierregistration/vendors/$vendorId/terms_exceptions": {
      id: "/_private/vsupplierregistration/vendors/$vendorId/terms_exceptions";
      path: "/terms_exceptions";
      fullPath: "/vsupplierregistration/vendors/$vendorId/terms_exceptions";
      preLoaderRoute: typeof PrivateVsupplierregistrationVendorsVendorIdTerms_exceptionsRouteImport;
      parentRoute: typeof PrivateVsupplierregistrationVendorsVendorIdRouteRoute;
    };
    "/_private/vsupplierregistration/vendors/$vendorId/users": {
      id: "/_private/vsupplierregistration/vendors/$vendorId/users";
      path: "/users";
      fullPath: "/vsupplierregistration/vendors/$vendorId/users";
      preLoaderRoute: typeof PrivateVsupplierregistrationVendorsVendorIdUsersRouteImport;
      parentRoute: typeof PrivateVsupplierregistrationVendorsVendorIdRouteRoute;
    };
    "/_public/_auth/users/confirmation/new": {
      id: "/_public/_auth/users/confirmation/new";
      path: "/users/confirmation/new";
      fullPath: "/users/confirmation/new";
      preLoaderRoute: typeof PublicAuthUsersConfirmationNewRouteImport;
      parentRoute: typeof PublicAuthRouteRoute;
    };
    "/_public/_auth/users/password/new": {
      id: "/_public/_auth/users/password/new";
      path: "/users/password/new";
      fullPath: "/users/password/new";
      preLoaderRoute: typeof PublicAuthUsersPasswordNewRouteImport;
      parentRoute: typeof PublicAuthRouteRoute;
    };
    "/_private/vbuyer/service_negotiations/$serviceNegotiationId/proposals/new": {
      id: "/_private/vbuyer/service_negotiations/$serviceNegotiationId/proposals/new";
      path: "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/new";
      fullPath: "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/new";
      preLoaderRoute: typeof PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsNewRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId/": {
      id: "/_private/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId/";
      path: "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId";
      fullPath: "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId/";
      preLoaderRoute: typeof PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsProposalIdIndexRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
    "/_private/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId/edit": {
      id: "/_private/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId/edit";
      path: "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId/edit";
      fullPath: "/vbuyer/service_negotiations/$serviceNegotiationId/proposals/$proposalId/edit";
      preLoaderRoute: typeof PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsProposalIdEditRouteImport;
      parentRoute: typeof PrivateRouteRoute;
    };
  }
}

interface PrivateVsupplierregistrationVendorRouteRouteChildren {
  PrivateVsupplierregistrationVendorCategoriesRoute: typeof PrivateVsupplierregistrationVendorCategoriesRoute;
  PrivateVsupplierregistrationVendorDocumentsRoute: typeof PrivateVsupplierregistrationVendorDocumentsRoute;
  PrivateVsupplierregistrationVendorEditRoute: typeof PrivateVsupplierregistrationVendorEditRoute;
  PrivateVsupplierregistrationVendorTermsRoute: typeof PrivateVsupplierregistrationVendorTermsRoute;
  PrivateVsupplierregistrationVendorTerms_exceptionsRoute: typeof PrivateVsupplierregistrationVendorTerms_exceptionsRoute;
  PrivateVsupplierregistrationVendorUsersRoute: typeof PrivateVsupplierregistrationVendorUsersRoute;
  PrivateVsupplierregistrationVendorIndexRoute: typeof PrivateVsupplierregistrationVendorIndexRoute;
}

const PrivateVsupplierregistrationVendorRouteRouteChildren: PrivateVsupplierregistrationVendorRouteRouteChildren =
  {
    PrivateVsupplierregistrationVendorCategoriesRoute:
      PrivateVsupplierregistrationVendorCategoriesRoute,
    PrivateVsupplierregistrationVendorDocumentsRoute:
      PrivateVsupplierregistrationVendorDocumentsRoute,
    PrivateVsupplierregistrationVendorEditRoute:
      PrivateVsupplierregistrationVendorEditRoute,
    PrivateVsupplierregistrationVendorTermsRoute:
      PrivateVsupplierregistrationVendorTermsRoute,
    PrivateVsupplierregistrationVendorTerms_exceptionsRoute:
      PrivateVsupplierregistrationVendorTerms_exceptionsRoute,
    PrivateVsupplierregistrationVendorUsersRoute:
      PrivateVsupplierregistrationVendorUsersRoute,
    PrivateVsupplierregistrationVendorIndexRoute:
      PrivateVsupplierregistrationVendorIndexRoute,
  };

const PrivateVsupplierregistrationVendorRouteRouteWithChildren =
  PrivateVsupplierregistrationVendorRouteRoute._addFileChildren(
    PrivateVsupplierregistrationVendorRouteRouteChildren,
  );

interface PrivateVsupplierregistrationVendorsVendorIdRouteRouteChildren {
  PrivateVsupplierregistrationVendorsVendorIdCategoriesRoute: typeof PrivateVsupplierregistrationVendorsVendorIdCategoriesRoute;
  PrivateVsupplierregistrationVendorsVendorIdDocumentsRoute: typeof PrivateVsupplierregistrationVendorsVendorIdDocumentsRoute;
  PrivateVsupplierregistrationVendorsVendorIdEditRoute: typeof PrivateVsupplierregistrationVendorsVendorIdEditRoute;
  PrivateVsupplierregistrationVendorsVendorIdTermsRoute: typeof PrivateVsupplierregistrationVendorsVendorIdTermsRoute;
  PrivateVsupplierregistrationVendorsVendorIdTerms_exceptionsRoute: typeof PrivateVsupplierregistrationVendorsVendorIdTerms_exceptionsRoute;
  PrivateVsupplierregistrationVendorsVendorIdUsersRoute: typeof PrivateVsupplierregistrationVendorsVendorIdUsersRoute;
  PrivateVsupplierregistrationVendorsVendorIdIndexRoute: typeof PrivateVsupplierregistrationVendorsVendorIdIndexRoute;
}

const PrivateVsupplierregistrationVendorsVendorIdRouteRouteChildren: PrivateVsupplierregistrationVendorsVendorIdRouteRouteChildren =
  {
    PrivateVsupplierregistrationVendorsVendorIdCategoriesRoute:
      PrivateVsupplierregistrationVendorsVendorIdCategoriesRoute,
    PrivateVsupplierregistrationVendorsVendorIdDocumentsRoute:
      PrivateVsupplierregistrationVendorsVendorIdDocumentsRoute,
    PrivateVsupplierregistrationVendorsVendorIdEditRoute:
      PrivateVsupplierregistrationVendorsVendorIdEditRoute,
    PrivateVsupplierregistrationVendorsVendorIdTermsRoute:
      PrivateVsupplierregistrationVendorsVendorIdTermsRoute,
    PrivateVsupplierregistrationVendorsVendorIdTerms_exceptionsRoute:
      PrivateVsupplierregistrationVendorsVendorIdTerms_exceptionsRoute,
    PrivateVsupplierregistrationVendorsVendorIdUsersRoute:
      PrivateVsupplierregistrationVendorsVendorIdUsersRoute,
    PrivateVsupplierregistrationVendorsVendorIdIndexRoute:
      PrivateVsupplierregistrationVendorsVendorIdIndexRoute,
  };

const PrivateVsupplierregistrationVendorsVendorIdRouteRouteWithChildren =
  PrivateVsupplierregistrationVendorsVendorIdRouteRoute._addFileChildren(
    PrivateVsupplierregistrationVendorsVendorIdRouteRouteChildren,
  );

interface PrivateVsupplierregistrationVendorsRouteRouteChildren {
  PrivateVsupplierregistrationVendorsVendorIdRouteRoute: typeof PrivateVsupplierregistrationVendorsVendorIdRouteRouteWithChildren;
  PrivateVsupplierregistrationVendorsNew_by_equinorRoute: typeof PrivateVsupplierregistrationVendorsNew_by_equinorRoute;
  PrivateVsupplierregistrationVendorsIndexRoute: typeof PrivateVsupplierregistrationVendorsIndexRoute;
}

const PrivateVsupplierregistrationVendorsRouteRouteChildren: PrivateVsupplierregistrationVendorsRouteRouteChildren =
  {
    PrivateVsupplierregistrationVendorsVendorIdRouteRoute:
      PrivateVsupplierregistrationVendorsVendorIdRouteRouteWithChildren,
    PrivateVsupplierregistrationVendorsNew_by_equinorRoute:
      PrivateVsupplierregistrationVendorsNew_by_equinorRoute,
    PrivateVsupplierregistrationVendorsIndexRoute:
      PrivateVsupplierregistrationVendorsIndexRoute,
  };

const PrivateVsupplierregistrationVendorsRouteRouteWithChildren =
  PrivateVsupplierregistrationVendorsRouteRoute._addFileChildren(
    PrivateVsupplierregistrationVendorsRouteRouteChildren,
  );

interface PrivateVbuyerQuotation_batchesQuotationBatchIdRouteRouteChildren {
  PrivateVbuyerQuotation_batchesQuotationBatchIdEditRoute: typeof PrivateVbuyerQuotation_batchesQuotationBatchIdEditRoute;
  PrivateVbuyerQuotation_batchesQuotationBatchIdIndexRoute: typeof PrivateVbuyerQuotation_batchesQuotationBatchIdIndexRoute;
}

const PrivateVbuyerQuotation_batchesQuotationBatchIdRouteRouteChildren: PrivateVbuyerQuotation_batchesQuotationBatchIdRouteRouteChildren =
  {
    PrivateVbuyerQuotation_batchesQuotationBatchIdEditRoute:
      PrivateVbuyerQuotation_batchesQuotationBatchIdEditRoute,
    PrivateVbuyerQuotation_batchesQuotationBatchIdIndexRoute:
      PrivateVbuyerQuotation_batchesQuotationBatchIdIndexRoute,
  };

const PrivateVbuyerQuotation_batchesQuotationBatchIdRouteRouteWithChildren =
  PrivateVbuyerQuotation_batchesQuotationBatchIdRouteRoute._addFileChildren(
    PrivateVbuyerQuotation_batchesQuotationBatchIdRouteRouteChildren,
  );

interface PrivateVbuyerQuotationsQuotationIdRouteRouteChildren {
  PrivateVbuyerQuotationsQuotationIdIndexRoute: typeof PrivateVbuyerQuotationsQuotationIdIndexRoute;
}

const PrivateVbuyerQuotationsQuotationIdRouteRouteChildren: PrivateVbuyerQuotationsQuotationIdRouteRouteChildren =
  {
    PrivateVbuyerQuotationsQuotationIdIndexRoute:
      PrivateVbuyerQuotationsQuotationIdIndexRoute,
  };

const PrivateVbuyerQuotationsQuotationIdRouteRouteWithChildren =
  PrivateVbuyerQuotationsQuotationIdRouteRoute._addFileChildren(
    PrivateVbuyerQuotationsQuotationIdRouteRouteChildren,
  );

interface PrivateRouteRouteChildren {
  PrivateVsupplierregistrationVendorRouteRoute: typeof PrivateVsupplierregistrationVendorRouteRouteWithChildren;
  PrivateVsupplierregistrationVendorsRouteRoute: typeof PrivateVsupplierregistrationVendorsRouteRouteWithChildren;
  PrivateCall_off_contract_itemsIssue_purchase_orderRoute: typeof PrivateCall_off_contract_itemsIssue_purchase_orderRoute;
  PrivateDelivery_date_change_requestsNewRoute: typeof PrivateDelivery_date_change_requestsNewRoute;
  PrivateDelivery_schedulesNewRoute: typeof PrivateDelivery_schedulesNewRoute;
  PrivateMm_request_assignment_rulesNewRoute: typeof PrivateMm_request_assignment_rulesNewRoute;
  PrivateUsersEditRoute: typeof PrivateUsersEditRoute;
  PrivateCreate_purchase_order_by_call_off_contractsIndexRoute: typeof PrivateCreate_purchase_order_by_call_off_contractsIndexRoute;
  PrivateCreate_purchase_order_by_spotsIndexRoute: typeof PrivateCreate_purchase_order_by_spotsIndexRoute;
  PrivateDelivery_date_change_requestsIndexRoute: typeof PrivateDelivery_date_change_requestsIndexRoute;
  PrivateDelivery_schedulesIndexRoute: typeof PrivateDelivery_schedulesIndexRoute;
  PrivateDevelopersIndexRoute: typeof PrivateDevelopersIndexRoute;
  PrivateMm_request_assignment_rulesIndexRoute: typeof PrivateMm_request_assignment_rulesIndexRoute;
  PrivateMm_request_weekly_goalsIndexRoute: typeof PrivateMm_request_weekly_goalsIndexRoute;
  PrivateNotificationsIndexRoute: typeof PrivateNotificationsIndexRoute;
  PrivateRequest_anticipation_evaluation_quotationsIndexRoute: typeof PrivateRequest_anticipation_evaluation_quotationsIndexRoute;
  PrivateVbuyerQuotation_batchesQuotationBatchIdRouteRoute: typeof PrivateVbuyerQuotation_batchesQuotationBatchIdRouteRouteWithChildren;
  PrivateVbuyerQuotationsQuotationIdRouteRoute: typeof PrivateVbuyerQuotationsQuotationIdRouteRouteWithChildren;
  PrivateCall_off_contract_itemsCallOffItemIdService_linesRoute: typeof PrivateCall_off_contract_itemsCallOffItemIdService_linesRoute;
  PrivateMm_request_assignment_rulesAssignmentRuleIdEditRoute: typeof PrivateMm_request_assignment_rulesAssignmentRuleIdEditRoute;
  PrivateVbuyerBill_of_materials_mgmt_requestsNewRoute: typeof PrivateVbuyerBill_of_materials_mgmt_requestsNewRoute;
  PrivateVbuyerChange_material_requestsNewRoute: typeof PrivateVbuyerChange_material_requestsNewRoute;
  PrivateVbuyerDuimp_requestsNewRoute: typeof PrivateVbuyerDuimp_requestsNewRoute;
  PrivateVbuyerHelpsInvoice_and_payment_proceduresRoute: typeof PrivateVbuyerHelpsInvoice_and_payment_proceduresRoute;
  PrivateVbuyerIssues_of_rfq_requestsNewRoute: typeof PrivateVbuyerIssues_of_rfq_requestsNewRoute;
  PrivateVbuyerMm_requestsCreate_new_requestsRoute: typeof PrivateVbuyerMm_requestsCreate_new_requestsRoute;
  PrivateVbuyerOther_masterdata_services_requestsNewRoute: typeof PrivateVbuyerOther_masterdata_services_requestsNewRoute;
  PrivateVbuyerQuotation_batchesNewRoute: typeof PrivateVbuyerQuotation_batchesNewRoute;
  PrivateVbuyerQuotationsApproval_statsRoute: typeof PrivateVbuyerQuotationsApproval_statsRoute;
  PrivateVbuyerQuotationsIssue_purchase_orderRoute: typeof PrivateVbuyerQuotationsIssue_purchase_orderRoute;
  PrivateVbuyerRnm_requestsNewRoute: typeof PrivateVbuyerRnm_requestsNewRoute;
  PrivateVbuyerRnm_requestsNew_usRoute: typeof PrivateVbuyerRnm_requestsNew_usRoute;
  PrivateVbuyerService_quotationsIssue_service_purchase_orderRoute: typeof PrivateVbuyerService_quotationsIssue_service_purchase_orderRoute;
  PrivateVbuyerValoration_requestsNewRoute: typeof PrivateVbuyerValoration_requestsNewRoute;
  PrivateVsupplierregistrationTermsNewRoute: typeof PrivateVsupplierregistrationTermsNewRoute;
  PrivateVsupplierregistrationTerms_exceptionsNewRoute: typeof PrivateVsupplierregistrationTerms_exceptionsNewRoute;
  PrivateErrorsErrorIndexRoute: typeof PrivateErrorsErrorIndexRoute;
  PrivateErrorsForbiddenIndexRoute: typeof PrivateErrorsForbiddenIndexRoute;
  PrivateErrorsNot_foundIndexRoute: typeof PrivateErrorsNot_foundIndexRoute;
  PrivateCreate_purchase_order_by_call_off_contractsCreatePurchaseOrderByCallOffContractIdIndexRoute: typeof PrivateCreate_purchase_order_by_call_off_contractsCreatePurchaseOrderByCallOffContractIdIndexRoute;
  PrivateCreate_purchase_order_by_spotsCreatePurchaseOrderBySpotIdIndexRoute: typeof PrivateCreate_purchase_order_by_spotsCreatePurchaseOrderBySpotIdIndexRoute;
  PrivateCreate_purchase_order_by_spotsExecutionsIndexRoute: typeof PrivateCreate_purchase_order_by_spotsExecutionsIndexRoute;
  PrivateDelivery_date_change_requestsDeliveryDateChangeRequestIdIndexRoute: typeof PrivateDelivery_date_change_requestsDeliveryDateChangeRequestIdIndexRoute;
  PrivateDelivery_schedulesDeliveryScheduleIdIndexRoute: typeof PrivateDelivery_schedulesDeliveryScheduleIdIndexRoute;
  PrivateInvoice_approvalsInvoiceApprovalIdIndexRoute: typeof PrivateInvoice_approvalsInvoiceApprovalIdIndexRoute;
  PrivateMm_request_assignment_rulesAssignmentRuleIdIndexRoute: typeof PrivateMm_request_assignment_rulesAssignmentRuleIdIndexRoute;
  PrivateMm_request_weekly_goalsUserIdIndexRoute: typeof PrivateMm_request_weekly_goalsUserIdIndexRoute;
  PrivatePurchase_ordersMaterialsIndexRoute: typeof PrivatePurchase_ordersMaterialsIndexRoute;
  PrivatePurchase_ordersService_quotationsIndexRoute: typeof PrivatePurchase_ordersService_quotationsIndexRoute;
  PrivateRequest_anticipation_evaluation_quotationsRequestAnticipationEvaluationQuotationIdIndexRoute: typeof PrivateRequest_anticipation_evaluation_quotationsRequestAnticipationEvaluationQuotationIdIndexRoute;
  PrivateRequest_anticipation_service_quotationsRequestAnticipationServiceQuotationIdIndexRoute: typeof PrivateRequest_anticipation_service_quotationsRequestAnticipationServiceQuotationIdIndexRoute;
  PrivateVbuyerCreate_purchase_order_by_quotationsIndexRoute: typeof PrivateVbuyerCreate_purchase_order_by_quotationsIndexRoute;
  PrivateVbuyerCreate_purchase_order_by_service_quotationsIndexRoute: typeof PrivateVbuyerCreate_purchase_order_by_service_quotationsIndexRoute;
  PrivateVbuyerGr_general_issue_raisersIndexRoute: typeof PrivateVbuyerGr_general_issue_raisersIndexRoute;
  PrivateVbuyerGuidesIndexRoute: typeof PrivateVbuyerGuidesIndexRoute;
  PrivateVbuyerHelpsIndexRoute: typeof PrivateVbuyerHelpsIndexRoute;
  PrivateVbuyerMaterial_request_formsIndexRoute: typeof PrivateVbuyerMaterial_request_formsIndexRoute;
  PrivateVbuyerMm_requestsIndexRoute: typeof PrivateVbuyerMm_requestsIndexRoute;
  PrivateVbuyerQuotation_batchesIndexRoute: typeof PrivateVbuyerQuotation_batchesIndexRoute;
  PrivateVbuyerQuotationsIndexRoute: typeof PrivateVbuyerQuotationsIndexRoute;
  PrivateVbuyerService_negotiationsIndexRoute: typeof PrivateVbuyerService_negotiationsIndexRoute;
  PrivateVbuyerService_quotationsIndexRoute: typeof PrivateVbuyerService_quotationsIndexRoute;
  PrivateVsupplierregistrationExclusive_brandsIndexRoute: typeof PrivateVsupplierregistrationExclusive_brandsIndexRoute;
  PrivateVsupplierregistrationTermsIndexRoute: typeof PrivateVsupplierregistrationTermsIndexRoute;
  PrivateVsupplierregistrationTerms_exceptionsIndexRoute: typeof PrivateVsupplierregistrationTerms_exceptionsIndexRoute;
  PrivateVbuyerBill_of_materials_mgmt_requestsBillOfMaterialsMgmtRequestIdEditRoute: typeof PrivateVbuyerBill_of_materials_mgmt_requestsBillOfMaterialsMgmtRequestIdEditRoute;
  PrivateVbuyerChange_material_requestsChangeMaterialRequestIdEditRoute: typeof PrivateVbuyerChange_material_requestsChangeMaterialRequestIdEditRoute;
  PrivateVbuyerDuimp_requestsDuimpRequestIdEditRoute: typeof PrivateVbuyerDuimp_requestsDuimpRequestIdEditRoute;
  PrivateVbuyerIssues_of_rfq_requestsIssuesOfRfqRequestIdEditRoute: typeof PrivateVbuyerIssues_of_rfq_requestsIssuesOfRfqRequestIdEditRoute;
  PrivateVbuyerOther_masterdata_services_requestsOtherMasterdataServicesRequestIdEditRoute: typeof PrivateVbuyerOther_masterdata_services_requestsOtherMasterdataServicesRequestIdEditRoute;
  PrivateVbuyerRsps3_requestsRsps3RequestIdEditRoute: typeof PrivateVbuyerRsps3_requestsRsps3RequestIdEditRoute;
  PrivateVbuyerValoration_requestsValorationRequestIdEditRoute: typeof PrivateVbuyerValoration_requestsValorationRequestIdEditRoute;
  PrivateVsupplierregistrationTermsTermIdEditRoute: typeof PrivateVsupplierregistrationTermsTermIdEditRoute;
  PrivateVsupplierregistrationTerms_exceptionsTermExceptionIdEditRoute: typeof PrivateVsupplierregistrationTerms_exceptionsTermExceptionIdEditRoute;
  PrivatePurchase_ordersMaterialsPurchaseOrderIdIndexRoute: typeof PrivatePurchase_ordersMaterialsPurchaseOrderIdIndexRoute;
  PrivatePurchase_ordersService_quotationsPurchaseOrderIdIndexRoute: typeof PrivatePurchase_ordersService_quotationsPurchaseOrderIdIndexRoute;
  PrivateRedirectRailsHomeIndexRoute: typeof PrivateRedirectRailsHomeIndexRoute;
  PrivateVbuyerBill_of_materials_mgmt_requestsBillOfMaterialsMgmtRequestIdIndexRoute: typeof PrivateVbuyerBill_of_materials_mgmt_requestsBillOfMaterialsMgmtRequestIdIndexRoute;
  PrivateVbuyerChange_material_requestsChangeMaterialRequestIdIndexRoute: typeof PrivateVbuyerChange_material_requestsChangeMaterialRequestIdIndexRoute;
  PrivateVbuyerCreate_purchase_order_by_quotationsCreatePurchaseOrderByQuotationIdIndexRoute: typeof PrivateVbuyerCreate_purchase_order_by_quotationsCreatePurchaseOrderByQuotationIdIndexRoute;
  PrivateVbuyerCreate_purchase_order_by_service_quotationsCreatePurchaseOrderByServiceQuotationIdIndexRoute: typeof PrivateVbuyerCreate_purchase_order_by_service_quotationsCreatePurchaseOrderByServiceQuotationIdIndexRoute;
  PrivateVbuyerDuimp_requestsDuimpRequestIdIndexRoute: typeof PrivateVbuyerDuimp_requestsDuimpRequestIdIndexRoute;
  PrivateVbuyerGr_general_issue_raisersGrGeneralIssueRaiserIdIndexRoute: typeof PrivateVbuyerGr_general_issue_raisersGrGeneralIssueRaiserIdIndexRoute;
  PrivateVbuyerIssues_of_rfq_requestsIssuesOfRfqRequestIdIndexRoute: typeof PrivateVbuyerIssues_of_rfq_requestsIssuesOfRfqRequestIdIndexRoute;
  PrivateVbuyerMaterial_request_formsMaterialRequestFormIdIndexRoute: typeof PrivateVbuyerMaterial_request_formsMaterialRequestFormIdIndexRoute;
  PrivateVbuyerOther_masterdata_services_requestsOtherMasterdataServicesRequestIdIndexRoute: typeof PrivateVbuyerOther_masterdata_services_requestsOtherMasterdataServicesRequestIdIndexRoute;
  PrivateVbuyerProposalsProposalIdIndexRoute: typeof PrivateVbuyerProposalsProposalIdIndexRoute;
  PrivateVbuyerRnm_requestsRnmRequestIdIndexRoute: typeof PrivateVbuyerRnm_requestsRnmRequestIdIndexRoute;
  PrivateVbuyerRsps3_requestsRsps3RequestIdIndexRoute: typeof PrivateVbuyerRsps3_requestsRsps3RequestIdIndexRoute;
  PrivateVbuyerService_negotiationsServiceNegotiationIdIndexRoute: typeof PrivateVbuyerService_negotiationsServiceNegotiationIdIndexRoute;
  PrivateVbuyerService_quotation_approvalsServiceQuotationApprovalIdIndexRoute: typeof PrivateVbuyerService_quotation_approvalsServiceQuotationApprovalIdIndexRoute;
  PrivateVbuyerService_quotationsServiceQuotationIdIndexRoute: typeof PrivateVbuyerService_quotationsServiceQuotationIdIndexRoute;
  PrivateVbuyerValoration_requestsValorationRequestIdIndexRoute: typeof PrivateVbuyerValoration_requestsValorationRequestIdIndexRoute;
  PrivateVsupplierregistrationExclusive_brandsIdIndexRoute: typeof PrivateVsupplierregistrationExclusive_brandsIdIndexRoute;
  PrivateVsupplierregistrationTerms_exceptionsTermExceptionIdIndexRoute: typeof PrivateVsupplierregistrationTerms_exceptionsTermExceptionIdIndexRoute;
  PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsNewRoute: typeof PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsNewRoute;
  PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsProposalIdEditRoute: typeof PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsProposalIdEditRoute;
  PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsProposalIdIndexRoute: typeof PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsProposalIdIndexRoute;
}

const PrivateRouteRouteChildren: PrivateRouteRouteChildren = {
  PrivateVsupplierregistrationVendorRouteRoute:
    PrivateVsupplierregistrationVendorRouteRouteWithChildren,
  PrivateVsupplierregistrationVendorsRouteRoute:
    PrivateVsupplierregistrationVendorsRouteRouteWithChildren,
  PrivateCall_off_contract_itemsIssue_purchase_orderRoute:
    PrivateCall_off_contract_itemsIssue_purchase_orderRoute,
  PrivateDelivery_date_change_requestsNewRoute:
    PrivateDelivery_date_change_requestsNewRoute,
  PrivateDelivery_schedulesNewRoute: PrivateDelivery_schedulesNewRoute,
  PrivateMm_request_assignment_rulesNewRoute:
    PrivateMm_request_assignment_rulesNewRoute,
  PrivateUsersEditRoute: PrivateUsersEditRoute,
  PrivateCreate_purchase_order_by_call_off_contractsIndexRoute:
    PrivateCreate_purchase_order_by_call_off_contractsIndexRoute,
  PrivateCreate_purchase_order_by_spotsIndexRoute:
    PrivateCreate_purchase_order_by_spotsIndexRoute,
  PrivateDelivery_date_change_requestsIndexRoute:
    PrivateDelivery_date_change_requestsIndexRoute,
  PrivateDelivery_schedulesIndexRoute: PrivateDelivery_schedulesIndexRoute,
  PrivateDevelopersIndexRoute: PrivateDevelopersIndexRoute,
  PrivateMm_request_assignment_rulesIndexRoute:
    PrivateMm_request_assignment_rulesIndexRoute,
  PrivateMm_request_weekly_goalsIndexRoute:
    PrivateMm_request_weekly_goalsIndexRoute,
  PrivateNotificationsIndexRoute: PrivateNotificationsIndexRoute,
  PrivateRequest_anticipation_evaluation_quotationsIndexRoute:
    PrivateRequest_anticipation_evaluation_quotationsIndexRoute,
  PrivateVbuyerQuotation_batchesQuotationBatchIdRouteRoute:
    PrivateVbuyerQuotation_batchesQuotationBatchIdRouteRouteWithChildren,
  PrivateVbuyerQuotationsQuotationIdRouteRoute:
    PrivateVbuyerQuotationsQuotationIdRouteRouteWithChildren,
  PrivateCall_off_contract_itemsCallOffItemIdService_linesRoute:
    PrivateCall_off_contract_itemsCallOffItemIdService_linesRoute,
  PrivateMm_request_assignment_rulesAssignmentRuleIdEditRoute:
    PrivateMm_request_assignment_rulesAssignmentRuleIdEditRoute,
  PrivateVbuyerBill_of_materials_mgmt_requestsNewRoute:
    PrivateVbuyerBill_of_materials_mgmt_requestsNewRoute,
  PrivateVbuyerChange_material_requestsNewRoute:
    PrivateVbuyerChange_material_requestsNewRoute,
  PrivateVbuyerDuimp_requestsNewRoute: PrivateVbuyerDuimp_requestsNewRoute,
  PrivateVbuyerHelpsInvoice_and_payment_proceduresRoute:
    PrivateVbuyerHelpsInvoice_and_payment_proceduresRoute,
  PrivateVbuyerIssues_of_rfq_requestsNewRoute:
    PrivateVbuyerIssues_of_rfq_requestsNewRoute,
  PrivateVbuyerMm_requestsCreate_new_requestsRoute:
    PrivateVbuyerMm_requestsCreate_new_requestsRoute,
  PrivateVbuyerOther_masterdata_services_requestsNewRoute:
    PrivateVbuyerOther_masterdata_services_requestsNewRoute,
  PrivateVbuyerQuotation_batchesNewRoute:
    PrivateVbuyerQuotation_batchesNewRoute,
  PrivateVbuyerQuotationsApproval_statsRoute:
    PrivateVbuyerQuotationsApproval_statsRoute,
  PrivateVbuyerQuotationsIssue_purchase_orderRoute:
    PrivateVbuyerQuotationsIssue_purchase_orderRoute,
  PrivateVbuyerRnm_requestsNewRoute: PrivateVbuyerRnm_requestsNewRoute,
  PrivateVbuyerRnm_requestsNew_usRoute: PrivateVbuyerRnm_requestsNew_usRoute,
  PrivateVbuyerService_quotationsIssue_service_purchase_orderRoute:
    PrivateVbuyerService_quotationsIssue_service_purchase_orderRoute,
  PrivateVbuyerValoration_requestsNewRoute:
    PrivateVbuyerValoration_requestsNewRoute,
  PrivateVsupplierregistrationTermsNewRoute:
    PrivateVsupplierregistrationTermsNewRoute,
  PrivateVsupplierregistrationTerms_exceptionsNewRoute:
    PrivateVsupplierregistrationTerms_exceptionsNewRoute,
  PrivateErrorsErrorIndexRoute: PrivateErrorsErrorIndexRoute,
  PrivateErrorsForbiddenIndexRoute: PrivateErrorsForbiddenIndexRoute,
  PrivateErrorsNot_foundIndexRoute: PrivateErrorsNot_foundIndexRoute,
  PrivateCreate_purchase_order_by_call_off_contractsCreatePurchaseOrderByCallOffContractIdIndexRoute:
    PrivateCreate_purchase_order_by_call_off_contractsCreatePurchaseOrderByCallOffContractIdIndexRoute,
  PrivateCreate_purchase_order_by_spotsCreatePurchaseOrderBySpotIdIndexRoute:
    PrivateCreate_purchase_order_by_spotsCreatePurchaseOrderBySpotIdIndexRoute,
  PrivateCreate_purchase_order_by_spotsExecutionsIndexRoute:
    PrivateCreate_purchase_order_by_spotsExecutionsIndexRoute,
  PrivateDelivery_date_change_requestsDeliveryDateChangeRequestIdIndexRoute:
    PrivateDelivery_date_change_requestsDeliveryDateChangeRequestIdIndexRoute,
  PrivateDelivery_schedulesDeliveryScheduleIdIndexRoute:
    PrivateDelivery_schedulesDeliveryScheduleIdIndexRoute,
  PrivateInvoice_approvalsInvoiceApprovalIdIndexRoute:
    PrivateInvoice_approvalsInvoiceApprovalIdIndexRoute,
  PrivateMm_request_assignment_rulesAssignmentRuleIdIndexRoute:
    PrivateMm_request_assignment_rulesAssignmentRuleIdIndexRoute,
  PrivateMm_request_weekly_goalsUserIdIndexRoute:
    PrivateMm_request_weekly_goalsUserIdIndexRoute,
  PrivatePurchase_ordersMaterialsIndexRoute:
    PrivatePurchase_ordersMaterialsIndexRoute,
  PrivatePurchase_ordersService_quotationsIndexRoute:
    PrivatePurchase_ordersService_quotationsIndexRoute,
  PrivateRequest_anticipation_evaluation_quotationsRequestAnticipationEvaluationQuotationIdIndexRoute:
    PrivateRequest_anticipation_evaluation_quotationsRequestAnticipationEvaluationQuotationIdIndexRoute,
  PrivateRequest_anticipation_service_quotationsRequestAnticipationServiceQuotationIdIndexRoute:
    PrivateRequest_anticipation_service_quotationsRequestAnticipationServiceQuotationIdIndexRoute,
  PrivateVbuyerCreate_purchase_order_by_quotationsIndexRoute:
    PrivateVbuyerCreate_purchase_order_by_quotationsIndexRoute,
  PrivateVbuyerCreate_purchase_order_by_service_quotationsIndexRoute:
    PrivateVbuyerCreate_purchase_order_by_service_quotationsIndexRoute,
  PrivateVbuyerGr_general_issue_raisersIndexRoute:
    PrivateVbuyerGr_general_issue_raisersIndexRoute,
  PrivateVbuyerGuidesIndexRoute: PrivateVbuyerGuidesIndexRoute,
  PrivateVbuyerHelpsIndexRoute: PrivateVbuyerHelpsIndexRoute,
  PrivateVbuyerMaterial_request_formsIndexRoute:
    PrivateVbuyerMaterial_request_formsIndexRoute,
  PrivateVbuyerMm_requestsIndexRoute: PrivateVbuyerMm_requestsIndexRoute,
  PrivateVbuyerQuotation_batchesIndexRoute:
    PrivateVbuyerQuotation_batchesIndexRoute,
  PrivateVbuyerQuotationsIndexRoute: PrivateVbuyerQuotationsIndexRoute,
  PrivateVbuyerService_negotiationsIndexRoute:
    PrivateVbuyerService_negotiationsIndexRoute,
  PrivateVbuyerService_quotationsIndexRoute:
    PrivateVbuyerService_quotationsIndexRoute,
  PrivateVsupplierregistrationExclusive_brandsIndexRoute:
    PrivateVsupplierregistrationExclusive_brandsIndexRoute,
  PrivateVsupplierregistrationTermsIndexRoute:
    PrivateVsupplierregistrationTermsIndexRoute,
  PrivateVsupplierregistrationTerms_exceptionsIndexRoute:
    PrivateVsupplierregistrationTerms_exceptionsIndexRoute,
  PrivateVbuyerBill_of_materials_mgmt_requestsBillOfMaterialsMgmtRequestIdEditRoute:
    PrivateVbuyerBill_of_materials_mgmt_requestsBillOfMaterialsMgmtRequestIdEditRoute,
  PrivateVbuyerChange_material_requestsChangeMaterialRequestIdEditRoute:
    PrivateVbuyerChange_material_requestsChangeMaterialRequestIdEditRoute,
  PrivateVbuyerDuimp_requestsDuimpRequestIdEditRoute:
    PrivateVbuyerDuimp_requestsDuimpRequestIdEditRoute,
  PrivateVbuyerIssues_of_rfq_requestsIssuesOfRfqRequestIdEditRoute:
    PrivateVbuyerIssues_of_rfq_requestsIssuesOfRfqRequestIdEditRoute,
  PrivateVbuyerOther_masterdata_services_requestsOtherMasterdataServicesRequestIdEditRoute:
    PrivateVbuyerOther_masterdata_services_requestsOtherMasterdataServicesRequestIdEditRoute,
  PrivateVbuyerRsps3_requestsRsps3RequestIdEditRoute:
    PrivateVbuyerRsps3_requestsRsps3RequestIdEditRoute,
  PrivateVbuyerValoration_requestsValorationRequestIdEditRoute:
    PrivateVbuyerValoration_requestsValorationRequestIdEditRoute,
  PrivateVsupplierregistrationTermsTermIdEditRoute:
    PrivateVsupplierregistrationTermsTermIdEditRoute,
  PrivateVsupplierregistrationTerms_exceptionsTermExceptionIdEditRoute:
    PrivateVsupplierregistrationTerms_exceptionsTermExceptionIdEditRoute,
  PrivatePurchase_ordersMaterialsPurchaseOrderIdIndexRoute:
    PrivatePurchase_ordersMaterialsPurchaseOrderIdIndexRoute,
  PrivatePurchase_ordersService_quotationsPurchaseOrderIdIndexRoute:
    PrivatePurchase_ordersService_quotationsPurchaseOrderIdIndexRoute,
  PrivateRedirectRailsHomeIndexRoute: PrivateRedirectRailsHomeIndexRoute,
  PrivateVbuyerBill_of_materials_mgmt_requestsBillOfMaterialsMgmtRequestIdIndexRoute:
    PrivateVbuyerBill_of_materials_mgmt_requestsBillOfMaterialsMgmtRequestIdIndexRoute,
  PrivateVbuyerChange_material_requestsChangeMaterialRequestIdIndexRoute:
    PrivateVbuyerChange_material_requestsChangeMaterialRequestIdIndexRoute,
  PrivateVbuyerCreate_purchase_order_by_quotationsCreatePurchaseOrderByQuotationIdIndexRoute:
    PrivateVbuyerCreate_purchase_order_by_quotationsCreatePurchaseOrderByQuotationIdIndexRoute,
  PrivateVbuyerCreate_purchase_order_by_service_quotationsCreatePurchaseOrderByServiceQuotationIdIndexRoute:
    PrivateVbuyerCreate_purchase_order_by_service_quotationsCreatePurchaseOrderByServiceQuotationIdIndexRoute,
  PrivateVbuyerDuimp_requestsDuimpRequestIdIndexRoute:
    PrivateVbuyerDuimp_requestsDuimpRequestIdIndexRoute,
  PrivateVbuyerGr_general_issue_raisersGrGeneralIssueRaiserIdIndexRoute:
    PrivateVbuyerGr_general_issue_raisersGrGeneralIssueRaiserIdIndexRoute,
  PrivateVbuyerIssues_of_rfq_requestsIssuesOfRfqRequestIdIndexRoute:
    PrivateVbuyerIssues_of_rfq_requestsIssuesOfRfqRequestIdIndexRoute,
  PrivateVbuyerMaterial_request_formsMaterialRequestFormIdIndexRoute:
    PrivateVbuyerMaterial_request_formsMaterialRequestFormIdIndexRoute,
  PrivateVbuyerOther_masterdata_services_requestsOtherMasterdataServicesRequestIdIndexRoute:
    PrivateVbuyerOther_masterdata_services_requestsOtherMasterdataServicesRequestIdIndexRoute,
  PrivateVbuyerProposalsProposalIdIndexRoute:
    PrivateVbuyerProposalsProposalIdIndexRoute,
  PrivateVbuyerRnm_requestsRnmRequestIdIndexRoute:
    PrivateVbuyerRnm_requestsRnmRequestIdIndexRoute,
  PrivateVbuyerRsps3_requestsRsps3RequestIdIndexRoute:
    PrivateVbuyerRsps3_requestsRsps3RequestIdIndexRoute,
  PrivateVbuyerService_negotiationsServiceNegotiationIdIndexRoute:
    PrivateVbuyerService_negotiationsServiceNegotiationIdIndexRoute,
  PrivateVbuyerService_quotation_approvalsServiceQuotationApprovalIdIndexRoute:
    PrivateVbuyerService_quotation_approvalsServiceQuotationApprovalIdIndexRoute,
  PrivateVbuyerService_quotationsServiceQuotationIdIndexRoute:
    PrivateVbuyerService_quotationsServiceQuotationIdIndexRoute,
  PrivateVbuyerValoration_requestsValorationRequestIdIndexRoute:
    PrivateVbuyerValoration_requestsValorationRequestIdIndexRoute,
  PrivateVsupplierregistrationExclusive_brandsIdIndexRoute:
    PrivateVsupplierregistrationExclusive_brandsIdIndexRoute,
  PrivateVsupplierregistrationTerms_exceptionsTermExceptionIdIndexRoute:
    PrivateVsupplierregistrationTerms_exceptionsTermExceptionIdIndexRoute,
  PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsNewRoute:
    PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsNewRoute,
  PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsProposalIdEditRoute:
    PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsProposalIdEditRoute,
  PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsProposalIdIndexRoute:
    PrivateVbuyerService_negotiationsServiceNegotiationIdProposalsProposalIdIndexRoute,
};

const PrivateRouteRouteWithChildren = PrivateRouteRoute._addFileChildren(
  PrivateRouteRouteChildren,
);

interface ProtectedRouteRouteChildren {
  ProtectedOnboardingVendorTermsRoute: typeof ProtectedOnboardingVendorTermsRoute;
}

const ProtectedRouteRouteChildren: ProtectedRouteRouteChildren = {
  ProtectedOnboardingVendorTermsRoute: ProtectedOnboardingVendorTermsRoute,
};

const ProtectedRouteRouteWithChildren = ProtectedRouteRoute._addFileChildren(
  ProtectedRouteRouteChildren,
);

interface PublicAuthRouteRouteChildren {
  PublicAuthUsersSign_inRoute: typeof PublicAuthUsersSign_inRoute;
  PublicAuthUsersSign_upRoute: typeof PublicAuthUsersSign_upRoute;
  PublicAuthUsersConfirmationNewRoute: typeof PublicAuthUsersConfirmationNewRoute;
  PublicAuthUsersPasswordNewRoute: typeof PublicAuthUsersPasswordNewRoute;
}

const PublicAuthRouteRouteChildren: PublicAuthRouteRouteChildren = {
  PublicAuthUsersSign_inRoute: PublicAuthUsersSign_inRoute,
  PublicAuthUsersSign_upRoute: PublicAuthUsersSign_upRoute,
  PublicAuthUsersConfirmationNewRoute: PublicAuthUsersConfirmationNewRoute,
  PublicAuthUsersPasswordNewRoute: PublicAuthUsersPasswordNewRoute,
};

const PublicAuthRouteRouteWithChildren = PublicAuthRouteRoute._addFileChildren(
  PublicAuthRouteRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  PrivateRouteRoute: PrivateRouteRouteWithChildren,
  ProtectedRouteRoute: ProtectedRouteRouteWithChildren,
  PublicAuthRouteRoute: PublicAuthRouteRouteWithChildren,
  PublicDomain_transitionRoute: PublicDomain_transitionRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
